msgid ""
msgstr ""
"POT-Creation-Date: 2024-04-25 11:35+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: app/routes/_app+/licensing+/components/License.tsx:83
msgid "\"All rights reserved\" is the most restrictive type of license. It allows Winamp visitors to stream your work for personal listening, but does not allow them to download, distribute, display, perform or modify it for any use."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:293
msgid "(BMI, ASCAP, SACEM, SABAM, SEGA, etc.)"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:164
msgid "(VAT may be applied)"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:395
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:446
msgid "{0, plural, one {{1} error} other {{2} errors}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:187
msgid "{0, plural, one {{1}} other {{2}}}"
msgstr ""

#: app/routes/onboarding+/subscription+/index.tsx:249
msgid "{0, plural, one {# artist} other {# artists}}"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseCandidatesSelection.tsx:80
msgid "{0, plural, one {# audio} other {# audios}}"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:82
msgid "{0, plural, one {# post} other {# posts}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:192
msgid "{0, plural, one {An audio cannot be deleted because it's currently in use in some or all services. Please take it down from the services first to delete it.} other {# selected audios cannot be deleted because they're currently in use in some or all services. Please take them down from the services first to delete them.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:244
msgid "{0, plural, one {An audio cannot be edited because it's currently in use in some or all services.} other {# selected audios cannot be edited because they're currently in use in some or all services.}}"
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:163
msgid "{0, plural, one {An error occurred when trying to monetize the track.} other {An error occurred when trying to monetize the tracks.}}"
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:215
msgid "{0, plural, one {Collection deleted!} other {# collection deleted!}}"
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:336
msgid "{0, plural, one {Collection pushed!} other {# collections pushed!}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:162
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:175
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:253
msgid "{0, plural, one {Delete 1 audio} other {Delete # audios}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:153
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:166
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:248
msgid "{0, plural, one {Delete 1 collection} other {Delete # collections}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:178
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:191
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:236
msgid "{0, plural, one {Download 1 audio} other {Download # audios}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:211
#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:224
#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:374
msgid "{0, plural, one {Edit 1 audio} other {Edit # audios}}"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:283
msgid "{0, plural, one {Invite teammate} other {Invite teammates}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:186
msgid "{0, plural, one {Media deleted!} other {# media deleted!}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:622
msgid "{0, plural, one {Media pushed!} other {# media pushed!}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:399
msgid "{0, plural, one {Media updated!} other {# media updated!}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:179
msgid "{0, plural, one {Please note that once deleted, it cannot be recovered.} other {Please note that once deleted, they cannot be recovered.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:262
msgid "{0, plural, one {Push 1 audio to Collectible} other {Push # audios to Collectible}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:277
msgid "{0, plural, one {Push 1 audio to Copyrights} other {Push # audios to Copyrights}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:217
msgid "{0, plural, one {Push 1 audio to Distribution} other {Push # audios to Distribution}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:232
msgid "{0, plural, one {Push 1 audio to Fanzone} other {Push # audios to Fanzone}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:247
msgid "{0, plural, one {Push 1 audio to Licensing} other {Push # audios to Licensing}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:202
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:304
msgid "{0, plural, one {Push 1 audio} other {Push # audios}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:215
msgid "{0, plural, one {Push 1 collection to Distribution} other {Push # collections to Distribution}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:230
msgid "{0, plural, one {Push 1 collection to Fanzone} other {Push # collections to Fanzone}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:200
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:253
msgid "{0, plural, one {Push 1 collection} other {Push # collections}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:266
msgid "{0, plural, one {Push this audio to Collectible} other {Push # audios to Collectible}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:281
msgid "{0, plural, one {Push this audio to Copyrights} other {Push # audios to Copyrights}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:221
msgid "{0, plural, one {Push this audio to Distribution} other {Push # audios to Distribution}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:236
msgid "{0, plural, one {Push this audio to Fanzone} other {Push # audios to Fanzone}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:251
msgid "{0, plural, one {Push this audio to Licensing} other {Push # audios to Licensing}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:206
msgid "{0, plural, one {Push this audio} other {Push # audios}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:219
msgid "{0, plural, one {Push this collection to Distribution} other {Push # collections to Distribution}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:234
msgid "{0, plural, one {Push this collection to Fanzone} other {Push # collections to Fanzone}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:204
msgid "{0, plural, one {Push this collection} other {Push # collections}}"
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:64
msgid "{0, plural, one {Selection added to the collection.} other {Selection added to the collections.}}"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/success/index.tsx:34
msgid "{0, plural, one {The invite has been sent} other {The invites have been sent}}"
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:219
msgid "{0, plural, one {The selected collection has been deleted with success.} other {The # selected collection have been deleted with success.}}"
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:340
msgid "{0, plural, one {The selected collection has been pushed with success.} other {The # selected collections have been pushed with success.}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:190
msgid "{0, plural, one {The selected media has been deleted with success.} other {The # selected media have been deleted with success.}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:626
msgid "{0, plural, one {The selected media has been pushed with success.} other {The # selected media have been pushed with success.}}"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:403
msgid "{0, plural, one {The selected media has been updated with success.} other {The # selected media have been updated with success.}}"
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:68
msgid "{0, plural, one {The selected track has been added to the collection with success.} other {The selected tracks have been added to the collections with success.}}"
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:94
msgid "{0, plural, one {The track could not be monetized due to invalid data.} other {The tracks could not be monetized due to invalid data.}}"
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:79
msgid "{0, plural, one {The track has been added to the collection with success.} other {The track has been added to the collections with success.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:270
msgid "{0, plural, one {This audio cannot be pushed to Collectible because it's already in use.} other {# selected audios cannot be pushed to Collectible because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:285
msgid "{0, plural, one {This audio cannot be pushed to Copyrights because it's already in use.} other {# selected audios cannot be pushed to Copyrights because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:225
msgid "{0, plural, one {This audio cannot be pushed to Distribution because it's already in use.} other {# selected audios cannot be pushed to Distribution because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:240
msgid "{0, plural, one {This audio cannot be pushed to Fanzone because it's already in use.} other {# selected audios cannot be pushed to Fanzone because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:255
msgid "{0, plural, one {This audio cannot be pushed to Licensing because it's already in use.} other {# selected audios cannot be pushed to Licensing because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:210
msgid "{0, plural, one {This audio cannot be pushed to this service because it's already in use.} other {# selected audios cannot be pushed to the service because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:176
msgid "{0, plural, one {This audio cannot be pushed to Youtube Content ID because it's already in use.} other {# selected audios cannot be pushed to Youtube Content ID because they are already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:188
msgid "{0, plural, one {This collection cannot be deleted because it's currently in use in some or all services. Please take it down from the services first to delete it.} other {# selected collections cannot be deleted because they're currently in use in some or all services. Please take them down from the services first to delete them.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:223
msgid "{0, plural, one {This collection cannot be pushed to Distribution because it's already in use.} other {# selected collections cannot be pushed to Distribution because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:238
msgid "{0, plural, one {This collection cannot be pushed to Fanzone because it's already in use.} other {# selected collections cannot be pushed to Fanzone because they're already in use.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:208
msgid "{0, plural, one {This collection cannot be pushed to this service because it's already in use.} other {# selected collections cannot be pushed to the service because they're already in use.}}"
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:75
msgid "{0, plural, one {Track added to the collection.} other {Track added to the collections.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:534
msgid "{0, plural, one {View 1 reply} other {View # replies}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:182
msgid "{0, plural, one {You're about to remove 1 selected audio from your library. Please note that once deleted, it cannot be recovered.} other {You're about to remove # selected audios from your library. Please note that once deleted, they cannot be recovered.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:173
msgid "{0, plural, one {You're about to remove 1 selected collection from your library.} other {You're about to remove # selected collections from your library.}}"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/success/index.tsx:41
msgid "{0, plural, one {Your teammate is on its way.} other {Your teammates are on their way.}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:276
msgid "{0, plural, zero {No comments} one {1 comment} other {# comments}}"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:256
msgid "{0, plural, zero {No tracks} one {1 track} other {# tracks}}"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:239
msgid "{0, selectordinal, one {first} two {second} few {third} other {#th}}"
msgstr ""

#: app/routes/_app+/distribution+/$id+/index.tsx:181
#: app/routes/_app+/distribution+/components/ReleaseCandidatesSelection.tsx:79
msgid "{0}"
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:99
msgid "{0} ({1})"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:166
#: app/routes/account+/finance+/revenue-share+/components/ArtistsField.tsx:79
msgid "{0} artists"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:250
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:199
msgid "{0} collaborators"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/retention.tsx:84
msgid "{0} days"
msgstr ""

#: app/routes/_app+/distribution+/init.tsx:161
msgid "{0} items"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:235
msgid "{0} of {1}<0> items selected</0>"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/countries.tsx:233
#: app/routes/resources+/app+/widgets+/statistics+/streams+/dsps.tsx:131
msgid "{0} streams"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:123
msgid "{0} tracks"
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:174
msgid "{0} Tracks monetized!"
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:383
msgid "{0} tracks to monetize"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:609
msgid "{0}, based on your location"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:224
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:270
msgid "{amount} on {dpsName}"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/ContentIdForm.tsx:68
msgid "{audiosCount, plural, one {I hereby certify that this track does not contain any public domain recordings or songs, nor does it include sounds from video games, television, movies, or other media. Additionally, this single does not feature any audio from other YouTube videos. I have not used any third-party services, such as TuneCore or CD Baby, to submit this single to YouTube Content ID, nor have I taken any actions that could cause a conflict of interest.} other {I hereby certify that these tracks do not contain any public domain recordings or songs, nor do they include sounds from video games, television, movies, or other media. Additionally, these singles do not feature any audio from other YouTube videos. I have not used any third-party services, such as TuneCore or CD Baby, to submit these singles to YouTube Content ID, nor have I taken any actions that could cause a conflict of interest.}}"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/route.tsx:60
msgid "{audioTitle} - Winamp for Creators"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/route.tsx:32
msgid "{collectionName} - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:542
msgid "{formattedDay} at {formattedTime}"
msgstr ""

#: app/modules/format/date.ts:87
msgid "{hours, plural, one {1 hour} other {# hours}}"
msgstr ""

#: app/modules/format/date.ts:123
msgid "{hours, plural, one {around an hour} other {around # hours}}"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/components/FeedCard/FeedCardFooter.tsx:299
msgid "{likes, plural, one {1 like} other {# likes}}"
msgstr ""

#: app/modules/format/date.ts:80
msgid "{minutes, plural, one {1 minute} other {# minutes}}"
msgstr ""

#: app/modules/format/date.ts:116
msgid "{minutes, plural, one {around a minute} other {around # minutes}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:519
msgid "{selectionCount, plural, one {Archive the selected audio} other {Archive # audios}}"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:374
msgid "{selectionCount, plural, one {Archive the selected collection} other {Archive # collections}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:514
msgid "{selectionCount, plural, one {Archive the selected media} other {Archive # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:505
msgid "{selectionCount, plural, one {Delete the selected audio} other {Delete # audios}}"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:360
msgid "{selectionCount, plural, one {Delete the selected collection} other {Delete # collections}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:500
msgid "{selectionCount, plural, one {Delete the selected media} other {Delete # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:556
msgid "{selectionCount, plural, one {Download the selected audio} other {Download # audios}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:551
msgid "{selectionCount, plural, one {Download the selected media} other {Download # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:603
msgid "{selectionCount, plural, one {Edit the selected audio} other {Edit # audios}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:600
msgid "{selectionCount, plural, one {Edit the selected media} other {Edit # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:580
msgid "{selectionCount, plural, one {Organize the selected audio} other {Organize # audios}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:577
msgid "{selectionCount, plural, one {Organize the selected media} other {Organize # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:533
msgid "{selectionCount, plural, one {Take down the selected audio} other {Take down # audio}}"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:388
msgid "{selectionCount, plural, one {Take down the selected collection} other {Take down # collection}}"
msgstr ""

#: app/routes/_app+/media+/index.tsx:528
msgid "{selectionCount, plural, one {Take down the selected media} other {Take down # media}}"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:480
msgid "{selectionCount} of {0}<0> audios selected</0>"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:335
msgid "{selectionCount} of {0}<0> collections selected</0>"
msgstr ""

#: app/routes/_app+/media+/index.tsx:475
msgid "{selectionCount} of {0}<0> media selected</0>"
msgstr ""

#: app/components/layout/ListingLayout.tsx:22
#: app/components/layout/PageLayout.tsx:34
msgid "{subtitle}"
msgstr ""

#: app/components/layout/ListingLayout.tsx:19
#: app/components/layout/PageLayout.tsx:26
msgid "{title}"
msgstr ""

#: app/modules/format/date.ts:72
msgid "{totalSeconds, plural, one {1 second} other {# seconds}}"
msgstr ""

#: app/routes/onboarding+/index.tsx:65
msgid "* You can create your label later."
msgstr ""

#: app/components/RevShareAmount.tsx:14
msgid "/m"
msgstr ""

#: app/components/RevShareAmount.tsx:16
msgid "/q"
msgstr ""

#: app/components/RevShareAmount.tsx:12
msgid "/w"
msgstr ""

#: app/components/RevShareAmount.tsx:18
msgid "/y"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:199
msgid "+00"
msgstr ""

#: app/routes/account+/index.tsx:89
#: app/routes/account+/messages+/index.tsx:26
msgid "<0>Hello {0}</0>, <1>{1}</1>"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:159
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:212
#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:188
msgid "0.00"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:330
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:319
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:233
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:242
msgid "000000012146438X"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:175
msgid "20% saved"
msgstr ""

#: app/components/ImageUpload.tsx:184
msgid "3000 x 3000 px in PNG, JPG or TIFF"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:64
msgid "A collaborator is required"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:64
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:147
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:147
msgid "A collaborator is required."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:33
#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:34
msgid "A collectible type is required."
msgstr ""

#: app/routes/_app+/media+/components/CollectionsPlaceholder.tsx:30
msgid "A collection is a bundle of different elements that you can use in different services."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:320
msgid "A draft for this collection already exists."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:376
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:216
msgid "A draft for this track already exists."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/create.tsx:17
#: app/routes/_app+/fanzone+/audios+/create.tsx:18
#: app/routes/_app+/fanzone+/collections+/create.tsx:17
#: app/routes/_app+/fanzone+/collections+/create.tsx:18
msgid "A membership is required."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:27
#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:28
msgid "A number of supply is required."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:21
#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:22
msgid "A price is required."
msgstr ""

#: app/routes/subscription.tsx:47
#: app/routes/subscription.tsx:48
#: app/routes/subscription.tsx:48
msgid "A product is required."
msgstr ""

#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:15
#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:16
msgid "A re-release is required."
msgstr ""

#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:30
#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:31
msgid "A release date is required."
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:215
msgid "A short text on your creator profile and this track will help your fans learn about your music, your influences and this collectible in particular."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:374
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:352
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:409
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:474
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:338
msgid "A short text that describe the artist."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:151
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:241
msgid "A short text that describe your label."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:145
msgid "A short text that describes the artist here could be super great"
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:305
msgid "A short text that describes your label."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:855
msgid "A short text to give context to the links page."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:105
msgid "A token is a digital asset that represents value, ownership, or access to something, and it exists on a blockchain."
msgstr ""

#: app/routes/_app+/rights+/form/use-import-track-url-form.ts:12
msgid "A valid URL is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:48
msgid "A video ID is required for TikTok replies."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:362
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:340
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:398
msgid "About <0>(optional)</0>"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/AboutCard.tsx:35
msgid "About the artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:407
msgid "Accept"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:237
msgid "Accept licensing conditions"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:208
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:177
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:333
msgid "Accept terms & conditions"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:338
msgid "Accept Terms & create a post"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:135
msgid "Accept Terms & Create Premium Access"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:270
#: app/routes/_app+/youtube-content-id+/new.tsx:294
msgid "Accept Terms & monetize"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:143
msgid "Accept Terms & monetize tracks"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:255
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:349
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:460
msgid "Accept Terms & submit"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:232
msgid "Accept YT Content ID conditions"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:101
msgid "Access revoked!"
msgstr ""

#: app/routes/account+/index.tsx:338
msgid "Access statistics and reports for each service to understand who listens to your music and how, and which channels generate the most revenue for you."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:99
msgid "Access your data, services, and devices"
msgstr ""

#: app/components/KycGdprDialog.tsx:78
msgid "Access your personal data"
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:52
msgid "Account"
msgstr ""

#: app/components/CommandMenu.tsx:156
msgid "Account > Admin > Artists"
msgstr ""

#: app/components/CommandMenu.tsx:161
msgid "Account > Admin > Collaborators"
msgstr ""

#: app/components/CommandMenu.tsx:151
msgid "Account > Admin > Labels"
msgstr ""

#: app/components/CommandMenu.tsx:176
msgid "Account > Finance > Llamacoin"
msgstr ""

#: app/components/CommandMenu.tsx:181
msgid "Account > Finance > Plans & Billing"
msgstr ""

#: app/components/CommandMenu.tsx:171
msgid "Account > Finance > Revenue Share"
msgstr ""

#: app/components/CommandMenu.tsx:166
msgid "Account > Finance > Wallet"
msgstr ""

#: app/components/CommandMenu.tsx:212
msgid "Account > Legal > Privacy notice"
msgstr ""

#: app/components/CommandMenu.tsx:206
msgid "Account > Legal > Terms & conditions"
msgstr ""

#: app/components/CommandMenu.tsx:191
msgid "Account > My Account > Global preferences"
msgstr ""

#: app/components/CommandMenu.tsx:201
msgid "Account > My account > Legal documents"
msgstr ""

#: app/components/CommandMenu.tsx:196
msgid "Account > My Account > Login & security"
msgstr ""

#: app/components/CommandMenu.tsx:186
msgid "Account > My Account > Personal info"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:68
#: app/routes/account+/finance+/wallet+/index.tsx:99
msgid "Account balance"
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:75
msgid "Account deletion could take up to 90 days. After that we proceed with all the take downs. This action can not be undone."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:107
msgid "Account documentation"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:118
msgid "Account set up"
msgstr ""

#: app/components/UserMenu.tsx:63
msgid "Account Settings"
msgstr ""

#: app/components/KycBadge.tsx:72
msgid "Account unverified"
msgstr ""

#: app/components/KycBadge.tsx:61
msgid "Account verification declined"
msgstr ""

#: app/components/KycBadge.tsx:51
msgid "Account verification pending"
msgstr ""

#: app/components/UserMenu.tsx:89
msgid "Account workspace"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/copyright+/total.tsx:112
#: app/routes/resources+/app+/widgets+/reporting+/distribution+/total.tsx:112
#: app/routes/resources+/app+/widgets+/reporting+/fanzone+/total.tsx:114
#: app/routes/resources+/app+/widgets+/reporting+/licensing+/total.tsx:112
#: app/routes/resources+/app+/widgets+/reporting+/summary+/total.tsx:106
msgid "Accumulated revenue"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:99
msgid "Acknowledge roles contributing to track production as producer, mastering engineer, mixing engineer etc."
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:387
#: app/routes/_app+/media+/collections+/index.tsx:261
#: app/routes/_app+/media+/index.tsx:382
msgid "Actions"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/route.tsx:115
msgid "Activate & publish to the Fanzone"
msgstr ""

#: app/components/ServiceLinkButton.tsx:73
#: app/components/ServiceSubmitButton.tsx:131
msgid "Activate & submit"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:13
msgid "Activation email sent"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:215
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:259
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:129
msgid "Activation of Service"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:140
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:144
msgid "Activation of the Collectibles Service"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:112
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:116
msgid "Activation of the Content ID Service"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:126
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:130
msgid "Activation of the Distribution Service"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:68
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:72
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:84
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:88
msgid "Activation of the Fanzone Service"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:98
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:102
msgid "Activation of the Licensing Service"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:19
msgid "Active"
msgstr ""

#: app/routes/_app+/index/components/AddWidgetDialog.tsx:131
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:532
msgid "Add"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:380
msgid "Add / Remove Links"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:199
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:433
msgid "Add a contributor"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContextSwitch/index.tsx:160
#: app/routes/account+/admin+/labels+/index.tsx:99
msgid "Add a label"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:260
msgid "Add a new artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:597
msgid "Add a new comment"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:498
msgid "Add a new contact"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:255
msgid "Add a new contributor"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:244
msgid "Add a new producer/engineer"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/index.tsx:107
msgid "Add a new rule"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:257
msgid "Add a new songwriter"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:192
msgid "Add an artist"
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:118
msgid "Add an artist profile"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:226
#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:179
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:231
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:391
msgid "Add an optional description."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:261
msgid "Add another collaborator"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:281
#: app/components/SelectArtistPlaceholder.tsx:93
#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:191
#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:201
#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:430
#: app/routes/account+/admin+/artists+/index.tsx:69
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:530
#: app/routes/account+/index.tsx:106
#: app/routes/account+/index.tsx:120
msgid "Add artist"
msgstr ""

#: app/routes/account+/index.tsx:109
msgid "Add artists and start to manage their careers from A to Z."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:348
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:345
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:436
msgid "Add at least 1 social media URL, to display all your existing creations through Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:215
msgid "Add audio"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:178
msgid "Add audios to a membership library"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:295
msgid "Add audios to the collection"
msgstr ""

#: app/routes/account+/admin+/collaborators+/index.tsx:71
#: app/routes/account+/index.tsx:152
msgid "Add collaborators"
msgstr ""

#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:184
msgid "Add collection"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:183
msgid "Add collections to a membership library"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:181
msgid "Add contributors"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:86
msgid "Add distribution links"
msgstr ""

#: app/routes/account+/admin+/labels+/index.tsx:73
msgid "Add label"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1047
msgid "Add links"
msgstr ""

#: app/routes/account+/admin+/artists+/components/ArtistsActions.tsx:47
msgid "Add media"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:199
msgid "Add more tracks"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:248
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:532
msgid "Add musician"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:117
#: app/routes/_app+/licensing+/components/Listing.tsx:111
#: app/routes/_app+/rights+/components/Listing.tsx:107
msgid "Add new tracks"
msgstr ""

#: app/routes/_app+/index/components/AddWidgetDialog.tsx:80
msgid "Add or remove the widgets you want to display on your overview section"
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:109
#: app/routes/account+/producers+/DialogNewProducer.tsx:177
msgid "Add producer"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:173
msgid "Add selection to a collection"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:155
msgid "Add social links"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:135
msgid "Add social links to help fans discover the artist on their favorite platforms."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:248
msgid "Add songwriter"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:349
msgid "Add the artists later"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:359
msgid "Add this artist to Winamp"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:349
#: app/routes/_app+/media_+/audios+/$id+/route.tsx:145
msgid "Add to collection"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:110
msgid "Add tracks"
msgstr ""

#: app/routes/_app+/index/route.tsx:232
msgid "Add widget"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:276
msgid "Add your {artistOrdinal} artist"
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:246
msgid "Add your artist profile"
msgstr ""

#: app/routes/account+/index.tsx:155
msgid "Add your team or bandmates to help manage your artists."
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:253
#: app/routes/_app+/media+/audios+/index.tsx:379
#: app/routes/_app+/media+/collections+/index.tsx:200
#: app/routes/_app+/media+/collections+/index.tsx:256
#: app/routes/_app+/media+/index.tsx:247
#: app/routes/_app+/media+/index.tsx:374
msgid "Added"
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:64
msgid "Adjust your preferences"
msgstr ""

#: app/routes/account.tsx:190
msgid "Admin"
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:104
#: app/routes/account+/admin+/labels+/index.tsx:82
msgid "Admin Illustration"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:313
msgid "Affiliate & submit"
msgstr ""

#: app/components/CopyrightCheck.tsx:76
msgid "After review, your track was marked as Copyright Check because it seems to already exist. Please, contact support for more information."
msgstr ""

#: app/routes/_app+/rights+/components/Listing.tsx:165
#: app/routes/_app+/rights+/components/Listing.tsx:188
msgid "Album"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:241
msgid "Album track pricing"
msgstr ""

#: app/routes/_app+/media+/route.tsx:172
#: app/routes/_app+/tools+/reporting+/route.tsx:54
msgid "All"
msgstr ""

#: app/routes/_app+/index/components/Filters.tsx:84
#: app/routes/_app+/tools+/reporting+/components/GlobalFilters.tsx:87
#: app/routes/_app+/tools+/statistics+/components/Filters.tsx:87
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:159
#: app/routes/account+/finance+/revenue-share+/components/ArtistsField.tsx:40
#: app/routes/account+/finance+/revenue-share+/components/ArtistsField.tsx:75
#: app/routes/account+/finance+/revenue-share+/index.tsx:218
msgid "All artists"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:235
msgid "All artists of the label"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:190
msgid "All countries"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:199
msgid "All media were downloaded."
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:199
msgid "All Platforms"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:80
msgid "All rights reserved"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:248
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:423
msgid "All services"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:226
#: app/routes/account+/finance+/revenue-share+/index.tsx:268
msgid "All Services"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:146
msgid "All this artist's data and files will be permanently removed from our databases."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/index.tsx:91
msgid "All this audio's data and files will be removed from our databases. This action is irreversible."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:160
msgid "All this post's data and files will be removed from our databases. This action is irreversible."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:83
#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:119
msgid "All tracks"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:156
msgid "All tracks are eligible for licensing as long as they are well-produced. Are your tracks registered with a PRO? Don't worry; you can still do licensing: either you're affiliated with a flexible PRO like BMI or ASCAP, and that's no problem, or your PRO is less flexible, and in that case, you'll have to inform the customer that he'll have to pay an additional fee."
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:72
msgid "All your data will be deleted."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:261
msgid "All your links in one place"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:72
msgid "All your released collections"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:158
msgid "Already have a distributor?"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:286
msgid "Already registered to a Collective Management Organization (CMO) to collect copyright royalties on the streaming platforms?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:304
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:354
msgid "Also publish on"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:236
msgid "Amount"
msgstr ""

#: app/routes/subscription.tsx:39
#: app/routes/subscription.tsx:44
msgid "An artist is required."
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:164
msgid "An audio ID is required to initialize the collectible."
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:168
msgid "An audio ID is required to initialize the licensing."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:29
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:30
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:55
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:29
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:30
msgid "An email address is required."
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:249
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:69
#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:87
#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:108
#: app/routes/resources+/app+/audios+/$id+/update-title.ts:64
#: app/routes/resources+/app+/tools+/marketing.social-medias.unlink.ts:59
msgid "An error occured"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:613
msgid "An error occured when trying to push these audios to the service."
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:327
msgid "An error occured when trying to push these collections to the service."
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:72
msgid "An error occured while processing the label. Please check the form and try again."
msgstr ""

#: app/routes/resources+/app+/widgets+/components/WidgetErrorBoundary.tsx:47
msgid "An error occurred while fetching the data."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:128
msgid "An invitation has been sent to the collaborator to join this artist."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:128
msgid "An invitation has been sent to the collaborator to join this label."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:345
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:321
msgid "An invitation will be sent"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:425
msgid "An ISRC (International Standard Recording Code) is a unique 12-character code that identifies a specific music recording or music video, mainly for royalty tracking and licensing. You can usually find it through the music distributor, record label, or metadata in digital music files or streaming platforms."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:170
msgid "An NFT (Non-Fungible Token) is a distinct record in a blockchain database characterized by attributes such as timestamp, owner, name, and description. It represents a digital asset while certifying its ownership and authenticity. As the creator of an NFT, you have perpetual rights to the work, which means you earn money on the first sale and all future sales."
msgstr ""

#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:51
#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:52
#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:55
#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:56
msgid "An option price is required."
msgstr ""

#: app/components/ErrorBoundary.tsx:169
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:278
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:332
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:279
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:328
#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:71
#: app/routes/_app+/fanzone+/memberships+/create.tsx:83
#: app/routes/_app+/fanzone+/profile+/edit.tsx:89
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:116
#: app/routes/_app+/media+/collections+/new.tsx:70
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:140
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:187
#: app/routes/account+/admin+/artists+/$artistId+/distribution-links.ts:79
#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:110
#: app/routes/account+/admin+/artists+/$artistId+/social-links.ts:76
#: app/routes/account+/admin+/artists+/new.tsx:153
#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:79
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:108
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:143
#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:79
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:95
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:130
#: app/routes/account+/admin+/collaborators+/invitation.tsx:94
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:140
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:187
#: app/routes/account+/admin+/labels+/$labelId+/edit+/index.tsx:60
#: app/routes/account+/admin+/labels+/new.tsx:102
#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:86
#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:117
#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:133
#: app/routes/account+/finance+/revenue-share+/new.tsx:114
#: app/routes/account+/finance+/wallet+/index.tsx:148
#: app/routes/account+/my-account+/global-preferences+/edit.tsx:57
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:56
#: app/routes/account+/my-account+/personal-info+/edit.tsx:66
#: app/routes/account+/my-account+/personal-info+/wallet.tsx:48
#: app/routes/onboarding+/artists/index.tsx:175
#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:100
#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:96
#: app/routes/onboarding+/labels+/index.tsx:107
#: app/routes/subscription.tsx:140
msgid "An unexpected error occured."
msgstr ""

#: app/components/ErrorPageContent.tsx:32
msgid "An unexpected error occurred!"
msgstr ""

#: app/routes/_app+/rights+/form/use-import-track-url-form.ts:11
msgid "An URL is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/index.tsx:131
#: app/routes/_app+/tools+/marketing+/links+/index.tsx:264
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:203
msgid "Analytics"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/index.tsx:332
msgid "Analytics not found"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:142
msgid "and"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:397
msgid "And {0} more"
msgstr ""

#: app/routes/account+/index.tsx:327
msgid "And extra features you know you've needed"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:254
msgid "Any change to an active rule will be applied from the next month."
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:309
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:301
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:357
msgid "April"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:350
msgid "Archive this release"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/index.tsx:89
msgid "Are you sure you want to delete this audio?"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDelete/index.tsx:89
msgid "Are you sure you want to delete this collection?"
msgstr ""

#: app/modules/links/LinksLibraryDeleteDialog.tsx:106
msgid "Are you sure you want to delete this link?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:158
msgid "Are you sure you want to delete this post?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:93
msgid "Are you sure you want to downgrade the tier of this audio?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:93
msgid "Are you sure you want to downgrade the tier of this collection?"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:183
msgid "Are you sure you want to remove the premium access?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/index.tsx:116
msgid "Are you sure you want to remove this audio?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/index.tsx:122
msgid "Are you sure you want to remove this collection?"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/index.tsx:93
msgid "Are you sure you want to remove this entry from the collection?"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:186
msgid "Are you sure you want to remove this membership? This cannot be undone."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:161
msgid "Are you sure you want to revoke this collaborator's access for this artist?"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:165
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:191
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:146
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:172
msgid "Are you sure you want to revoke this collaborator's access for this label?"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:227
msgid "Are you sure you want to revoke this collaborator's access to this label?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/index.tsx:92
msgid "Are you sure you want to update the tier of this post?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:88
msgid "Are you sure you want to upgrade the tier of this audio?"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:88
msgid "Are you sure you want to upgrade the tier of this collection?"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:115
msgid "Arrangers, authors, composers and songwriters"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:260
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:206
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:181
#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:96
#: app/routes/account+/finance+/revenue-share+/components/ArtistsField.tsx:35
msgid "Artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:385
msgid "Artist avatar <0>(optional)</0>"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:174
msgid "Artist collaborators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:293
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:271
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:397
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:204
msgid "Artist country"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:307
msgid "Artist Country"
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingArtistComplete/index.tsx:26
#: app/routes/onboarding+/artists/index.tsx:182
#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:129
msgid "Artist created"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:130
msgid "Artist created successfully"
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:140
msgid "Artist created!"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:53
msgid "Artist deleted!"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:54
msgid "Artist documentation"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:265
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:242
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:283
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:414
msgid "Artist genre"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:218
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:229
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:268
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:279
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:147
msgid "Artist name"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:403
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:438
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:498
msgid "Artist picture <0>(optional)</0>"
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:306
msgid "Artist picture and description <0>(optional)</0>"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:97
msgid "Artist updated!"
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:294
msgid "Artist URL"
msgstr ""

#: app/components/CommandMenu.tsx:454
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:106
#: app/routes/account.tsx:198
#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:79
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:49
#: app/routes/account+/admin+/artists+/index.tsx:54
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:225
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:112
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:173
msgid "Artists"
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:25
msgid "Artists - Winamp for Creators"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/Artwork.tsx:75
msgid "Artwork"
msgstr ""

#: app/routes/onboarding+/subscription+/success/index.tsx:72
msgid "As a reminder you will be charged {0} per {1}.You can find the subscription and invoice in your account settings"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:76
msgid "As an author, composer, or songwriter, you generate copyright royalties each time your tracks are played on streaming platforms."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:262
msgid "As part of my subscription to Bridger's services, I agree to, among other things:"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:181
msgid "As soon as possible"
msgstr ""

#: app/routes/account+/index.tsx:439
msgid "Ask for a demo"
msgstr ""

#: app/components/ErrorBoundary.tsx:89
msgid "Ask your administrator to grant you access to this page."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:259
msgid "Assign artist"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:302
msgid "Assign label"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:182
msgid "Assign new artist collaborators to {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:231
msgid "Assign new artist roles to {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:188
msgid "Assign new label collaborators to {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:171
msgid "Assign new label collaborators to the selected label."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:133
msgid "Assign new label permissions to a user"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:220
msgid "Assign new label roles to {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:324
msgid "Assign new permissions for {0}."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:133
msgid "Assign new roles for a collaborator"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:332
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:363
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:336
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:341
msgid "Assign permissions"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/distribution-links.ts:21
msgid "At least 1 distribution link is required."
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:60
msgid "At least 1 platform URL is required."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/social-links.ts:18
msgid "At least 1 social link is required."
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:16
msgid "At least one audio file is required."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:42
msgid "At least one contributor is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:33
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:34
msgid "At least one platform is required."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/$id+/delete.tsx:31
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:70
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:78
msgid "Audio deleted!"
msgstr ""

#: app/routes/_app+/media+/components/AudioPlayButton.tsx:78
msgid "Audio Error"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:357
msgid "Audio files will not be shared on social platforms other than the Fanzone."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:303
msgid "Audio language"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/create.tsx:76
msgid "Audio published"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/edit.ts:219
msgid "Audio updated!"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:67
msgid "Audio Updated!"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:111
#: app/routes/_app+/media_+/audios+/$id+/route.tsx:119
#: app/routes/_app+/media+/route.tsx:176
msgid "Audios"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:88
msgid "Audios - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:225
msgid "Audios from feed"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:321
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:313
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:369
msgid "August"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:200
msgid "Auto Hashtags"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:437
msgid "Automatically generated if you don't have one"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:172
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:186
msgid "Automatically generated if you don’t have one"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:117
msgid "available to spend"
msgstr ""

#: app/components/ErrorPageContent.tsx:51
msgid "Back"
msgstr ""

#: app/routes/auth.login.tsx:69
msgid "Back to login"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:497
msgid "Background"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:568
msgid "Background color"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:25
msgid "Banned"
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:75
#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:200
msgid "Based on request"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/components/FeedCard/FeedCardPlaceholder.tsx:25
msgid "Be creative and engage your fans, they are waiting for you!"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:43
msgid "Be rewarded for using our services"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:66
msgid ""
"Before adding content to your fanzone, you need\n"
"to accept the terms and conditions."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:138
msgid ""
"Before minting NFTs, you need\n"
"to accept the terms and conditions."
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:322
msgid "Before picking featured tracks, you need to accept the terms & conditions."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightConsents.tsx:38
msgid "Before submitting your statements to us and to your co-creators (if applicable), please make sure that all the information is correct. Once submitted, you won't be able to to any change. Please contact us if needed."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:219
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:264
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:133
msgid "Before we can activate the service, you need to accept the terms and conditions."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:81
msgid ""
"Before we can collect copyright royalties on streaming platforms for\n"
"you, you need to complete the Bridger affilitation and to verify\n"
"your identity."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:180
msgid "Before we can collect copyright royalties on streaming platforms for you, you need to complete the Bridger affilitation and to verify your identity"
msgstr ""

#: app/components/WalletFeedback.tsx:45
msgid "Before we can collect royalties on your collectibles for you, you need to connect your wallet."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:124
msgid ""
"Before we can distribute your music to streaming platforms, you need\n"
"to accept the terms and conditions."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:96
msgid ""
"Before we can issue a license for your music, you need\n"
"to accept the terms and conditions."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:110
msgid ""
"Before we can monetize your music, you need\n"
"to accept the terms and conditions."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:82
msgid "Beneficiary"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:170
msgid "billed monthly"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:171
msgid "billed yearly"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/route.tsx:53
msgid "Billing"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:258
msgid "Brand Customization"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:376
msgid "Bridger - Rue de Strasbourg, 51 - 2561 Luxembourg, Luxembourg"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:261
msgid "Bridger affiliation"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:176
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:530
msgid "Bridger Affiliation"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:145
msgid "Bridger collects copyright royalties from all the major streaming platforms."
msgstr ""

#: app/routes/_app+/rights+/components/Listing.tsx:66
msgid "Bridger is an easy and intuitive copyright management solution for all songwriters."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:737
msgid "Button color"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:667
msgid "Button shape"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:487
msgid "By continuing, I agree to the <0>General Terms and Conditions of Subscription</0> and the <1>Privacy Policy.</1>"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:136
msgid "By DSP"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/components/TracksTable.tsx:133
msgid "By tracks"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:109
msgid "Can I post several jobs at the same time?"
msgstr ""

#: app/components/AvatarUpload.tsx:164
#: app/components/ImageUpload.tsx:217
#: app/components/ServiceContract/InitialisationStep.tsx:35
#: app/modules/links/LinksLibraryCreateDialog.tsx:156
#: app/modules/links/LinksLibraryDeleteDialog.tsx:115
#: app/modules/links/LinksLibraryDialog.tsx:272
#: app/modules/links/LinksLibraryEditDialog.tsx:151
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:329
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:360
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:386
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/index.tsx:206
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:179
#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:186
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:401
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:204
#: app/modules/route-dialogs/dialogs/AudioDelete/index.tsx:111
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:245
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:223
#: app/modules/route-dialogs/dialogs/AudioEdit/index.tsx:233
#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:371
#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/index.tsx:73
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:451
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:311
#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:171
#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:346
#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:244
#: app/modules/route-dialogs/dialogs/CollectionDelete/index.tsx:105
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:240
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/index.tsx:111
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:397
#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:197
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:261
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:234
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:217
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/index.tsx:134
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:181
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/index.tsx:140
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:181
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:425
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:627
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:217
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:475
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:564
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/index.tsx:103
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:453
#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:193
#: app/modules/route-dialogs/dialogs/GlobalPreferencesThemeEdit/index.tsx:193
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:333
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:338
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:364
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/index.tsx:206
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:209
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:190
#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:196
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:286
#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:189
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:261
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:278
#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:192
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:244
#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:292
#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:208
#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:360
#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:192
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:269
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:189
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:514
#: app/modules/tables/tables-states.tsx:218
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:373
#: app/routes/_app+/distribution+/init.tsx:178
#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:361
#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:216
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:426
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:331
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:529
#: app/routes/_app+/youtube-content-id+/new.tsx:307
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:247
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:521
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:245
#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:201
#: app/routes/account+/producers+/DialogNewProducer.tsx:174
#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:311
#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:174
#: app/routes/onboarding+/subscription+/components/CalendlyDialog.tsx:91
msgid "Cancel"
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:108
#: app/components/CollaboratorRow.tsx:271
msgid "Cancel invitation"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesThemeEdit/index.tsx:140
msgid "Change the color of interface theme"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:124
msgid "Change your preferences"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:373
msgid "Check the <0>troubleshooting guide</0> or <1>contact the support team</1>."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:366
#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:372
msgid "Choose a template"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:115
msgid "Choose a track to create a Winamp Original Collectible, or visit the Media section to add and manage your tracks"
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:138
msgid "Choose the artist you'd like to pay for now:"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:110
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:119
msgid "Choose tracks to monetize, or visit the Media section to add and manage your tracks."
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:117
msgid "Choose your five favorite tracks for pre-listen on your public Fanzone profile."
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:231
msgid "Click an icon to link a social network"
msgstr ""

#: app/components/KycBadge.tsx:64
msgid "click here to try again"
msgstr ""

#: app/components/KycBadge.tsx:75
msgid "click here to verify it"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/components/SocialNetworkCard.tsx:112
msgid "Click to link"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:280
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:267
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:228
#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:388
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:469
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:262
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:415
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/index.tsx:196
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:293
#: app/modules/route-dialogs/dialogs/index.tsx:385
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:166
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:187
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:205
#: app/modules/route-dialogs/RouteDialogsContext.tsx:224
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:444
msgid "Close"
msgstr ""

#: app/routes/_app.tsx:315
#: app/routes/account.tsx:133
msgid "Close sidebar"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:198
msgid "CMO <0>(optional)</0>"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:240
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:244
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:141
msgid "Collaborator"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:62
#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:62
msgid "Collaborator access revoked!"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:174
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:174
msgid "Collaborator assigned!"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:127
#: app/routes/account+/admin+/artists+/new.tsx:120
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:95
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:82
#: app/routes/account+/admin+/collaborators+/invitation.tsx:81
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:127
#: app/routes/account+/admin+/labels+/new.tsx:72
msgid "Collaborator invited!"
msgstr ""

#: app/routes/account.tsx:204
#: app/routes/account+/admin+/artists+/components/ArtistsGrid.tsx:74
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:113
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:220
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:97
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:44
#: app/routes/account+/admin+/collaborators+/index.tsx:56
#: app/routes/account+/admin+/labels+/index.tsx:143
#: app/routes/account+/finance+/revenue-share+/index.tsx:180
#: app/routes/account+/finance+/revenue-share+/index.tsx:320
msgid "Collaborators"
msgstr ""

#: app/routes/account+/admin+/collaborators+/index.tsx:24
msgid "Collaborators - Winamp for Creators"
msgstr ""

#: app/routes/account+/admin+/collaborators+/index.tsx:78
msgid "Collaborators are people who help you to manage the career of artists."
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:154
msgid "Collapse"
msgstr ""

#: app/routes/account+/index.tsx:257
msgid "Collect copyright royalties each time your tracks are played on steaming platforms directly on Winamp and generate a new income stream."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:46
msgid "Collect Llamacoin that you can use on the platform or exchange for $llama tokens, giving you a revolutionary new way to earn money with your music."
msgstr ""

#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:195
#: app/routes/_app+/rights+/components/Marketing.tsx:129
msgid "Collect rights"
msgstr ""

#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:130
#: app/routes/_app+/rights+/components/Marketing.tsx:73
msgid "Collect your copyright royalties with Bridger"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:264
#: app/routes/_app+/media+/index.tsx:258
msgid "Collect."
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:674
#: app/routes/_app+/media+/index.tsx:671
msgid "Collectible"
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:163
msgid "Collectible could not be initialized"
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:122
msgid "Collectible created!"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:84
msgid "Collectible information"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:94
#: app/routes/_app+/collectibles+/components/Listing.tsx:203
msgid "Collectible type"
msgstr ""

#: app/routes/_app+/collectibles+/$id+/index.tsx:95
msgid "Collectible update!"
msgstr ""

#: app/components/CommandMenu.tsx:101
#: app/routes/_app.tsx:403
#: app/routes/_app+/collectibles+/$id+/index.tsx:146
#: app/routes/_app+/collectibles+/new.tsx:232
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:69
#: app/routes/_app+/media+/audios+/index.tsx:321
#: app/routes/_app+/media+/audios+/index.tsx:383
#: app/routes/_app+/media+/index.tsx:315
#: app/routes/_app+/media+/index.tsx:378
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:434
#: app/routes/account+/index.tsx:284
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:191
msgid "Collectibles"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:74
#: app/routes/_app+/collectibles+/components/Marketing.tsx:62
msgid "Collectibles - Winamp Originals"
msgstr ""

#: app/routes/_app+/collectibles+/index.tsx:11
msgid "Collectibles - Winamp Originals - Winamp for Creators"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:67
msgid "Collectibles - Winamp Originals Illustration"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:200
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:349
msgid "Collection cover"
msgstr ""

#: app/routes/_app+/media+/collections+/new.tsx:77
msgid "Collection created!"
msgstr ""

#: app/routes/_app+/fanzone+/collections+/$id+/delete.tsx:34
#: app/routes/_app+/media_+/collections+/$id+/delete.tsx:59
msgid "Collection deleted!"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:163
#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:167
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:312
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:316
msgid "Collection name"
msgstr ""

#: app/routes/_app+/fanzone+/collections+/create.tsx:76
msgid "Collection published"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:96
msgid "Collection updated"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:126
msgid "Collection updated!"
msgstr ""

#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:68
msgid "Collection Updated!"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:120
#: app/routes/_app+/media_+/collections+/$id+/route.tsx:83
#: app/routes/_app+/media+/audios+/index.tsx:380
#: app/routes/_app+/media+/index.tsx:375
#: app/routes/_app+/media+/route.tsx:183
msgid "Collections"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:60
msgid "Collections - Winamp for Creators"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:194
msgid "Collective Management Organization (C.M.O.)"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:277
msgid "Collective Management Organization (CMO)"
msgstr ""

#: app/components/CommandMenu.tsx:343
msgid "Commands"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:197
msgid "Comment management"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:222
msgid "Comment on"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:202
msgid "Comments"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:80
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:517
msgid "Complete Bridger affiliation"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:192
msgid "Complete Bridger affilitation"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:234
msgid "Complete NFT information and set a price."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/KYCStatus.tsx:14
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:195
msgid "Complete the KYC steps to verify your identity. Once completed, you will have access to all services."
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:229
msgid "Complete track information and choose a license."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:210
msgid "Compress all files into a single ZIP file"
msgstr ""

#: app/modules/tables/tables-states.tsx:170
msgid "Configuration"
msgstr ""

#: app/modules/tables/tables-states.tsx:174
msgid "Configure the columns to display in the table and their order."
msgstr ""

#: app/modules/tables/tables-states.tsx:178
msgid "Configure the columns to display in the table."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:190
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:190
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/index.tsx:113
#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:216
#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:363
#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:314
msgid "Confirm"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:461
msgid "Confirm new revenue share"
msgstr ""

#: app/components/WalletFeedback.tsx:59
msgid "Connect wallet"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:212
msgid "Connect Wallet"
msgstr ""

#: app/components/ServiceLinkButton.tsx:77
#: app/components/ServiceSubmitButton.tsx:135
msgid "Connect Wallet & submit"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:142
#: app/routes/_app+/collectibles+/components/Marketing.tsx:242
msgid "Connect your wallet"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:326
#: app/routes/_app+/rights+/components/Listing.tsx:276
msgid "Contact support"
msgstr ""

#: app/components/CopyrightCheck.tsx:90
#: app/components/KYCFeedback.tsx:164
#: app/components/KYCFeedbackButton.tsx:88
#: app/modules/route-dialogs/dialogs/index.tsx:530
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:314
msgid "Contact Support"
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:61
msgid "Contact us"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:386
#: app/routes/_app+/media+/index.tsx:381
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:440
#: app/routes/account+/index.tsx:299
msgid "Content ID"
msgstr ""

#: app/routes/_app+/youtube-content-id+/$id+/deactivate.tsx:48
msgid "Content ID deactivated!"
msgstr ""

#: app/routes/_app+/youtube-content-id+/$id+/deactivate.tsx:40
msgid "Content ID deactivation failed!"
msgstr ""

#: app/routes/_app+/youtube-content-id+/$id+/deactivate.tsx:41
msgid "Content ID deactivation failed. Please try again later."
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:351
#: app/routes/_app+/media+/index.tsx:345
msgid "Content ID."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:340
msgid "Content rating"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:175
#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:193
#: app/routes/_app+/collectibles+/components/Marketing.tsx:131
#: app/routes/_app+/licensing+/components/Marketing.tsx:126
#: app/routes/onboarding+/artists/index.tsx:286
#: app/routes/onboarding+/kyc/index.tsx:177
#: app/routes/onboarding+/labels+/$labelId+/collaborators+/success/index.tsx:53
#: app/routes/onboarding+/subscription+/components/CalendlyDialog.tsx:102
#: app/routes/onboarding+/subscription+/success/index.tsx:88
msgid "Continue"
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:327
msgid "Continue without verification"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:180
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:172
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:443
msgid "Contributor"
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:101
#: app/components/CollaboratorRow.tsx:264
msgid "Copy link"
msgstr ""

#: app/components/CommandMenu.tsx:89
#: app/routes/_app.tsx:379
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:57
#: app/routes/_app+/media+/audios+/index.tsx:290
#: app/routes/_app+/media+/audios+/index.tsx:382
#: app/routes/_app+/media+/audios+/index.tsx:639
#: app/routes/_app+/media+/collections+/index.tsx:258
#: app/routes/_app+/media+/index.tsx:284
#: app/routes/_app+/media+/index.tsx:377
#: app/routes/_app+/media+/index.tsx:636
#: app/routes/_app+/rights+/$id+/index.tsx:180
#: app/routes/_app+/rights+/components/Listing.tsx:63
#: app/routes/_app+/rights+/components/Marketing.tsx:64
#: app/routes/_app+/rights+/new.tsx:243
#: app/routes/_app+/tools+/reporting+/route.tsx:70
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:431
#: app/routes/account+/index.tsx:254
msgid "Copyright"
msgstr ""

#: app/routes/_app+/rights+/index.tsx:15
msgid "Copyright - Winamp for Creators"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:98
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:278
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:313
msgid "Copyright / Bridger"
msgstr ""

#: app/components/CopyrightCheck.tsx:104
msgid "Copyright Check"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:70
msgid "Copyright Illustration"
msgstr ""

#: app/routes/_app+/tools+/reporting+/copyright/index.tsx:9
msgid "Copyright Reporting - Winamp for Creators"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:178
#: app/routes/_app+/index/utils/widgets.tsx:188
msgid "Copyright Revenue"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:179
msgid "Copyright revenues details"
msgstr ""

#: app/routes/_app+/media+/collections+/bulk.tsx:207
msgid "Could not delete all collections."
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:178
msgid "Could not delete all media."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:48
msgid "Could not delete the artist. Please contact the support."
msgstr ""

#: app/routes/resources+/app+/fanzone+/eligible-tracks.ts:42
msgid "Could not fetch the collections."
msgstr ""

#: app/routes/_app+/rights+/new.tsx:222
msgid "Could not fetch the contributors."
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:226
msgid "Could not fetch the licensing candidate."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:72
msgid "Could not fetch the services status"
msgstr ""

#: app/routes/account+/my-account+/personal-info+/index.tsx:43
msgid "Could not fetch the user"
msgstr ""

#: app/routes/_app+/rights+/new.tsx:186
msgid "Could not fetch the work candidate."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:37
msgid "Could not load user's preferences"
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:391
msgid "Could not update all media."
msgstr ""

#: app/components/CopyrightCheck.tsx:38
#: app/modules/route-dialogs/dialogs/index.tsx:474
msgid "Could you please help me with this?"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:243
#: app/routes/account+/finance+/revenue-share+/index.tsx:324
#: app/routes/account+/my-account+/personal-info+/index.tsx:173
#: app/routes/resources+/app+/widgets+/statistics+/streams+/countries.tsx:258
msgid "Country"
msgstr ""

#: app/routes/_app+/collectibles+/$id+/index.tsx:168
#: app/routes/_app+/collectibles+/new.tsx:255
#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:100
msgid "Cover image is required."
msgstr ""

#: app/components/DropdownMenuCollectionOrganizer.tsx:73
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/index.tsx:205
#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:258
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:354
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:402
#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:216
#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:305
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/index.tsx:200
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:298
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:348
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:194
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:238
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:243
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:324
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:262
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:156
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:261
#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:323
#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:720
#: app/routes/_app+/media+/components/AudioTitle.tsx:21
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:284
#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:109
#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:140
#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:176
#: app/routes/resources+/app+/widgets+/reporting+/licensing+/singles.tsx:110
msgid "Cover of {0}"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:315
msgid "Cover of {title}"
msgstr ""

#: app/routes/resources+/app+/widgets+/latest-activities.tsx:133
#: app/routes/resources+/app+/widgets+/latest-activities.tsx:140
msgid "Cover of the activity {0}"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:150
#: app/routes/_app+/distribution+/components/Listing.tsx:148
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:82
#: app/routes/_app+/licensing+/components/Listing.tsx:145
#: app/routes/_app+/media_+/collections+/$id+/route.tsx:96
#: app/routes/_app+/media+/collections+/index.tsx:160
#: app/routes/_app+/rights+/components/Listing.tsx:139
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:142
msgid "Cover of the collection {0}"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:102
msgid "Cover of the media {title}"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/top-tracks.tsx:133
msgid "Cover of the track {0}"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:159
msgid "Create"
msgstr ""

#: app/components/DropdownMenuCollectionOrganizer.tsx:95
#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:202
#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:141
#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:252
msgid "Create a new collection"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:105
msgid "Create a new label"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:108
msgid "Create a new label to manage artists and collaborators"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:108
msgid "Create a new Link"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:111
msgid "Create a new Link in your library so you can use it everywhere in Winamp for Creators."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:251
msgid "Create a page with social media links, website, music platforms and more."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:227
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:307
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:340
msgid "Create a post"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:76
msgid "Create a Winamp Original Collectible and allow your fans to access your unique master audio track while safeguarding your rights and earning money each time your NFT is resold."
msgstr ""

#: app/components/ErrorBoundary.tsx:266
msgid "Create an account"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:200
msgid "Create and customize your Winamp links page"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:245
msgid "Create and install your Ethereum wallet on your browser."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:63
msgid "Create and sell Collectibles of your work."
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:77
msgid "Create and sell collectibles of your works."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:394
msgid "Create artist"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:44
msgid "Create job offers, manage proposals, and select the right people to help you develop your career."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:372
#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:204
msgid "Create label"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:136
#: app/modules/links/LinksLibraryDialog.tsx:169
#: app/modules/links/LinksLibraryDialog.tsx:264
msgid "Create new Link"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/new.tsx:177
msgid "Create new revenue share"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/new.tsx:34
msgid "Create new Revenue Share - Winamp for Creators"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:122
msgid "Create posts for your different social networks"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:111
#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:195
#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:138
msgid "Create Premium Access"
msgstr ""

#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:238
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:221
msgid "Create release"
msgstr ""

#: app/routes/account+/index.tsx:367
msgid "Create specific links to your content, publish on social networks, create a website and much more."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/components/FeedCard/FeedCardPlaceholder.tsx:22
msgid "Create your first post"
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:345
msgid "Create your label"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:47
msgid "Create your links page"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:231
msgid "Create your page"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:74
msgid "Create your website with our builder"
msgstr ""

#: app/routes/_app+/media+/components/Uploads.tsx:147
msgid "Creating audio"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:456
msgid "Creating rule..."
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:114
msgid "Creating the collectible did not work. Try Again."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:206
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:200
msgid "Creating the comment did not work for the fanzone."
msgstr ""

#: app/routes/resources+/artists.$artistId.links.tsx:50
msgid "Creating the link did not work. Try Again."
msgstr ""

#: app/routes/_app+/distribution+/$id+/index.tsx:149
#: app/routes/_app+/distribution+/new.tsx:120
msgid "Creating the release did not work. Try Again"
msgstr ""

#: app/components/ServiceCandidateIssue.tsx:60
msgid "Creation not allowed"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:107
msgid "Credit those with roles for crafting a song such as its composer and/or lyricist."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCredits.tsx:44
msgid "Credits"
msgstr ""

#: app/components/AvatarUpload.tsx:178
#: app/components/ImageUpload.tsx:234
#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:375
msgid "Crop"
msgstr ""

#: app/components/AvatarUpload.tsx:144
#: app/components/ImageUpload.tsx:201
#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:345
msgid "Crop your image"
msgstr ""

#: app/modules/route-dialogs/dialogs/Subscribe/index.tsx:240
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:276
#: app/routes/onboarding+/subscription+/index.tsx:259
msgid "Currency"
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:302
#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:325
#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:365
msgid "Current plan"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:488
msgid "Custom time"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:488
msgid "Customise template"
msgstr ""

#: app/modules/theme/theme.tsx:66
msgid "Dark"
msgstr ""

#: app/components/UserMenu.tsx:118
msgid "Dark mode"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:189
msgid "Data missing"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:577
msgid "Date"
msgstr ""

#: app/components/CopyrightCheck.tsx:34
#: app/components/KycGdprDialog.tsx:26
#: app/modules/route-dialogs/dialogs/index.tsx:470
#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:40
msgid "Dear Winamp Support Team,"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:333
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:325
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:381
msgid "December"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:156
msgid "Declare that I have read the provisions of the General Terms and Conditions of Subscription (GTCS) of BRIDGER, a public limited company whose registered office is located at 51, rue de Strasbourg, L-2561 Luxemburg, Luxemburg, and that I subscribe to them without restriction or reservation in my capacity as author and/or composer."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:281
msgid "Declare to BRIDGER's repertoire all the works of which I am the creator or one of the creators (author/composer), guaranteeing that these works are not tainted by infringement, plagiarism or illicit borrowing;"
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:321
msgid "Default Fanzone Banner"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:195
#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:75
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:344
#: app/routes/_app+/fanzone+/feed+/route.tsx:292
#: app/routes/_app+/media+/audios+/index.tsx:426
#: app/routes/_app+/media+/collections+/index.tsx:291
#: app/routes/_app+/media+/index.tsx:421
#: app/routes/account+/admin+/artists+/components/ArtistsActions.tsx:62
msgid "Delete"
msgstr ""

#: app/modules/links/LinksLibraryDeleteDialog.tsx:95
msgid "Delete a Link"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:135
msgid "Delete artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/index.tsx:86
msgid "Delete audio"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDelete/index.tsx:86
msgid "Delete collection"
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:67
msgid "Delete my account"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:147
msgid "Delete post"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:185
msgid "Delete posts"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/route.tsx:155
msgid "Delete this audio"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:405
msgid "Delete this collectible"
msgstr ""

#: app/routes/_app+/rights+/components/Listing.tsx:289
msgid "Delete this copyright"
msgstr ""

#: app/routes/_app+/licensing+/components/Listing.tsx:333
msgid "Delete this licensing"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:356
msgid "Delete this release"
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:52
msgid "Deletion failed!"
msgstr ""

#: app/routes/account+/index.tsx:454
msgid "Demo request"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:210
#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:848
msgid "Description"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionCreate/index.tsx:215
#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:140
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:230
#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:168
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:220
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:371
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:463
#: app/routes/onboarding+/labels+/index.tsx:294
msgid "Description <0>(optional)</0>"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:388
msgid "Did you already start the transfer of your rights to Bridger?"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:250
msgid "Direct License provided?"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:291
msgid "Disable monetization"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:303
msgid "Disclaimer: Winamp is not responsible for the creation, management or accuracy of revenue share between users. It is the sole responsibility of users to set up and maintain their revenue share rules. Any revenue distributed by Winamp to user's wallet reflects the existing rule settings at the time of payout. Users retain the ability to adjust and redistribute revenue share and earnings in subsequent months if necessary."
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:277
#: app/routes/account+/my-account+/personal-info+/index.tsx:162
msgid "Display name"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:146
msgid "Distribute"
msgstr ""

#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:165
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:148
msgid "Distribute a track or a collection"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:354
msgid "Distribute to DSP"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:68
msgid "Distribute your tracks on Amazon Music, Apple Music, Deezer, SoundCloud, Spotify, Tidal, Winamp and many more..."
msgstr ""

#: app/components/CommandMenu.tsx:83
#: app/routes/_app.tsx:368
#: app/routes/_app+/distribution+/$id+/index.tsx:175
#: app/routes/_app+/distribution+/components/Listing.tsx:69
#: app/routes/_app+/distribution+/components/Marketing.tsx:56
#: app/routes/_app+/distribution+/new.tsx:218
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:53
#: app/routes/_app+/media+/audios+/index.tsx:275
#: app/routes/_app+/media+/audios+/index.tsx:385
#: app/routes/_app+/media+/audios+/index.tsx:627
#: app/routes/_app+/media+/collections+/index.tsx:211
#: app/routes/_app+/media+/collections+/index.tsx:260
#: app/routes/_app+/media+/collections+/index.tsx:412
#: app/routes/_app+/media+/index.tsx:269
#: app/routes/_app+/media+/index.tsx:380
#: app/routes/_app+/media+/index.tsx:624
#: app/routes/_app+/tools+/reporting+/route.tsx:62
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:425
#: app/routes/account+/index.tsx:239
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:133
msgid "Distribution"
msgstr ""

#: app/routes/_app+/distribution+/index.tsx:12
msgid "Distribution - Winamp for Creators"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:61
msgid "Distribution Illustration"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/distribution-links.ts:66
msgid "Distribution platforms updated!"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:32
msgid "Distribution profile page"
msgstr ""

#: app/routes/_app+/tools+/reporting+/distribution/index.tsx:9
msgid "Distribution Reporting - Winamp for Creators"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:162
#: app/routes/_app+/index/utils/widgets.tsx:172
msgid "Distribution Revenue"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:163
msgid "Distribution revenues details"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:341
msgid "Distribution URL"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:84
msgid "Do I have to pay extra to use the collaborator website?"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:139
msgid "Do I need a digital wallet?"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:140
msgid "Do the creations derived from your track have to be distributed under the same CC License?"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:127
msgid "Do you allow users to remix, arrange and adapt your track?"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:118
msgid "Do you allow users to use your track for commercial use?"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:177
msgid "Doe"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:182
msgid "Does Winamp for Creators come with secondary sales royalties?"
msgstr ""

#: app/routes/auth.login.tsx:79
msgid "Don't have an account yet?"
msgstr ""

#: app/components/ErrorBoundary.tsx:104
#: app/routes/account+/$.tsx:28
msgid "Don't worry, we'll get you back on track—just head to a safer place and let the music play!"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:551
msgid "Done"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:92
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:92
msgid "Downgrade tier"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:62
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:333
msgid "Downgrade to {0}"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:48
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:200
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:361
#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:103
#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:153
msgid "Download"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:417
msgid "Download Error"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/index.tsx:203
msgid "Download in progress..."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:191
msgid "Download pricing"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:404
msgid "Download the document"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:547
msgid "Download the mandate"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:292
msgid "Download uploaded license"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:97
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:407
#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:101
msgid "Downloading..."
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingArtistComplete/index.tsx:40
#: app/routes/_app+/media+/route.tsx:143
msgid "Drag & drop media or <0>click to upload</0>"
msgstr ""

#: app/components/FileUpload.tsx:99
msgid "Drag and drop a file or <0>click to upload</0>"
msgstr ""

#: app/components/ImageUpload.tsx:176
msgid "Drag and drop an image or <0>click to upload</0>"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:47
msgid "DSP"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:218
msgid "Duration: {0}"
msgstr ""

#: app/components/KYCFeedback.tsx:121
msgid "During verification, you do not have access to all services."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:79
msgid "EAN/UPC copied"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:229
msgid "EAN/UPC: {0}"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/index.tsx:52
msgid "Earn Llamacoin thanks to our tokenized rewards program."
msgstr ""

#: app/routes/account+/index.tsx:302
msgid "Earn more by tracking your music on YouTube. Create a unique copyright code for your tracks, we'll protect it and collect your earnings."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:33
msgid "Easily find collaborators for your projects."
msgstr ""

#: app/routes/account+/index.tsx:353
msgid "Easily share all the revenue generated by your music between all your collaborators, according to each person's role."
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:189
#: app/components/ActiveEntityDropdown.tsx:261
#: app/routes/_app+/fanzone+/feed+/route.tsx:280
#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:329
#: app/routes/_app+/media+/audios+/index.tsx:412
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:39
#: app/routes/_app+/media+/index.tsx:407
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:117
#: app/routes/account+/my-account+/personal-info+/index.tsx:105
msgid "Edit"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:250
msgid "Edit {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:191
msgid "Edit a label"
msgstr ""

#: app/modules/links/LinksLibraryEditDialog.tsx:113
msgid "Edit a Link"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:260
msgid "Edit a post"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:205
msgid "Edit an artist"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:135
msgid "Edit artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:238
msgid "Edit Artist"
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:179
msgid "Edit artist info"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:142
msgid "Edit artist link"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEdit/index.tsx:167
#: app/modules/route-dialogs/dialogs/AudioEdit/index.tsx:176
#: app/modules/route-dialogs/dialogs/AudioEdit/index.tsx:236
msgid "Edit audio"
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:169
msgid "Edit banner"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:115
msgid "Edit label"
msgstr ""

#: app/components/ArtistRow.tsx:96
#: app/components/CollaboratorRow.tsx:218
#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorArtistRow.tsx:99
#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorLabelRow.tsx:95
msgid "Edit permissions"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:159
msgid "Edit Premium Access"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:189
#: app/routes/account+/finance+/revenue-share+/index.tsx:350
msgid "Edit Rule"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:393
msgid "Edit this collectible"
msgstr ""

#: app/routes/_app+/licensing+/components/Listing.tsx:329
msgid "Edit this licensing"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:333
msgid "Edit this release"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:148
msgid "Edit your profile"
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:100
msgid "Editing the link did not work. Try Again."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:145
msgid "Editing this link will affect all the places you use this link. This can include the Fanzone links and the Winamp.link links."
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:322
msgid "Electric or Acoustic"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:183
#: app/routes/account+/my-account+/personal-info+/index.tsx:151
msgid "Email"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:227
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:155
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:231
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:184
msgid "Email address"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:295
#: app/routes/account+/producers+/DialogNewProducer.tsx:140
msgid "Email address <0>(optional)</0>"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:193
msgid "Email address of the teammate"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:31
msgid "Email confirmed"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:301
msgid "Enable monetization"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:257
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:232
msgid "Enable your fans to explore exclusive content by <0>curating selections from your media library</0>"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:343
msgid "End date"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:422
msgid "End of your current membership agreement"
msgstr ""

#: app/modules/lingui/lingui.ts:11
msgid "English"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:227
msgid "Enjoy your tokens outside Winamp for Creators' ecosystem."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:346
msgid "Enter his distribution URL"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:261
#: app/routes/onboarding+/kyc/index.tsx:306
msgid "Enter your last name."
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:344
#: app/routes/onboarding+/subscription+/enterprise/index.tsx:90
msgid "Enterprise plan request"
msgstr ""

#: app/modules/route-dialogs/dialogs/index.tsx:468
msgid "Error loading data - {key}"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:280
msgid "EUR"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:246
msgid "Every four months, we redistribute the money generated to you."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:306
msgid "Exclude certain countries of this release"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:210
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:214
msgid "Existing collaborator"
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:152
msgid "Expand"
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:57
#: app/components/CollaboratorRow.tsx:113
msgid "Expires on {0}"
msgstr ""

#: app/routes/account+/index.tsx:98
msgid "Explore and setup Creators"
msgstr ""

#: app/routes/account+/index.tsx:231
msgid "Explore the services of Winamp for Creators!"
msgstr ""

#: app/routes/_app+/tools+/reporting+/route.tsx:38
msgid "Export"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:305
msgid "Expressly mention, when one of my works borrows or reproduces a pre-existing work;"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:109
#: app/routes/account+/finance+/revenue-share+/index.tsx:358
msgid "Extend Rule"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:150
msgid "Extend rule duration"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:254
msgid "Facebook"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:67
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:74
msgid "Facebook comments must be 8000 characters or less."
msgstr ""

#: app/modules/posts/validate.ts:43
msgid "Facebook posts cannot exceed 63,206 characters."
msgstr ""

#: app/routes/_app+/distribution+/$id+/index.tsx:48
#: app/routes/_app+/distribution+/new.tsx:164
#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:59
msgid "Failed to fetch artist {0}"
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:35
#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:150
#: app/routes/account+/finance+/revenue-share+/new.tsx:140
msgid "Failed to fetch artists"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:62
msgid "Failed to fetch collaborator {0}"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:65
#: app/routes/account+/admin+/collaborators+/index.tsx:34
#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:153
#: app/routes/account+/finance+/revenue-share+/new.tsx:143
#: app/routes/account+/index.tsx:65
msgid "Failed to fetch collaborators"
msgstr ""

#: app/routes/account+/admin+/labels+/index.tsx:44
#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:147
#: app/routes/account+/finance+/revenue-share+/new.tsx:137
msgid "Failed to fetch labels"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:143
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:66
msgid "Failed to fetch rule {0}"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/index.tsx:71
msgid "Failed to fetch rules"
msgstr ""

#: app/routes/services+/$id+/mandate[.]pdf.tsx:65
#: app/routes/services+/rights+/mandate[.]pdf.tsx:42
msgid "Failed to generate PDF"
msgstr ""

#: app/components/CommandMenu.tsx:95
#: app/routes/_app.tsx:412
#: app/routes/_app+/fanzone+/route.tsx:69
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:73
#: app/routes/_app+/media+/audios+/index.tsx:306
#: app/routes/_app+/media+/audios+/index.tsx:381
#: app/routes/_app+/media+/audios+/index.tsx:686
#: app/routes/_app+/media+/collections+/index.tsx:227
#: app/routes/_app+/media+/collections+/index.tsx:257
#: app/routes/_app+/media+/collections+/index.tsx:424
#: app/routes/_app+/media+/index.tsx:300
#: app/routes/_app+/media+/index.tsx:376
#: app/routes/_app+/media+/index.tsx:683
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:243
#: app/routes/_app+/tools+/reporting+/route.tsx:78
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:428
#: app/routes/account+/index.tsx:314
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:162
msgid "Fanzone"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/route.tsx:11
msgid "Fanzone - Audios - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/collections+/route.tsx:10
msgid "Fanzone - Collections - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/route.tsx:38
msgid "Fanzone - Feed - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/images+/route.tsx:10
msgid "Fanzone - Images - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/videos+/route.tsx:10
msgid "Fanzone - Videos - Winamp for Creators"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:22
msgid "Fanzone - Winamp for Creators"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/conversion-rate.tsx:83
msgid "Fanzone conversion rate"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:307
msgid "Fanzone Conversion Rate"
msgstr ""

#: app/routes/account+/index.tsx:317
msgid "Fanzone helps you connect with fans through subscriptions and exclusive content, building loyalty and your fanbase."
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/minutes-listened.tsx:83
msgid "Fanzone minutes listened"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:251
msgid "Fanzone Minutes Listened"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/posts-read.tsx:81
msgid "Fanzone posts read"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:265
msgid "Fanzone Posts Read"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/reach.tsx:79
msgid "Fanzone reach"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:293
msgid "Fanzone Reach"
msgstr ""

#: app/routes/_app+/tools+/reporting+/fanzone/index.tsx:8
msgid "Fanzone Reporting - Winamp for Creators"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/retention.tsx:80
msgid "Fanzone retention"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:279
msgid "Fanzone Retention"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:194
#: app/routes/_app+/index/utils/widgets.tsx:204
msgid "Fanzone Revenue"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:195
msgid "Fanzone revenues details"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/countries.tsx:142
msgid "Fanzone streams by country"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:347
msgid "Fanzone Streams by Country"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/subscribers.tsx:190
msgid "Fanzone subscribers"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:226
msgid "Fanzone Subscribers"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:227
msgid "Fanzone subscribers details"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/total-plays.tsx:81
msgid "Fanzone total plays"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:237
msgid "Fanzone Total Plays"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:114
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:296
#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:319
msgid "Featured tracks"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:248
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:170
msgid "Features"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:303
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:295
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:351
msgid "February"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:108
msgid "Feed"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:231
#: app/routes/_app+/licensing+/components/Marketing.tsx:226
msgid "Fill in the metadata"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:117
msgid "Filter fields for the following services"
msgstr ""

#: app/routes/account.tsx:210
msgid "Finance"
msgstr ""

#: app/routes/_app+/tools+/reporting+/route.tsx:31
msgid "Find details about your revenue."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:57
msgid "Find new collaborators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:170
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:156
#: app/routes/account+/my-account+/personal-info+/index.tsx:111
msgid "First name"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:252
#: app/routes/onboarding+/kyc/index.tsx:297
msgid "First name and middle names."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:158
msgid "First release date"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:77
msgid "First you need to add <0>tracks</0> or a <1>collection</1> to your media library."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:87
#: app/routes/_app+/licensing+/components/Marketing.tsx:83
#: app/routes/_app+/rights+/components/Marketing.tsx:86
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:92
msgid "First you need to add <0>tracks</0> to your media library."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:228
msgid "Fixed amount"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:719
#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:792
msgid "Font color"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:758
msgid "Font Family"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:223
#: app/routes/onboarding+/kyc/index.tsx:243
msgid "For a smooth verification process, please upload a clear photo of your physical ID only. <0>Screen photos won't work and might cause your verification to fail.</0>"
msgstr ""

#: app/routes/_app+/media+/components/CollectionsPlaceholder.tsx:35
msgid "For example, in the case of distribution, a collection must be created to distribute an album."
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:172
msgid "For now, you can only distribute audio tracks. However, you can always upload other media to the Winamp Fanzone!"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:293
msgid "For works previously exploited under a Creative Commons license, declare in BRIDGER's repertoire only those works subject to licenses that do not allow commercial exploitation (BY-NC, BY-NC-SA and BY-NC-ND licenses);"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:116
msgid "Formatting guide"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:150
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:146
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:356
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:113
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:287
#: app/routes/onboarding+/subscription+/components/SubscriptionPlan.tsx:68
msgid "Free"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:114
msgid "Free plan"
msgstr ""

#: app/modules/lingui/lingui.ts:12
msgid "French"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:251
msgid "Frequency"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:138
#: app/routes/_app+/distribution+/components/Marketing.tsx:153
#: app/routes/_app+/licensing+/components/Marketing.tsx:133
#: app/routes/_app+/rights+/components/Marketing.tsx:137
#: app/routes/_app+/tools+/grow-your-team+/index.tsx:79
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:153
#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:97
msgid "Frequently Asked Questions"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:183
msgid "Full legal name"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:98
msgid "General information"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/TippingCard.tsx:31
msgid "Generate a QR Code"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:192
msgid "Genre"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:211
msgid "Get $llama tokens"
msgstr ""

#: app/components/CopyrightCheck.tsx:128
msgid "Get contacted by Support"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:153
#: app/routes/account.tsx:182
#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:306
#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:369
msgid "Get started"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/TippingCard.tsx:19
msgid "Get tips from fans in your Fanzone or at events with printed tip QR code."
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:274
#: app/routes/onboarding+/kyc/index.tsx:319
msgid "Get verified"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:283
msgid "Get verified later"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:73
msgid "Get your music featured in films, video games, TV, radio, commercials, and public establishments, with fair payment for each placement."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:255
#: app/routes/_app+/licensing+/components/Marketing.tsx:248
#: app/routes/_app+/rights+/components/Marketing.tsx:256
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:243
msgid "Get your revenue"
msgstr ""

#: app/routes/account+/index.tsx:463
msgid "Give us feedback"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:114
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:162
#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:122
msgid "Give your fans exclusive access to many benefits for a monthly fee."
msgstr ""

#: app/routes/account.tsx:244
#: app/routes/account+/my-account+/global-preferences+/index.tsx:57
#: app/routes/account+/my-account+/global-preferences+/index.tsx:72
msgid "Global preferences"
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:27
msgid "Global preferences - Winamp for Creators"
msgstr ""

#: app/components/ErrorBoundary.tsx:231
#: app/components/ErrorBoundary.tsx:242
msgid "Go back to a safer place"
msgstr ""

#: app/routes/account+/$.tsx:40
msgid "Go back to account"
msgstr ""

#: app/components/ArtistRow.tsx:81
#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorArtistRow.tsx:85
msgid "Go to artist page"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:168
#: app/routes/account+/admin+/artists+/components/ArtistsGrid.tsx:128
msgid "Go to artist workspace"
msgstr ""

#: app/components/CollaboratorRow.tsx:213
msgid "Go to collaborator page"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:343
msgid "Go to Fanzone"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorLabelRow.tsx:82
msgid "Go to label page"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:306
msgid "Go to media"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:185
#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:215
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:247
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:230
#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:203
#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:168
#: app/routes/_app+/collectibles+/components/Marketing.tsx:97
#: app/routes/_app+/distribution+/components/Marketing.tsx:94
#: app/routes/_app+/licensing+/components/Marketing.tsx:93
#: app/routes/_app+/rights+/components/Marketing.tsx:96
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:102
msgid "Go to Media"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:72
msgid "Go to website"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:593
msgid "Gradient color #1"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:611
msgid "Gradient color #2"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:199
msgid "Grant non-exclusive licenses on the Rights for the exploitation of the works in all or part of the Territory, through licensing agreements with online music service platforms;"
msgstr ""

#: app/routes/_app.tsx:453
#: app/routes/_app+/tools+/grow-your-team+/index.tsx:32
msgid "Grow your team"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:18
msgid "Grow your team - Winamp for Creators"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:37
msgid "Grow your team Illustration"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:371
msgid "Happy/Sad"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:371
msgid "Having trouble linking a network?"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/index.tsx:47
msgid "Heads-up"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:236
#: app/routes/account+/finance+/revenue-share+/new.tsx:201
msgid "Help box Revenue sharing?"
msgstr ""

#: app/routes/account+/index.tsx:429
msgid "Help center"
msgstr ""

#: app/components/CommandMenu.tsx:502
msgid "Help with searching"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:353
msgid "Here, you can access a detailed overview of the statistics for all your posts, providing insights into their performance and engagement."
msgstr ""

#: app/modules/tables/tables-states.tsx:303
msgid "Hide"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:904
msgid "Hide artist picture"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:532
msgid "Hide replies"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:107
msgid "Highlight those who contributed to the track's instrumentals and vocals."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:128
msgid "How can I opt-in?"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:96
msgid "How can I receive and reply to candidate applications?"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:212
#: app/routes/_app+/licensing+/components/Marketing.tsx:207
#: app/routes/_app+/rights+/components/Marketing.tsx:206
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:213
#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:176
msgid "How it works?"
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:312
msgid "How many artists do you manage?"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:176
msgid "How much can I earn with YouTube Content ID?"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:168
msgid "How much can I earn?"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:237
#: app/routes/onboarding+/kyc/index.tsx:257
msgid "How we manage your information"
msgstr ""

#: app/components/KycGdprDialog.tsx:51
msgid "How we protect and use your data"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:253
msgid "However, I exclude from the mandate entrusted to BRIDGER any exploitation allowing me to be remunerated directly by my community (example: Patreon)."
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:301
msgid "https://open.spotify.com/artist/..."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:85
msgid "https://open.spotify.com/track/..."
msgstr ""

#: app/routes/onboarding+/index.tsx:77
msgid "I am a label"
msgstr ""

#: app/routes/onboarding+/index.tsx:55
msgid "I am an artist"
msgstr ""

#: app/routes/onboarding+/index.tsx:58
msgid "I am an artist managing my career on my own with or without a team."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:351
msgid "I am entrusting Bridger with this Mandate as of {0}. Bridger's services will be effective as of {1}."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/ContentIdForm.tsx:89
msgid "I certify all of the above statements are true."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightConsents.tsx:78
msgid "I confirm that \"{0}\" is the {1} of the track \"{title}\""
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:474
msgid "I confirm that I am entitled to sign up to Bridger to submit my work as \"<0>{0}</0>\""
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:386
msgid "I confirm that I have the rights to legally represent \"<0>{0}</0>\"."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightConsents.tsx:60
msgid "I confirm this is an original version"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:179
msgid "I further mandate BRIDGER, for a minimum period of one year, to:"
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:42
msgid "I have a question about the artists subscriptions dialog."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:167
msgid "I hereby grant BRIDGER an exclusive Mandate to exploit the public performance rights (PER) and mechanical reproduction rights (MEC) of the musical works to which I hold all or part of the rights, on online music services (download and streaming) and platforms offering, among others, user generated content."
msgstr ""

#: app/routes/onboarding+/index.tsx:80
msgid "I manage and represent multiple artists with or without a team."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/index.tsx:360
msgid "I understand"
msgstr ""

#: app/components/KycGdprDialog.tsx:28
msgid "I would like more information about the KYC data you store."
msgstr ""

#: app/components/CopyrightCheck.tsx:36
msgid "I would like to challenge the copyright check for track {audioUid}"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:149
msgid "I, the undersigned, <0>{0}</0>,"
msgstr ""

#: app/modules/route-dialogs/dialogs/index.tsx:472
msgid "I'm experiencing issues while loading the \"{key}\" dialog."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:698
msgid "Icon and text"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:704
msgid "Icon only"
msgstr ""

#: app/routes/_app+/media+/index.tsx:372
msgid "Icons"
msgstr ""

#: app/components/KYCFeedback.tsx:65
msgid "Identity verification"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:65
msgid "If the artist is already distributed, please provide your distribution links to ensure accurate mapping for future releases."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:452
msgid "If the artist is already distributed, you must add his DSP link so it can be correctly mapped with his future releases"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:166
msgid "If the rule was expired, it will be reactivated on the next month."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:139
msgid "If this album was previously released through another distributor, you can provide the original release date alongside the new release date for distribution through us."
msgstr ""

#: app/components/KycGdprDialog.tsx:105
msgid "If you have any questions or wish to exercise your rights, please contact our Privacy Team at <0>privacy@winamp.com</0>."
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleCard.tsx:30
msgid "Image required for the tracks."
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:117
msgid "Images"
msgstr ""

#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:37
msgid "Images from feed"
msgstr ""

#: app/modules/posts/helpers.server.ts:80
msgid "Images uploaded to {platform} cannot exceed {0}."
msgstr ""

#: app/modules/posts/helpers.server.ts:43
msgid "Images uploaded to {platform} must have an aspect ratio between {0} and {1}."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:204
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:40
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:71
msgid "In use"
msgstr ""

#: app/routes/_app+/media+/components/MediaCallToAction.tsx:53
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:70
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:80
msgid "Incomplete"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:70
msgid "Increase your music income through licensing"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:198
msgid "Individual track pricing"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:214
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:41
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:72
msgid "Ineligible"
msgstr ""

#: app/components/ServiceCandidateIssue.tsx:92
msgid "Information missing"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:265
msgid "Instagram"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:58
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:65
msgid "Instagram comments must be 2200 characters or less."
msgstr ""

#: app/modules/posts/validate.ts:116
msgid "Instagram posts cannot exceed 10 images or videos."
msgstr ""

#: app/modules/posts/validate.ts:94
msgid "Instagram posts cannot exceed 2200 characters."
msgstr ""

#: app/modules/posts/validate.ts:104
msgid "Instagram posts cannot exceed 3 mentions."
msgstr ""

#: app/modules/posts/validate.ts:99
msgid "Instagram posts cannot exceed 30 hashtags."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:134
msgid "Interface theme"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesThemeEdit/index.tsx:171
msgid "Interface Theme"
msgstr ""

#: app/routes/_app+/index/route.tsx:73
msgid "Invalid form data"
msgstr ""

#: app/modules/route-dialogs/dialogs/index.tsx:374
msgid "Invalid Parameters"
msgstr ""

#: app/routes/auth.invitations.$invitation.accept.tsx:51
msgid "Invitation accepted!"
msgstr ""

#: app/routes/auth.invitations.$invitation.accept.tsx:43
msgid "Invitation expired!"
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:121
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:96
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:83
#: app/routes/account+/admin+/collaborators+/invitation.tsx:82
#: app/routes/account+/admin+/labels+/new.tsx:73
msgid "Invitation has been sent successfully."
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:88
#: app/components/CollaboratorRow.tsx:251
msgid "Invitation link copied!"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:243
#: app/routes/account+/admin+/collaborators+/index.tsx:117
#: app/routes/account+/admin+/collaborators+/index.tsx:123
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:262
msgid "Invite collaborators"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:136
msgid "Invite new collaborators by email address."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:294
msgid "Invite the teammates later"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:168
msgid "Invite your team"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:135
msgid "Is this a re-release?"
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:248
msgid "Is your music already on digital stores?"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:318
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:307
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:221
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:230
msgid "ISNI number <0>(optional)</0>"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistGeneralInformation.tsx:73
msgid "ISNI number: {0}"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:165
#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:419
msgid "ISRC number"
msgstr ""

#: app/modules/route-dialogs/dialogs/index.tsx:510
msgid "It looks like some data was lost while loading this dialog. Please retry or contact the support if the issue persists."
msgstr ""

#: app/routes/auth.login.tsx:59
msgid "It looks like you have been disconnected."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:121
msgid "It really whips"
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:192
msgid "It seems the verification process has been canceled. This step helps ensure a smooth experience, but you can skip it for now."
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:179
msgid "Items"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:163
msgid "Jane"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:233
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:163
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:237
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:191
msgid "jane.doe@winamp.com"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:300
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:292
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:348
msgid "January"
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:132
msgid "John Doe"
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:156
msgid "john.doe@winamp.com"
msgstr ""

#: app/routes/auth.invitations.$invitation.accept.tsx:17
msgid "Join a Label - Winamp for Creators"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:205
msgid "Join date"
msgstr ""

#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:187
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:222
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:148
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:175
msgid "Joined"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:318
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:310
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:366
msgid "July"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:315
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:307
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:363
msgid "June"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/index.tsx:50
msgid "Just a heads-up: once your track is used for a service, the metadata can't be changed."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/KYCStatus.tsx:10
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:191
msgid "Know your customer (KYC)"
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:162
msgid "KYC completed"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:240
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:169
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:175
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:239
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:80
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:219
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:96
msgid "Label"
msgstr ""

#: app/routes/account+/admin+/labels+/new.tsx:89
#: app/routes/onboarding+/labels+/index.tsx:120
#: app/routes/onboarding+/labels+/index.tsx:131
msgid "Label created!"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:126
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:216
#: app/routes/onboarding+/labels+/index.tsx:281
msgid "Label name"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:271
msgid "Label not found"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:43
msgid "Label not found - Winamp for Creators"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:379
msgid "Label of the artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:171
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:273
#: app/routes/onboarding+/labels+/index.tsx:270
msgid "Label picture <0>(optional)</0>"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:58
msgid "Label Settings"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/edit+/index.tsx:69
#: app/routes/onboarding+/labels+/index.tsx:120
#: app/routes/onboarding+/labels+/index.tsx:131
msgid "Label updated!"
msgstr ""

#: app/components/CommandMenu.tsx:413
#: app/routes/account.tsx:192
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:267
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:81
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:172
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:77
#: app/routes/account+/admin+/labels+/index.tsx:62
msgid "Labels"
msgstr ""

#: app/routes/account+/admin+/labels+/index.tsx:34
msgid "Labels - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:181
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:170
#: app/routes/account+/my-account+/personal-info+/index.tsx:122
msgid "Last name"
msgstr ""

#: app/routes/_app+/index/route.tsx:187
#: app/routes/_app+/tools+/statistics+/index.tsx:49
msgid "Last update: {0}"
msgstr ""

#: app/routes/resources+/app+/widgets+/latest-activities.tsx:59
msgid "Latest activities"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:109
msgid "Latest Activities"
msgstr ""

#: app/routes/account.tsx:256
msgid "Legal"
msgstr ""

#: app/routes/account.tsx:252
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:92
msgid "Legal documentation"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:29
msgid "Legal documentation - Winamp for Creators"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:370
msgid "Legal information"
msgstr ""

#: app/modules/format/date.ts:111
msgid "less than a minute"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:231
msgid "Let us know if some of your tracks have been written in collaboration with other songwriters."
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingLabelComplete/index.tsx:33
msgid "Let's go"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:113
msgid "Library is empty"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:259
#: app/routes/_app+/licensing+/components/License.tsx:65
#: app/routes/_app+/licensing+/components/Listing.tsx:168
#: app/routes/_app+/licensing+/components/Listing.tsx:192
msgid "License"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:155
msgid "License {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:131
msgid "License a track or a collection"
msgstr ""

#: app/routes/_app+/licensing+/$id+/index.tsx:106
msgid "License registration update!"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:200
msgid "License type"
msgstr ""

#: app/routes/account+/index.tsx:272
msgid "License your music for use in ads, games, TV, videos, and public venues worldwide, earning fair revenue for each placement."
msgstr ""

#: app/components/CommandMenu.tsx:107
#: app/routes/_app.tsx:395
#: app/routes/_app+/licensing+/$id+/index.tsx:172
#: app/routes/_app+/licensing+/components/Listing.tsx:70
#: app/routes/_app+/licensing+/components/Marketing.tsx:61
#: app/routes/_app+/licensing+/new.tsx:249
#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:377
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:65
#: app/routes/_app+/media+/audios+/index.tsx:336
#: app/routes/_app+/media+/audios+/index.tsx:384
#: app/routes/_app+/media+/audios+/index.tsx:662
#: app/routes/_app+/media+/collections+/index.tsx:259
#: app/routes/_app+/media+/index.tsx:330
#: app/routes/_app+/media+/index.tsx:379
#: app/routes/_app+/media+/index.tsx:659
#: app/routes/_app+/tools+/reporting+/route.tsx:86
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:437
#: app/routes/account+/index.tsx:269
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:249
msgid "Licensing"
msgstr ""

#: app/routes/_app+/licensing+/index.tsx:11
msgid "Licensing - Winamp for Creators"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:141
msgid "Licensing allows you to sell synchronization licenses so your music can be used in video and audio projects, mobile apps, radios, cinema/TV spots, video games, and others. Licensing also lets you have your music integrated into several radios of different music genres, to be played as background music in public establishments."
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:167
msgid "Licensing could not be initialized"
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:116
msgid "Licensing created!"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:66
msgid "Licensing Illustration"
msgstr ""

#: app/routes/_app+/tools+/reporting+/licensing/index.tsx:8
msgid "Licensing Reporting - Winamp for Creators"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:210
#: app/routes/_app+/index/utils/widgets.tsx:220
msgid "Licensing Revenue"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:211
msgid "Licensing revenues details"
msgstr ""

#: app/modules/theme/theme.tsx:66
msgid "Light"
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:62
msgid "Link deleted!"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:130
msgid "Link DSP profile"
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:188
msgid "Link profile using a Spotify URL"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:130
#: app/modules/links/LinksLibraryEditDialog.tsx:125
#: app/modules/links/LinksLibraryEditDialog.tsx:130
msgid "Link title"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:120
msgid "Link title<0>(optional)</0>"
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:108
msgid "Link updated!"
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:141
#: app/modules/links/LinksLibraryEditDialog.tsx:136
msgid "Link URL"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:924
msgid "Links"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:94
msgid "Links Library"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:366
msgid "Listed on Rarible"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/countries.tsx:273
msgid "Listeners"
msgstr ""

#: app/routes/account.tsx:222
#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:92
#: app/routes/account+/finance+/llamacoin+/index.tsx:51
msgid "Llamacoin"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:168
msgid "Llamacoin - loyalty program"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/index.tsx:13
msgid "Llamacoin - Winamp for Creators"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:174
msgid "Llamacoin — Terms of use"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:40
msgid "Llamacoin Illustration"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:119
msgid "Llamacoin is the name of our rewards program through which you collect llama coins. These coins can then be exchanged for cryptocurrency in the form of web3 tokens called $llama tokens."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:109
msgid "Load metadata"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1016
msgid "Loading links..."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:194
msgid "Location"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:37
msgid "Locked"
msgstr ""

#: app/components/Header.tsx:74
#: app/components/UserMenu.tsx:128
msgid "Log out"
msgstr ""

#: app/components/ErrorBoundary.tsx:269
msgid "Login"
msgstr ""

#: app/routes/auth.login.tsx:10
msgid "Login - Winamp for Creators"
msgstr ""

#: app/routes/account.tsx:248
#: app/routes/account+/my-account+/login-and-security+/index.tsx:40
msgid "Login & security"
msgstr ""

#: app/routes/account+/my-account+/login-and-security+/index.tsx:17
msgid "Login & security - Winamp for Creators"
msgstr ""

#: app/components/SocialMediaCheckbox.tsx:54
#: app/components/SocialMediaCheckbox.tsx:86
msgid "Logo of {socialMedia}"
msgstr ""

#: app/components/DigitalServiceProviderImg.tsx:66
msgid "Logo of {type}"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:389
msgid "Main instrument"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:316
msgid "Make your track discoverable"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:42
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:40
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:42
msgid "Manage {0} - Winamp for Creators"
msgstr ""

#: app/routes/_app+/media+/route.tsx:133
msgid "Manage all your files and metadata"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:62
msgid "Manage all your licensing needs in one place"
msgstr ""

#: app/routes/_app+/licensing+/components/Listing.tsx:73
msgid "Manage all your licensing needs in one place."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:205
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:121
#: app/routes/account+/finance+/revenue-share+/index.tsx:113
#: app/routes/account+/finance+/revenue-share+/new.tsx:184
msgid "Manage collaborator revenue splits."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:173
msgid "Manage collaborators for an artist"
msgstr ""

#: app/routes/account+/index.tsx:129
msgid "Manage label"
msgstr ""

#: app/routes/account+/index.tsx:143
msgid "Manage labels"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:182
msgid "Manage subscription"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:157
msgid "Manage this creator's journey"
msgstr ""

#: app/routes/_app+/index/components/AddWidgetDialog.tsx:77
#: app/routes/_app+/index/route.tsx:217
msgid "Manage widgets"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:189
msgid "Manage worldwide (the Territory) my said rights (the Rights);"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:437
msgid "Mandate"
msgstr ""

#: app/routes/services+/$id+/mandate[.]pdf.tsx:21
msgid "Mandate not found"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:306
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:298
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:354
msgid "March"
msgstr ""

#: app/components/CommandMenu.tsx:133
#: app/routes/_app.tsx:434
#: app/routes/_app+/tools+/marketing+/index.tsx:27
#: app/routes/_app+/tools+/marketing+/links+/index.tsx:146
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:79
msgid "Marketing"
msgstr ""

#: app/routes/account+/index.tsx:364
msgid "Marketing Tools"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:312
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:304
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:360
msgid "May"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:203
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:217
msgid "Mechanical rights"
msgstr ""

#: app/components/CommandMenu.tsx:65
#: app/routes/_app.tsx:359
#: app/routes/_app+/media_+/audios+/$id+/route.tsx:113
#: app/routes/_app+/media_+/collections+/$id+/route.tsx:77
#: app/routes/_app+/media+/route.tsx:129
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:155
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:221
msgid "Media"
msgstr ""

#: app/routes/_app+/media+/route.tsx:39
msgid "Media - Winamp for Creators"
msgstr ""

#: app/components/CommandMenu.tsx:73
msgid "Media > Audios"
msgstr ""

#: app/components/CommandMenu.tsx:78
msgid "Media > Collections"
msgstr ""

#: app/routes/_app+/media+/components/MediaDropzonePlaceholder.tsx:41
msgid "Media is where you upload your different tracks"
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:39
msgid "Meet the sales team"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/create.tsx:91
msgid "Membership created!"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:73
msgid "Membership deleted!"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:194
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:163
msgid "Membership libraries"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:129
#: app/modules/route-dialogs/dialogs/MembershipCreate/index.tsx:136
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:185
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:192
msgid "Membership name"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:79
msgid "Membership updated!"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:142
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:167
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:129
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:164
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:98
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:131
#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:41
msgid "Memberships"
msgstr ""

#: app/routes/account.tsx:184
msgid "Messages"
msgstr ""

#: app/routes/account+/messages+/index.tsx:10
msgid "Messages - Winamp for Creators"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:194
msgid "Messaging"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:43
msgid "Metadata prefilled"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:285
msgid "Mike Llama"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:311
msgid "mike@winamp.com"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:261
msgid "Mint"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:122
msgid "Mint a track"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:208
msgid "Modify general information about this artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:194
msgid "Modify general information about your label"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:151
msgid "Modify your general information"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:206
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:276
#: app/routes/_app+/youtube-content-id+/new.tsx:299
msgid "Monetize"
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:250
msgid "Monetize {0} tracks"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:72
msgid "Monetize and monitor the use of your music on YouTube."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:146
msgid "Monetize tracks"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:134
msgid "Monetize your tracks!"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:92
msgid "Monitor and review transactions."
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionPlan.tsx:78
#: app/routes/onboarding+/subscription+/success/index.tsx:78
msgid "month"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:258
msgid "Monthly"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:136
msgid "Monthly subscription"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:413
msgid "Mood tags"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:159
msgid "Music rights are twofold: copyright and master rights. Your digital distributor collects and pays only your master royalties. Bridger collects the missing part, the copyright royalties."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:104
msgid "Musicians"
msgstr ""

#: app/components/CommandMenu.tsx:145
#: app/routes/account.tsx:238
msgid "My Account"
msgstr ""

#: app/routes/account+/index.tsx:53
msgid "My Account - Winamp for Creators"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:153
msgid "My digital distributor already collects my royalties. Why should I join Bridger?"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:270
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:245
#: app/routes/account+/finance+/revenue-share+/index.tsx:289
msgid "n/a"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:152
#: app/routes/_app+/media+/collections+/index.tsx:255
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:159
msgid "Name"
msgstr ""

#: app/components/UserMenu.tsx:123
msgid "Need help?"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:246
msgid "New artist"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:207
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:211
msgid "New collaborator"
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:51
msgid "New Collectible - Winamp Originals - Winamp for Creators"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:116
#: app/routes/_app+/distribution+/init.tsx:103
msgid "New distribution"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:295
msgid "New End date"
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:40
msgid "New Licensing - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:219
msgid "New permissions assigned to an existing label collaborator will override their current label permissions."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:215
msgid "New roles assigned to an existing label collaborator will override their current label permissions."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:132
msgid "New songwriter"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:314
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:407
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:270
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:181
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:260
msgid "No"
msgstr ""

#: app/routes/resources+/app+/widgets+/latest-activities.tsx:89
msgid "No activities have been recorded yet."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:345
msgid "No artist selected"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:245
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:175
msgid "No artists"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:374
msgid "No artists found"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:274
msgid "No artists in this label."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:267
msgid "No artists matching \"{0}\"."
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/AboutCard.tsx:39
msgid "No biography"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:311
#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:284
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:150
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:226
msgid "No collaborators"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:121
msgid "No contributor"
msgstr ""

#: app/routes/resources+/app+/widgets+/components/ChartPlaceholder.tsx:43
msgid "No data available for the selected period"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:218
msgid "No genres matching \"{0}\"."
msgstr ""

#: app/routes/_app+/distribution+/init.tsx:169
msgid "No items"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleCandidatesSelection.tsx:45
#: app/routes/_app+/distribution+/components/ReleaseCandidatesSelection.tsx:39
#: app/routes/_app+/licensing+/components/LicensingCandidateSelection.tsx:43
#: app/routes/_app+/rights+/components/WorkCandidatesSelection.tsx:43
#: app/routes/_app+/youtube-content-id+/components/ContentIdCandidatesSelection.tsx:43
msgid "No items could be found."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:288
msgid "No labels"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:352
msgid "No labels found"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContextSwitch/index.tsx:60
msgid "No labels or artists found with the search term."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1022
msgid "No links"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/billing.tsx:140
msgid "No payments yet."
msgstr ""

#: app/components/Table.tsx:80
msgid "No records found"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:145
msgid "No results"
msgstr ""

#: app/components/CommandMenu.tsx:522
msgid "No results found"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:119
#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:192
#: app/routes/account+/finance+/wallet+/index.tsx:181
#: app/routes/account+/finance+/wallet+/index.tsx:218
msgid "No revenue yet."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:159
msgid "No role"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:67
msgid "No subscriptions yet."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:317
msgid "No title"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:303
msgid "No tracks"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:158
msgid "No Tracks matching your query."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:276
#: app/routes/account+/finance+/wallet+/index.tsx:298
msgid "No transactions yet."
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:161
msgid "No worries, you can use our distribution service for your new songs."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:89
msgid "No, it's totally free if you have a Winamp for Creators account."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:142
msgid "No, using the Llamacoin within the ecosystem won't require any external tool or service."
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:242
msgid "Not listed on Rarible yet"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:315
msgid "Not to contribute to the benefit of anyone (including a collective management organization or an independent management organization) any of the Rights already entrusted to Bridger for management;"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:330
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:322
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:378
msgid "November"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:294
msgid "Number of pages opened"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:327
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:319
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:375
msgid "October"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/index.tsx:83
msgid "Ok I get it"
msgstr ""

#: app/components/KycGdprDialog.tsx:124
msgid "Ok, it's clear"
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:183
msgid "Ok, proceed to payment"
msgstr ""

#: app/modules/links/LinksLibraryDeleteDialog.tsx:98
msgid "Once a Link is deleted, it's also removed from where it was used like the Fanzone or the Winamp.link page."
msgstr ""

#: app/modules/links/LinksLibraryEditDialog.tsx:116
msgid "Once a Link is edited, it's also changed where it is used like the Fanzone or the Winamp.link page."
msgstr ""

#: app/routes/_app+/media+/components/MediaDropzonePlaceholder.tsx:44
msgid "Once a media has been uploaded, you can use it in different services."
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:120
msgid "Once in your admin panel, you'll need to complete a separate payment for each artist to activate them. If you have any questions, feel free to reach out to us at <0>support@winamp.com</0>!"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:94
msgid "Once you downgrade the tier, the audio will be available to users who are subscribed to the free tier."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:94
msgid "Once you downgrade the tier, the collection will be available to users who are subscribed to the free tier."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:166
msgid "Once you revoke the collaborator's access, they will no longer be able to access this artist's account."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:170
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:196
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:151
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:177
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:232
msgid "Once you revoke the collaborator's access, they will no longer be able to access this label's account."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:78
msgid "Once you start collecting Llamacoins, it will show here! Start using our services to collect loyalty points as tokens."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:89
msgid "Once you upgrade the tier, the audio will be not be available to users who are subscribed to the free tier."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:89
msgid "Once you upgrade the tier, the collection will be not be available to users who are subscribed to the free tier."
msgstr ""

#: app/routes/onboarding+/route.tsx:47
msgid "One moment, we are setting up your account..."
msgstr ""

#: app/routes/subscription.tsx:257
msgid "One moment, your subscription is processing..."
msgstr ""

#: app/components/ErrorBoundary.tsx:101
#: app/routes/account+/$.tsx:25
msgid "Oops! Looks like this page hit a sour note. 🎶"
msgstr ""

#: app/components/ErrorBoundary.tsx:117
#: app/components/ErrorBoundary.tsx:138
msgid "Oops! Something broke..."
msgstr ""

#: app/routes/_app.tsx:281
#: app/routes/account.tsx:99
msgid "Open sidebar"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:343
msgid "Open your Page"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:206
msgid "or select through existing collections"
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:280
msgid "Other digital stores"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:172
msgid "Our ability to pay copyright royalties depends on when the various streaming platforms share their usage reports and make their payments, which is usually done quarterly."
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:61
msgid "Our sales team is here to help you find the best plan for your needs! With more than 10 artists, we'd love to offer you a personalized plan and hands-on support to set up your label."
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/challenge-copyright.ts:44
msgid "Our support team will reach out to you soon."
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/copyright+/history.tsx:86
#: app/routes/resources+/app+/widgets+/reporting+/distribution+/history.tsx:86
#: app/routes/resources+/app+/widgets+/reporting+/fanzone+/history.tsx:86
#: app/routes/resources+/app+/widgets+/reporting+/licensing+/history.tsx:86
#: app/routes/resources+/app+/widgets+/reporting+/summary+/history.tsx:109
#: app/routes/resources+/app+/widgets+/revenue-overall.tsx:74
msgid "Overall revenue"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:135
msgid "Overall Revenue"
msgstr ""

#: app/components/CommandMenu.tsx:59
#: app/routes/_app.tsx:344
#: app/routes/_app+/index/route.tsx:180
msgid "Overview"
msgstr ""

#: app/routes/_app+/index/route.tsx:59
msgid "Overview - Winamp for Creators"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:831
msgid "Page details"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:105
msgid "Page saved!"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:836
msgid "Page Title"
msgstr ""

#: app/components/CommandMenu.tsx:378
msgid "Pages"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:196
#: app/routes/_app+/distribution+/components/Listing.tsx:216
msgid "Partners"
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:24
#: app/routes/onboarding+/subscription+/index.tsx:198
msgid "Pay for one tool instead of six different services across multiple platforms!"
msgstr ""

#: app/components/CollaboratorRow.tsx:125
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:43
msgid "Pending"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:215
#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:233
msgid "Pending collaborators"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:80
#: app/routes/resources+/app+/widgets+/reporting+/fanzone+/list.tsx:110
#: app/routes/resources+/app+/widgets+/reporting+/summary+/list.tsx:118
msgid "Percentage"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:225
msgid "Percentage %"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:308
msgid "Percentage of fans who have subscribed"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:327
msgid "Perform all acts necessary for BRIDGER to carry out its duties;"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:167
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:214
msgid "Performance rights"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:222
msgid "Perks <0>(optional)</0>"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:302
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:317
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/index.tsx:179
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:282
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:306
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:293
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/index.tsx:179
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsGrid.tsx:98
msgid "Permissions"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:203
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:228
msgid "Permissions are applied only to artists selected and will overwrite label permissions"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:270
msgid "Permissions are applied to all artists from selected labels and will be applied to new artist from those labels."
msgstr ""

#: app/components/CollaboratorRow.tsx:143
msgid "Permissions assigned to an existing label collaborator override their current label permissions. This collaborator can be found in the artist collaborators section."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:130
msgid "Permissions assigned!"
msgstr ""

#: app/components/CollaboratorRow.tsx:135
msgid "Permissions overridden"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:66
msgid "Permissions updated!"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:176
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:191
msgid "Permissions will apply to all current and future artists from the label."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:187
msgid "Permissions will be applied only to {0}."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:239
msgid "Permissions will be applied only to the selected artist."
msgstr ""

#: app/routes/account.tsx:240
msgid "Personal info"
msgstr ""

#: app/routes/account+/my-account+/personal-info+/index.tsx:62
msgid "Personal information"
msgstr ""

#: app/routes/account+/my-account+/personal-info+/index.tsx:31
msgid "Personal information - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContextSwitch/index.tsx:102
msgid "Personal workspace"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:192
#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:172
#: app/routes/account+/my-account+/personal-info+/index.tsx:133
msgid "Phone number"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/route.tsx:50
msgid "Plans"
msgstr ""

#: app/routes/account.tsx:233
msgid "Plans & billing"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/route.tsx:38
msgid "Plans & Billing"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/billing.tsx:25
#: app/routes/account+/finance+/plans-and-billing+/route.tsx:18
msgid "Plans & Billing - Winamp for Creators"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/countries.tsx:288
msgid "Plays"
msgstr ""

#: app/routes/services+/$id+/index.tsx:23
msgid "Please accept the terms to continue."
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:68
msgid "Please certify that all of the above statements are true."
msgstr ""

#: app/routes/services+/$id+/index.tsx:49
msgid "Please choose a CMO."
msgstr ""

#: app/routes/services+/$id+/index.tsx:50
msgid "Please choose a start date."
msgstr ""

#: app/routes/services+/$id+/index.tsx:38
msgid "Please choose an end date."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:30
msgid "Please confirm the above statement."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:18
msgid "Please confirm the deletion by typing \"whip it\"."
msgstr ""

#: app/routes/services+/$id+/index.tsx:59
msgid "Please confirm the statement above."
msgstr ""

#: app/routes/onboarding+/route.tsx:50
#: app/routes/subscription.tsx:260
msgid "Please do not refresh the page or click the back button. This may take a few moments."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:252
#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:135
msgid "Please ensure accuracy when completing the following fields. In the event that you manage your rights with us, we will contact your collaborator via email to validate the split and collect your copyright royalties efficiently."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:33
msgid "Please enter a first name."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:34
msgid "Please enter a last name."
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:33
msgid "Please enter a producer name."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:18
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:19
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:18
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:19
#: app/routes/account+/admin+/collaborators+/invitation.tsx:13
#: app/routes/account+/admin+/collaborators+/invitation.tsx:15
msgid "Please enter a valid email address."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:36
#: app/routes/account+/producers+/DialogNewProducer.tsx:36
msgid "Please enter an email address."
msgstr ""

#: app/routes/account+/kyc+/index.tsx:29
#: app/routes/account+/kyc+/index.tsx:30
msgid "Please fill your first and middle names."
msgstr ""

#: app/routes/account+/kyc+/index.tsx:33
#: app/routes/account+/kyc+/index.tsx:34
msgid "Please fill your last name."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:440
msgid "Please find below the mandate of your Bridger affiliation. You can <0>download the document</0>. To start using Bridger, you must read and agree with the terms of the mandate that explains the full registration terms."
msgstr ""

#: app/components/ErrorBoundary.tsx:76
msgid "Please log in to your account to access this page."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:155
msgid "Please note that eligibility for a audio hinges on having the requisite metadata filled for the service. In order to utilize the service, you will need to create a release, with the exception of Fanzone."
msgstr "Please note that eligibility for a track hinges on having the requisite metadata filled for the service."

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:239
#: app/routes/account+/finance+/revenue-share+/new.tsx:204
msgid "Please note that eligibility for a track hinges on having the requisite metadata filled for the service. In order to utilize the service, you will need to create a release, with the exception of Fanzone."
msgstr "Please note that eligibility for a track hinges on having the requisite metadata filled for the service."

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:175
msgid "Please note, once this is done, it cannot be undone."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:20
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:20
msgid "Please select a collaborator."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:368
msgid "Please select a contact or create a new one."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:36
#: app/routes/account+/admin+/collaborators+/invitation.tsx:18
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:36
msgid "Please select a label."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:51
msgid "Please select a license."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:369
msgid "Please select a role."
msgstr ""

#: app/routes/_app+/rights+/create.tsx:11
#: app/routes/_app+/rights+/create.tsx:12
msgid "Please select a track."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:348
msgid "Please select an artist to view his legal documents."
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:87
msgid "Please select an option."
msgstr ""

#: app/routes/subscription.tsx:40
#: app/routes/subscription.tsx:42
msgid "Please select at least one artist."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:42
#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:44
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:42
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:44
msgid "Please select at least one permission."
msgstr ""

#: app/routes/subscription.tsx:50
msgid "Please select at least one product."
msgstr ""

#: app/routes/account+/admin+/collaborators+/invitation.tsx:27
#: app/routes/account+/admin+/collaborators+/invitation.tsx:30
msgid "Please select at least one role."
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:52
msgid "Please select at least one track."
msgstr ""

#: app/routes/onboarding+/subscription+/index.tsx:183
msgid "Please select only one artist to proceed with the subscription."
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/challenge-copyright.ts:55
msgid "Please try again later."
msgstr ""

#: app/components/KycBadge.tsx:54
msgid "Please wait for the review"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/index.tsx:63
msgid "Please, don't show this message again"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:339
msgid "Post created!"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:74
msgid "Post deleted!"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:188
msgid "Post history"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:343
msgid "Post updated!"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:166
msgid "Posts"
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:68
msgid "Preferences updated!"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:158
#: app/routes/account+/my-account+/global-preferences+/index.tsx:96
msgid "Preferred currency"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:145
#: app/routes/account+/my-account+/global-preferences+/index.tsx:87
msgid "Preferred language"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:150
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:384
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:146
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:356
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:113
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:287
#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:114
#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:169
msgid "Premium"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:289
msgid "Preparing license..."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:353
#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1123
msgid "Preview"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:173
msgid "Price"
msgstr ""

#: app/routes/account.tsx:264
msgid "Privacy notice"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:151
msgid "Privacy policy"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:428
msgid "Processing..."
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:125
msgid "Producer name"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:96
msgid "Producers and engineers"
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:99
#: app/routes/account+/my-account+/personal-info+/edit.tsx:76
#: app/routes/account+/my-account+/personal-info+/wallet.tsx:58
msgid "Profile updated!"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:160
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:72
#: app/routes/_app+/youtube-content-id+/new.tsx:276
msgid "Protect and monetise YouTube as of now."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:272
msgid "Provide BRIDGER with accurate and complete information;"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:337
msgid "Provide BRIDGER with all information and documentation relating to the total or partial cancellation of a management contract with another collective management organization and/or independent management organization, in order to guarantee and allow BRIDGER the peaceful management of the rights granted."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:85
msgid "Provide the name of the collaborator eligible for revenue sharing."
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:264
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:281
msgid "Publish"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:128
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:165
msgid "Publish date"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1096
msgid "Publish my page"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:452
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:496
msgid "Publish now"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:310
msgid "Publish real-time or scheduled posts directly to your social media accounts from the <0>Fanzone of Winamp for Creators</0>."
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:173
msgid "Publish real-time or scheduled posts directly to your social media accounts from Winamp for Creators. <0/>Share various types of content, including text, images, or videos, across one or multiple social networks simultaneously."
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:344
msgid "Publish this release"
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:41
msgid "Publish your job offers and find new collaborators"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:195
#: app/routes/_app+/media+/audios+/index.tsx:613
#: app/routes/_app+/media+/collections+/index.tsx:398
#: app/routes/_app+/media+/index.tsx:610
msgid "Push to"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:261
msgid "Quarterly"
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:38
msgid "Question about the artists subscriptions dialog"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:110
msgid "Quick access to your recent activities"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:219
msgid "Rarible"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:238
msgid "Rate"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:382
msgid "RCS: LU32714368"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:118
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:155
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:184
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:213
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:242
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:271
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:298
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:333
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:145
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:159
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:182
msgid "Read"
msgstr ""

#: app/components/ServiceContract/InitialisationStep.tsx:38
#: app/modules/route-dialogs/dialogs/ServiceActivate/index.tsx:275
msgid "Read terms & conditions"
msgstr ""

#: app/routes/_app+/media+/components/MediaCallToAction.tsx:38
#: app/routes/_app+/media+/components/MediaCallToAction.tsx:69
msgid "Ready"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/MembershipsCard.tsx:119
msgid "Ready to generate revenue?"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:80
msgid "Recover money from YouTube"
msgstr ""

#: app/routes/_app+/index/route.tsx:207
#: app/routes/_app+/tools+/statistics+/index.tsx:70
msgid "Refresh"
msgstr ""

#: app/components/KYCFeedback.tsx:132
msgid "Refresh status"
msgstr ""

#: app/routes/_app+/tools+/statistics+/index.tsx:67
msgid "Refreshing..."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:228
msgid "Register your tracks"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:65
msgid "Register your tracks and claim your copyright royalties."
msgstr ""

#: app/routes/_app+/distribution+/new.tsx:127
msgid "Release created!"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:174
#: app/routes/_app+/distribution+/components/Listing.tsx:214
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:102
msgid "Release date"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:96
msgid "Release information"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:138
#: app/routes/_app+/distribution+/components/Listing.tsx:213
msgid "Release Name"
msgstr ""

#: app/routes/_app+/distribution+/$id+/takedown.tsx:36
msgid "Release not taken down"
msgstr ""

#: app/routes/_app+/distribution+/$id+/takedown.tsx:44
msgid "Release taken down!"
msgstr ""

#: app/routes/_app+/distribution+/$id+/index.tsx:156
msgid "Release updated!"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:57
msgid "Release your tracks on music streaming platforms and online stores."
msgstr ""

#: app/routes/_app+/index/components/AddWidgetDialog.tsx:131
#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:335
msgid "Remove"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/index.tsx:105
msgid "Remove audio from Fanzone"
msgstr ""

#: app/components/CollaboratorRow.tsx:227
msgid "Remove collaborator"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/index.tsx:111
msgid "Remove collection from Fanzone"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/index.tsx:90
msgid "Remove entry from collection"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:249
msgid "Remove from collection"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:657
msgid "Remove Image"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:145
msgid "Remove this contributor"
msgstr ""

#: app/routes/account+/index.tsx:132
msgid "Rename, add artists/collaborators, create new label."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:476
msgid "Reply"
msgstr ""

#: app/components/CommandMenu.tsx:121
#: app/routes/_app.tsx:424
#: app/routes/_app+/tools+/reporting+/route.tsx:27
msgid "Reporting"
msgstr ""

#: app/routes/_app+/tools+/reporting+/route.tsx:14
msgid "Reporting - Winamp for Creators"
msgstr ""

#: app/routes/account+/index.tsx:335
msgid "Reports and statistics"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:142
msgid "Request"
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:34
msgid "Request a tailor-made offer"
msgstr ""

#: app/components/KycGdprDialog.tsx:98
msgid "Request data portability"
msgstr ""

#: app/components/KycGdprDialog.tsx:83
#: app/components/KycGdprDialog.tsx:88
msgid "Request rectification or erasure"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/Artwork.tsx:78
msgid "Required for single track distribution and/or collectibles"
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:104
#: app/components/CollaboratorRow.tsx:267
msgid "Resend invitation"
msgstr ""

#: app/modules/tables/tables-states.tsx:232
msgid "Reset"
msgstr ""

#: app/components/KycGdprDialog.tsx:93
msgid "Restrict or object to the processing of your data"
msgstr ""

#: app/components/ErrorBoundary.tsx:228
#: app/modules/route-dialogs/dialogs/index.tsx:538
#: app/routes/_app+/media+/components/Uploads.tsx:128
msgid "Retry"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:276
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:218
#: app/routes/account+/finance+/revenue-share+/index.tsx:297
#: app/routes/account+/finance+/revenue-share+/index.tsx:325
#: app/routes/account+/finance+/wallet+/index.tsx:154
#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:99
#: app/routes/resources+/app+/widgets+/reporting+/components/TracksTable.tsx:94
#: app/routes/resources+/app+/widgets+/reporting+/fanzone+/list.tsx:129
#: app/routes/resources+/app+/widgets+/reporting+/licensing+/singles.tsx:125
#: app/routes/resources+/app+/widgets+/reporting+/summary+/list.tsx:137
msgid "Revenue"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:73
msgid "Revenue beneficiary and source"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:136
msgid "Revenue by period"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:156
msgid "Revenue by service"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:146
msgid "Revenue by Service"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:213
msgid "Revenue can be shared based on a fixed amount or on percentage by service/artitst."
msgstr ""

#: app/routes/account.tsx:217
#: app/routes/account+/index.tsx:350
msgid "Revenue share"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:183
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:90
#: app/routes/account+/finance+/revenue-share+/index.tsx:90
#: app/routes/account+/finance+/revenue-share+/new.tsx:171
msgid "Revenue Share"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:44
#: app/routes/account+/finance+/revenue-share+/index.tsx:59
msgid "Revenue Share - Winamp for Creators"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:407
msgid "Revenue sharing can be applied to all services or to a specific service of your choice. If necessary, you can also create a new rule for any additional services."
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:123
#: app/routes/_app+/index/utils/widgets.tsx:147
msgid "Revenue splitted by services"
msgstr ""

#: app/routes/resources+/app+/widgets+/revenue-by-service.tsx:100
msgid "Revenues by service"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:122
msgid "Revenues by Service"
msgstr ""

#: app/routes/_app+/index/route.tsx:319
msgid "Revert"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:191
msgid "Review management"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:90
msgid "Review the terms and conditions"
msgstr ""

#: app/components/ArtistRow.tsx:113
#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorArtistRow.tsx:114
#: app/routes/account+/admin+/collaborators+/$id+/components/CollaboratorLabelRow.tsx:109
msgid "Revoke access"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:153
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:182
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:163
msgid "Revoke access for {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:144
msgid "Revoke access for a collaborator"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:162
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:143
msgid "Revoke access for a user"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:224
msgid "Revoke collaborator access"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsStatusBadge.tsx:49
msgid "Revoked"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:152
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:150
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:142
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:150
#: app/routes/_app+/rights+/$id+/components/CopyrightContributor.tsx:156
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:508
msgid "Role"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:141
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:174
msgid "Roles"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:117
msgid "Roles assigned!"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:66
msgid "Roles updated!"
msgstr ""

#: app/components/Table.tsx:199
msgid "Rows per page"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/new.tsx:102
msgid "Rule created!"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:120
msgid "Rule extended!"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:105
msgid "Rule updated!"
msgstr ""

#: app/modules/links/LinksLibraryEditDialog.tsx:160
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/index.tsx:209
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:409
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:212
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:456
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/index.tsx:209
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:294
#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:295
#: app/modules/tables/tables-states.tsx:244
#: app/routes/_app+/media_+/audios+/$id+/route.tsx:232
msgid "Save"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:271
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:365
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:476
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:328
msgid "Save and quit"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:439
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:486
msgid "Save as draft"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:196
#: app/modules/route-dialogs/dialogs/GlobalPreferencesThemeEdit/index.tsx:196
#: app/modules/route-dialogs/dialogs/MembershipEdit/index.tsx:247
#: app/routes/_app+/index/components/AddWidgetDialog.tsx:150
#: app/routes/_app+/index/route.tsx:334
#: app/routes/onboarding+/labels+/index.tsx:343
msgid "Save changes"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1074
#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1106
msgid "Save my page"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:275
msgid "Save Selection"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:338
msgid "Save your {artistOrdinal} artist"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:359
msgid "Save your page to enable the preview."
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:75
msgid "Schedule a meeting"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:459
msgid "Schedule for later"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:636
msgid "Schedule post"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:571
msgid "Schedule post for later"
msgstr ""

#: app/components/CommandMenu.tsx:329
#: app/modules/route-dialogs/dialogs/ContextSwitch/index.tsx:52
msgid "Search"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:217
msgid "Search a audio"
msgstr ""

#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:222
msgid "Search a collection"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:467
msgid "Search for a contributor"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:128
msgid "Search for a track"
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:159
msgid "Search for an artist profile on Spotify"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:179
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:204
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:187
#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:171
#: app/routes/_app+/distribution+/components/Marketing.tsx:125
#: app/routes/_app+/licensing+/components/Marketing.tsx:119
#: app/routes/_app+/rights+/components/Marketing.tsx:120
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:128
msgid "Search for collection or track titles"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:153
#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:176
#: app/routes/_app+/collectibles+/components/Marketing.tsx:124
msgid "Search for track titles"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:312
msgid "Search in media"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:107
msgid "Search links library..."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:220
msgid "Select"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:331
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:199
msgid "Select a C.M.O."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:208
msgid "Select a CMO"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/index.tsx:245
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/index.tsx:249
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:166
msgid "Select a collaborator"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:346
msgid "Select a content rating"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:298
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:276
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:312
#: app/modules/route-dialogs/dialogs/ProfileEdit/index.tsx:248
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:401
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:209
msgid "Select a country"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:278
msgid "Select a currency"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:763
msgid "Select a font family"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:253
msgid "Select a frequency"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:270
#: app/modules/route-dialogs/dialogs/ArtistEdit/index.tsx:248
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:288
#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:197
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:418
msgid "Select a genre"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:244
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:179
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:245
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:383
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:119
msgid "Select a label"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:418
msgid "Select a mood"
msgstr ""

#: app/components/SubscriptionFeedback.tsx:64
msgid "Select a plan"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:246
msgid "Select a pricing"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:156
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:154
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:146
#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:154
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:510
#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:216
msgid "Select a role"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:343
msgid "Select a speed"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:244
msgid "Select a subgenre"
msgstr ""

#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:168
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:151
#: app/routes/_app+/distribution+/components/Marketing.tsx:116
#: app/routes/_app+/distribution+/init.tsx:106
msgid "Select a track or an album you want to distribute or go to Media to add/manage tracks and/or collections."
msgstr ""

#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:134
msgid "Select a track you want to add a license to or go to Media to add & manage tracks."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:125
msgid "Select a track you want to mint or go to Media to add & manage tracks."
msgstr ""

#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:133
msgid "Select a track."
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:326
msgid "Select a type"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:383
msgid "Select a type of license"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:223
msgid "Select a type of sharing"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:109
msgid "Select a type..."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:163
msgid "Select a version"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:319
msgid "Select All"
msgstr ""

#: app/components/SelectArtistPlaceholder.tsx:57
#: app/components/SelectArtistPlaceholder.tsx:59
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:266
msgid "Select an artist"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:68
msgid "Select an artist to see terms & conditions."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:319
msgid "Select an audio language"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:359
msgid "Select an energy"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:203
msgid "Select an individual pricing"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioOwnership.tsx:48
msgid "Select an ownership type"
msgstr ""

#: app/routes/_app+/distribution+/init.tsx:115
msgid "Select from existing collections"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:149
#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:176
#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:167
msgid "Select from existing tracks"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsMusicians.tsx:214
msgid "Select or add a contributor"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsProducers.tsx:204
msgid "Select or add a producer"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:215
msgid "Select or add a songwriter"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:215
msgid "Select or add an artist"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:315
msgid "Select release partners"
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:17
#: app/routes/_app+/fanzone+/profile+/edit.tsx:18
#: app/routes/account+/admin+/artists+/new.tsx:21
#: app/routes/account+/admin+/artists+/new.tsx:22
#: app/routes/onboarding+/artists/index.tsx:94
#: app/routes/onboarding+/artists/index.tsx:95
msgid "Select the artist's country."
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:20
#: app/routes/account+/admin+/artists+/new.tsx:37
msgid "Select the artist's genre."
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:394
msgid "Select the main instrument"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:112
#: app/routes/_app+/distribution+/components/Marketing.tsx:113
#: app/routes/_app+/licensing+/components/Marketing.tsx:107
#: app/routes/_app+/rights+/components/Marketing.tsx:111
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:116
msgid "Select tracks"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:223
#: app/routes/_app+/licensing+/components/Marketing.tsx:218
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:224
msgid "Select tracks from your media library."
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:137
msgid "Select tracks you want to monetize."
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:215
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:221
msgid "Select your tracks"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:375
msgid "Select..."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:262
#: app/routes/account+/finance+/revenue-share+/components/TracksField.tsx:76
msgid "Selected tracks"
msgstr ""

#: app/routes/_app+/media+/audios+/index.tsx:377
#: app/routes/_app+/media+/collections+/index.tsx:254
#: app/routes/_app+/media+/index.tsx:371
msgid "Selection"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:134
msgid "Send"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:314
msgid "Send invite"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:62
msgid "Send message to your different social networks"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:182
msgid "Send posts"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:324
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:316
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:372
msgid "September"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:212
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:404
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:421
#: app/routes/account+/finance+/revenue-share+/index.tsx:262
#: app/routes/account+/finance+/revenue-share+/index.tsx:322
#: app/routes/resources+/app+/widgets+/reporting+/fanzone+/list.tsx:95
#: app/routes/resources+/app+/widgets+/reporting+/summary+/list.tsx:98
msgid "Service"
msgstr ""

#: app/routes/services+/$id+/index.tsx:228
#: app/routes/services+/$id+/index.tsx:234
msgid "Service activated!"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:244
#: app/routes/_app.tsx:366
msgid "Services"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:307
msgid "Services privacy policies"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:162
msgid "Set a price"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:318
msgid "Settings"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:368
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:420
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:545
#: app/routes/_app+/fanzone+/feed+/route.tsx:163
msgid "Share your thoughts"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:203
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:201
msgid "Sharing and service"
msgstr ""

#: app/components/Table.tsx:194
#: app/modules/tables/tables-states.tsx:303
msgid "Show"
msgstr ""

#: app/routes/_app+/media+/components/Uploads.tsx:57
msgid "Show {0} more"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:906
msgid "Show artist picture"
msgstr ""

#: app/routes/_app+/media+/components/Uploads.tsx:57
msgid "Show less"
msgstr ""

#: app/routes/onboarding+/subscription+/index.tsx:237
msgid "Show plans for"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:96
msgid "Show Rule"
msgstr ""

#: app/routes/auth.login.tsx:56
msgid "Sign in again!"
msgstr ""

#: app/routes/auth.login.tsx:61
msgid "Sign in to use Winamp for Creators."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:235
msgid "Sign the contract and verify your identity."
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:240
msgid "Sign the distribution agreement and certificate."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:242
msgid "Sign the mandate"
msgstr ""

#: app/routes/auth.login.tsx:87
msgid "Sign up"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:92
msgid "Signed contracts"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Wallet.tsx:112
#: app/routes/account+/finance+/wallet+/index.tsx:174
msgid "since last week"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:216
#: app/routes/onboarding+/kyc/index.tsx:235
msgid "Since we handle critical informations, we must verify your identity. This step helps ensure a smooth experience, but you can skip it for now."
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:276
msgid "Since your identity has not been verified, we have set your collectibles as drafts. Please verify your identity and resubmit them to mint your collectibles."
msgstr ""

#: app/components/KYCFeedback.tsx:69
#: app/routes/_app+/distribution+/components/Listing.tsx:79
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:379
msgid "Since your identity has not been verified, we have set your tracks as drafts. Please verify your identity and republish them to distribute on streaming platforms."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:337
msgid "Since your identity has not been verified, we have set your works as drafts. Please verify your identity and resubmit them to collect rights."
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:155
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:165
msgid "Since your identity has not been verified. Please verify your identity and try again to enable Content ID for the selected tracks."
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/licensing+/singles.tsx:100
msgid "Single"
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingArtistComplete/index.tsx:52
msgid "Skip for now"
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:214
msgid "Skip this step"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/SlugValidationInput.tsx:67
msgid "Slug"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/index.tsx:336
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:342
#: app/routes/account+/admin+/artists+/$artistId+/components/ArtistExternalLinks.tsx:102
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:433
msgid "Social links"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:152
msgid "Social links page"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/social-links.ts:63
msgid "Social links updated!"
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:349
msgid "Social media links <0>(optional)</0>"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:59
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:85
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:119
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:228
msgid "Social Media Manager"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:72
msgid "Social post Updated!"
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:97
msgid "Some rights reserved"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsSongwriters.tsx:104
msgid "Songwriters"
msgstr ""

#: app/routes/account.tsx:229
msgid "soon"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:202
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:153
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:188
#: app/routes/account+/finance+/revenue-share+/index.tsx:214
#: app/routes/account+/finance+/revenue-share+/index.tsx:321
msgid "Source"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:108
#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:105
msgid "Source could not be downloaded. {0}"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:418
msgid "Source could not be downloaded. Reason: \"{0}\""
msgstr ""

#: app/modules/bytescale/get-audio-error.ts:7
msgid "Source could not be fetched. {error}"
msgstr ""

#: app/modules/bytescale/get-audio-error.ts:9
msgid "Source could not be loaded. {error}"
msgstr ""

#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:91
msgid "Source could not be played. {0}"
msgstr ""

#: app/modules/bytescale/get-audio-error.ts:11
#: app/modules/bytescale/get-audio-error.ts:13
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:72
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:300
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:67
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:283
msgid "Source could not be played. {error}"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:191
msgid "Specify the source of revenue. It can be from all artists under a label or from one or more selected artists."
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:113
msgid "Spotify"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:57
#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:82
msgid "Spotify or Deezer track URL"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:65
msgid "Spread your music around the world"
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:108
msgid "Start by adding an artist"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:287
msgid "Start date"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/index.tsx:139
msgid "Start sharing revenue by <0>creating your first rule</0>"
msgstr ""

#: app/routes/onboarding+/index.tsx:41
msgid "Start your creator journey by adding your first artist or label."
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingArtistComplete/index.tsx:30
msgid "Start your creators' journey by uploading your tracks to generate revenue."
msgstr ""

#: app/routes/account+/admin+/labels+/index.tsx:91
msgid "Start your label and easily manage multiple artist spaces! Customize permissions for your team and get a clear overview of your label and artists."
msgstr ""

#: app/components/CommandMenu.tsx:127
#: app/routes/_app.tsx:429
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:350
#: app/routes/_app+/tools+/statistics+/index.tsx:43
msgid "Statistics"
msgstr ""

#: app/routes/_app+/tools+/statistics+/index.tsx:23
msgid "Statistics - Winamp for Creators"
msgstr ""

#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:199
#: app/routes/account+/admin+/artists+/components/ArtistsTable.tsx:223
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:155
#: app/routes/account+/admin+/collaborators+/components/CollaboratorsTable.tsx:176
msgid "Status"
msgstr ""

#: app/components/KYCFeedbackButton.tsx:74
msgid "Status pending"
msgstr ""

#: app/components/KYCFeedbackButton.tsx:45
msgid "Status unverified"
msgstr ""

#: app/components/KYCFeedbackButton.tsx:54
msgid "Status verified"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:224
msgid "Step into the future of music"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:197
#: app/routes/_app+/distribution+/components/Marketing.tsx:194
#: app/routes/_app+/licensing+/components/Marketing.tsx:182
#: app/routes/_app+/rights+/components/Marketing.tsx:181
#: app/routes/_app+/tools+/grow-your-team+/index.tsx:120
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:188
#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:150
msgid "Still have questions? <0>Visit our FAQ</0> or <1>reach out to us</1>"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:263
#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:50
#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:60
msgid "Streamline your posts by sharing media directly from your feed."
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:348
msgid "Streams splitted by country"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:335
msgid "Streams splitted by DSP"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:238
msgid "Subgenre"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:318
msgid "Submit"
msgstr ""

#: app/components/ServiceLinkButton.tsx:65
#: app/routes/account+/finance+/plans-and-billing+/index.tsx:125
msgid "Subscribe"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/route.tsx:121
msgid "Subscribe & publish to the Fanzone"
msgstr ""

#: app/components/ServiceSubmitButton.tsx:123
msgid "Subscribe & submit"
msgstr ""

#: app/modules/route-dialogs/dialogs/Subscribe/index.tsx:180
msgid "Subscribe now and Get started"
msgstr ""

#: app/routes/subscription.tsx:224
msgid "Subscription enabled!"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:29
msgid "Subscriptions - Plans & Billing - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/config.tsx:20
#: app/routes/services+/$id+/index.tsx:26
#: app/routes/services+/$id+/index.tsx:61
msgid "Success redirect must be a string."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:465
msgid "Suggestions"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:189
msgid "Supply"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:134
msgid "Supply <0>(Total number of copies)</0>"
msgstr ""

#: app/components/CopyrightCheck.tsx:126
msgid "Support has been requested"
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/challenge-copyright.ts:54
msgid "Support Request Failed"
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/challenge-copyright.ts:43
msgid "Support Request Sent"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:293
#: app/components/SelectArtistPlaceholder.tsx:106
msgid "Switch label"
msgstr ""

#: app/components/CommandMenu.tsx:228
msgid "Switch to {label}"
msgstr ""

#: app/routes/_app+/media+/components/CollectionsPlaceholder.tsx:52
msgid "Switch to an artist workspace to create a collection."
msgstr ""

#: app/routes/_app+/media+/components/MediaDropzonePlaceholder.tsx:25
msgid "Switch to an artist workspace to upload media files."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:166
msgid "Switch to an artist's workspace to access his marketing tools"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:84
msgid "Switch to an artist's workspace to publish on the Fanzone"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:81
msgid "Switch to an artist's workspace to use the Marketing tools"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:217
msgid "Sync your Deezer or Spotify accounts or select tracks from your media library."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:214
msgid "Sync/Select your tracks"
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:284
#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:336
msgid "Synchronising artist with Spotify"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:313
msgid "Tags & Metadata"
msgstr ""

#: app/components/SubscriptionFeedback.tsx:34
msgid "Take it to the next level!"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:338
msgid "Takedown this release"
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionsTable.tsx:329
msgid "Talk to sales"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:321
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:270
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/index.tsx:198
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/index.tsx:203
msgid "Target audience"
msgstr ""

#: app/routes/account.tsx:227
msgid "Taxes"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:334
msgid "Template"
msgstr ""

#: app/routes/account.tsx:258
msgid "Terms & conditions"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:137
msgid "Terms of services"
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:127
msgid "Terms of services by services"
msgstr ""

#: app/routes/_app+/distribution+/components/Listing.tsx:187
#: app/routes/_app+/distribution+/components/Listing.tsx:215
#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:302
msgid "Territories"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:701
msgid "Text only"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:534
msgid "Thank you for joining Bridger! Download your mandate here or find it later in your Legal Documents menu. You can now submit your work."
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:46
msgid "Thank you for your help!"
msgstr ""

#: app/routes/onboarding+/subscription+/success/index.tsx:66
msgid "Thanks for joining, you're on the plan \"{0}\"!"
msgstr ""

#: app/components/CopyrightCheck.tsx:40
#: app/components/KycGdprDialog.tsx:30
#: app/modules/route-dialogs/dialogs/index.tsx:476
msgid "Thanks in advance!"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:242
msgid "The {fileType} file {0} is invalid or corrupted."
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:322
msgid "The 5 most streamed tracks through all DSP  (Fanzone included)"
msgstr ""

#: app/routes/services+/$id+/index.tsx:188
msgid "The affiliation could not be made."
msgstr ""

#: app/routes/services+/$id+/index.tsx:123
msgid "The agreement could not be saved."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:43
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:56
msgid "The amount is required."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:45
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:58
msgid "The amount must be a number."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:46
msgid "The amount must be greater than 0."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:47
msgid "The amount must be lower than 1 million."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/index.tsx:338
msgid "The analytics for this post could not be found. This is most likely because the post was manually deleted from the social media platforms. If you believe this is an error, please try again later or <0>contact our support team.</0>"
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:91
#: app/routes/account+/contacts+/new.tsx:27
#: app/routes/account+/contacts+/new.tsx:63
#: app/routes/account+/contacts+/new.tsx:104
#: app/routes/account+/contacts+/new.tsx:128
#: app/routes/account+/contacts+/new.tsx:159
#: app/routes/account+/producers+/new.tsx:47
#: app/routes/onboarding+/artists/index.tsx:135
#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:64
msgid "The artist could not be created."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:40
msgid "The artist could not be deleted."
msgstr ""

#: app/routes/resources+/streaming-services+/spotify+/artists.ts:54
msgid "The artist could not be found."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/distribution-links.ts:41
#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:70
#: app/routes/account+/admin+/artists+/$artistId+/social-links.ts:38
msgid "The artist could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:141
msgid "The artist has been created successfully."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:163
msgid "The artist has been created."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:54
msgid "The artist has been deleted with success."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:98
msgid "The artist has been updated successfully."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/config.ts:14
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorInvite/config.ts:15
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/config.tsx:14
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/config.tsx:15
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/config.tsx:14
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/config.tsx:15
#: app/modules/route-dialogs/dialogs/ArtistDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/ArtistDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/ArtistEdit/config.tsx:22
#: app/modules/route-dialogs/dialogs/ArtistEdit/config.tsx:23
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/config.ts:22
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/config.ts:23
#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:16
#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:17
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:18
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:19
#: app/modules/route-dialogs/dialogs/AudioEditBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/AudioEditBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/CollectibleCreate/config.tsx:22
#: app/modules/route-dialogs/dialogs/CollectibleCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:21
#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:22
#: app/modules/route-dialogs/dialogs/CollectionCreate/config.tsx:19
#: app/modules/route-dialogs/dialogs/CollectionCreate/config.tsx:20
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:16
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:17
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:20
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:21
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:17
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:18
#: app/modules/route-dialogs/dialogs/ContentIDCreate/config.tsx:19
#: app/modules/route-dialogs/dialogs/ContentIDCreate/config.tsx:20
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/config.tsx:19
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/config.tsx:20
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:44
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:45
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:20
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:21
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:20
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:21
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/config.tsx:14
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/config.tsx:15
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:14
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:15
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:14
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:15
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:14
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:15
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/config.tsx:12
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/config.tsx:13
#: app/modules/route-dialogs/dialogs/LicensingCreate/config.tsx:12
#: app/modules/route-dialogs/dialogs/LicensingCreate/config.tsx:13
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/config.tsx:12
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/config.tsx:13
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/config.tsx:12
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/config.tsx:13
#: app/modules/route-dialogs/dialogs/MembershipCreate/config.tsx:22
#: app/modules/route-dialogs/dialogs/MembershipCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:22
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:23
#: app/modules/route-dialogs/dialogs/RightsCreate/config.tsx:12
#: app/modules/route-dialogs/dialogs/RightsCreate/config.tsx:13
#: app/modules/route-dialogs/dialogs/ServiceActivate/config.tsx:12
#: app/modules/route-dialogs/dialogs/ServiceActivate/config.tsx:13
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/config.tsx:12
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/config.tsx:13
#: app/modules/route-dialogs/dialogs/Subscribe/config.tsx:25
#: app/modules/route-dialogs/dialogs/Subscribe/config.tsx:26
#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:13
#: app/routes/account+/admin+/artists+/$artistId+/delete.tsx:14
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:29
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:30
#: app/routes/services+/$id+/index.tsx:24
#: app/routes/services+/$id+/index.tsx:58
msgid "The artist ID is required."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:6
#: app/routes/account+/admin+/collaborators+/invitation.tsx:22
msgid "The artist is required."
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:27
msgid "The artist name is required."
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:165
msgid "The artist name you entered <0>\"{0}\"</0> does not match the name on your Spotify profile <1>\"{nameMismatch}\"</1>. Would you like to use the name from your Spotify profile?"
msgstr ""

#: app/routes/resources+/streaming-services+/spotify+/artists.ts:14
msgid "The artist URL is invalid."
msgstr ""

#: app/routes/resources+/streaming-services+/spotify+/artists.ts:13
msgid "The artist URL is required."
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:51
msgid "The artist's profile could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/index.tsx:126
msgid "The artwork of the {collaborator}"
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:108
msgid "The artwork of the {label}"
msgstr ""

#: app/routes/_app+/media+/route.tsx:96
msgid "The audio {originalFileName} could not be created. Please try again."
msgstr ""

#: app/routes/_app+/media+/route.tsx:67
msgid "The audio could not be created. Please try again."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:44
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:64
msgid "The audio could not be deleted."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/edit.ts:131
#: app/routes/_app+/media_+/audios+/$id+/edit.ts:208
msgid "The audio could not be updated. Please try again."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:71
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:79
msgid "The audio has been deleted with success."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:44
msgid "The audio has been prefilled with the data from the streaming service."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/create.tsx:77
msgid "The Audio has been published on your fanzone."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/$id+/delete.tsx:32
msgid "The audio has been removed from the fanzone with success."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/edit.ts:220
msgid "The audio has been updated with success."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:14
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:20
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:21
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:12
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:13
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:15
#: app/routes/_app+/media_+/audios+/$id+/delete.tsx:16
#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:39
msgid "The audio ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/config.tsx:13
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/config.tsx:13
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:15
#: app/modules/route-dialogs/dialogs/AudioEditBulk/config.tsx:13
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:13
#: app/routes/_app+/media+/audios+/bulk.tsx:26
#: app/routes/_app+/media+/audios+/bulk.tsx:70
msgid "The audio IDs are required."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:17
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:15
#: app/routes/resources+/app+/collections+/$id.entries.update.ts:13
msgid "The audio is required."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:68
msgid "The audio tier has been updated."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/create.tsx:39
#: app/routes/_app+/fanzone+/audios+/create.tsx:68
msgid "The audios could not be published."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:285
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:601
#: app/routes/_app+/fanzone+/feed+/route.tsx:148
#: app/routes/_app+/index/components/Filters.tsx:98
#: app/routes/_app+/tools+/reporting+/components/GlobalFilters.tsx:98
#: app/routes/_app+/tools+/statistics+/components/Filters.tsx:98
#: app/routes/account.tsx:163
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:79
msgid "The avatar of {0}"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/components/FeedCard/FeedCardHeadArtist.tsx:24
msgid "The avatar of {displayName}"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/index.tsx:106
msgid "The avatar of the artist {artist}"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:19
msgid "The ayrshare comment ID must be a string."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:17
msgid "The Ayrshare post ID must be a string."
msgstr ""

#: app/routes/_app+/media+/audios+/bulk.tsx:107
#: app/routes/_app+/media+/collections+/bulk.tsx:136
msgid "The bulk action is invalid."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:18
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:19
msgid "The C.M.O. is required."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:40
msgid "The CMO ID should be a string."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:175
msgid "The collaborator has been assigned to this artist successfully."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:175
msgid "The collaborator has been assigned to this label successfully."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/config.tsx:13
#: app/modules/route-dialogs/dialogs/LabelCreate/config.tsx:14
#: app/routes/account+/admin+/artists+/new.tsx:69
#: app/routes/account+/admin+/artists+/new.tsx:70
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:41
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:42
#: app/routes/account+/admin+/labels+/new.tsx:22
#: app/routes/account+/admin+/labels+/new.tsx:23
msgid "The collaborator ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/config.tsx:13
msgid "The collaborator ID must be a string."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:21
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:21
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:104
msgid "The collaborator is required."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:69
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:90
msgid "The collaborator's access could not be revoked."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:102
msgid "The collaborator's access has been revoked with success."
msgstr ""

#: app/routes/_app+/collectibles+/$id+/index.tsx:88
msgid "The collectible could not be created."
msgstr ""

#: app/routes/_app+/collectibles+/$id+/index.tsx:54
msgid "The collectible could not be updated."
msgstr ""

#: app/routes/_app+/collectibles+/new.tsx:123
msgid "The collectible has been created with success."
msgstr ""

#: app/routes/_app+/collectibles+/$id+/index.tsx:96
msgid "The collectible has been updated."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/create.tsx:39
msgid "The collection could not be added."
msgstr ""

#: app/routes/_app+/media+/collections+/new.tsx:44
#: app/routes/resources+/app+/collections+/$id.entries.update.ts:38
msgid "The collection could not be created due to invalid data."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/delete.tsx:41
msgid "The collection could not be deleted."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/create.tsx:68
msgid "The collection could not be published."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:84
msgid "The collection could not be updated due to invalid data."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:88
msgid "The collection could not be updated. Please try again."
msgstr ""

#: app/routes/_app+/media+/collections+/new.tsx:78
msgid "The collection has been created successfully."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/delete.tsx:60
msgid "The collection has been deleted with success."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/create.tsx:77
msgid "The collection has been published on your fanzone."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/$id+/delete.tsx:35
msgid "The collection has been removed from the fanzone with success."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:127
msgid "The collection has been updated successfully."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:26
#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:27
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:12
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:13
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:20
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:21
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:12
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:13
#: app/routes/_app+/media_+/collections+/$id+/delete.tsx:14
#: app/routes/_app+/media_+/collections+/$id+/delete.tsx:15
msgid "The collection ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/config.tsx:13
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:13
#: app/routes/_app+/media+/collections+/bulk.tsx:17
#: app/routes/_app+/media+/collections+/bulk.tsx:48
msgid "The collection IDs are required."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:59
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:60
#: app/routes/_app+/media+/collections+/new.tsx:23
#: app/routes/_app+/media+/collections+/new.tsx:24
msgid "The collection name is required."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:69
msgid "The collection tier has been updated."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionDelete/index.tsx:91
msgid "The collection will be deleted but it's content will be kept. This action cannot be undone."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:156
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:158
msgid "The comment could not be created due to an error."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:98
msgid "The comment could not be created due to invalid data."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:150
msgid "The comment could not be created on external platforms due to an error."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:21
msgid "The comment ID is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:21
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:22
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:23
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:24
msgid "The comment is required."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:17
msgid "The contact ID must be a string."
msgstr ""

#: app/routes/services+/$id+/index.tsx:222
msgid "The content Id could not be made."
msgstr ""

#: app/routes/_app+/youtube-content-id+/$id+/deactivate.tsx:49
msgid "The Content ID has been deactivated successfully."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:14
msgid "The country is required."
msgstr ""

#: app/routes/_app+/media+/collections+/new.tsx:18
#: app/routes/_app+/media+/collections+/new.tsx:19
msgid "The cover image is required."
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleCard.tsx:21
#: app/routes/_app+/distribution+/components/ReleaseCard.tsx:94
#: app/routes/_app+/licensing+/new.tsx:264
msgid "The cover of {0}"
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:288
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:322
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:342
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:422
#: app/routes/_app+/collectibles+/$id+/index.tsx:162
#: app/routes/_app+/collectibles+/new.tsx:249
#: app/routes/_app+/licensing+/$id+/index.tsx:186
#: app/routes/_app+/rights+/$id+/index.tsx:188
#: app/routes/_app+/rights+/new.tsx:251
#: app/routes/_app+/youtube-content-id+/new.tsx:326
#: app/routes/_app+/youtube-content-id+/new.tsx:377
#: app/routes/_app+/youtube-content-id+/new.tsx:404
msgid "The cover of the track {0}"
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/create.tsx:25
#: app/routes/_app+/fanzone+/memberships+/create.tsx:26
#: app/routes/account+/my-account+/global-preferences+/edit.tsx:15
#: app/routes/account+/my-account+/global-preferences+/form/use-preferences-schema.ts:10
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:14
msgid "The currency is required."
msgstr ""

#: app/routes/resources+/app+/fanzone+/cover.ts:16
#: app/routes/resources+/app+/fanzone+/cover.ts:17
msgid "The current filename of the file is required."
msgstr ""

#: app/routes/resources+/streaming-services+/tracks.ts:34
msgid "The Deezer URL is invalid."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:22
#: app/routes/account+/admin+/artists+/new.tsx:31
#: app/routes/onboarding+/artists/index.tsx:39
msgid "The description is limited to {0} characters."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:18
msgid "The description is required."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:21
#: app/routes/_app+/fanzone+/memberships+/create.tsx:32
msgid "The description must not exceed 250 characters."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:17
msgid "The display name is required."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/distribution-links.ts:67
msgid "The distribution platforms have been updated successfully."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:72
msgid "The distribution URL is not valid."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:71
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:81
msgid "The distribution URL is required."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:97
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:97
msgid "The email address is missing."
msgstr ""

#: app/routes/account+/admin+/collaborators+/invitation.tsx:14
msgid "The email address is required."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:36
msgid "The email is invalid"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:64
msgid "The email is invalid."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:55
#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:35
msgid "The email is required"
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:63
msgid "The email must be a string."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:144
#: app/routes/services+/$id+/index.tsx:100
msgid "The end date must be greater than the start date."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:42
msgid "The end date must be greater than the today."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:29
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:35
msgid "The end date year must be a number."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:26
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:27
msgid "The energy is required."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:38
#: app/routes/account+/producers+/DialogNewProducer.tsx:37
msgid "The entered email address is invalid."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:16
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:17
msgid "The entry ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/index.tsx:97
msgid "The entry will not be part of the collection anymore. But you can always re-add it later."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:25
msgid "The file {0} is not a supported file."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:24
msgid "The file {0} is not a supported file. Accepted formats are {1}."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:30
msgid "The file {0} is too large."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:29
msgid "The file {0} is too large. Maximum size is {1}."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:34
msgid "The file {0} is too small."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:33
msgid "The file {0} is too small. Minimum size is {1}."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:40
msgid "The file could not be uploaded."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:226
msgid "The file of type {0} does not contain any video stream."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:15
msgid "The first name is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/config.tsx:12
msgid "The form ID is requiest."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/config.tsx:13
msgid "The form ID is required."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:118
msgid "The full name of the artist who composes musical compositions or writes lyrics for songs, or both."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:39
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:40
msgid "The instrument is required."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:45
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:46
msgid "The instrument sound is required."
msgstr ""

#: app/routes/auth.invitations.$invitation.accept.tsx:44
msgid "The invitation could not be accepted."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:89
#: app/routes/account+/admin+/collaborators+/invitation.tsx:49
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:89
#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:67
msgid "The invitation could not be sent"
msgstr ""

#: app/components/CollaboratorInvitedRow.tsx:89
#: app/components/CollaboratorRow.tsx:252
msgid "The invitation link has been copied to clipboard"
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:30
#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:31
#: app/routes/account+/admin+/artists+/new.tsx:41
#: app/routes/account+/admin+/artists+/new.tsx:42
#: app/routes/onboarding+/artists/index.tsx:100
#: app/routes/onboarding+/artists/index.tsx:101
msgid "The ISNI number is invalid."
msgstr ""

#: app/routes/account+/admin+/labels+/new.tsx:44
msgid "The label could not be created. Please check the form and try again."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/edit+/index.tsx:35
msgid "The label could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/account+/admin+/labels+/new.tsx:90
#: app/routes/onboarding+/labels+/index.tsx:122
#: app/routes/onboarding+/labels+/index.tsx:133
msgid "The label has been created successfully."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/edit+/index.tsx:70
#: app/routes/onboarding+/labels+/index.tsx:123
#: app/routes/onboarding+/labels+/index.tsx:134
msgid "The label has been updated successfully."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:43
msgid "The label ID is required when inviting a collaborator."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:20
#: app/modules/route-dialogs/dialogs/AudioDelete/config.tsx:21
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/AudioDeleteBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/AudioDownloadBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:22
#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:23
#: app/modules/route-dialogs/dialogs/AudioEditBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/AudioEditBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/CollectibleCreate/config.tsx:26
#: app/modules/route-dialogs/dialogs/CollectibleCreate/config.tsx:27
#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:31
#: app/modules/route-dialogs/dialogs/CollectionAppend/config.tsx:32
#: app/modules/route-dialogs/dialogs/CollectionCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/CollectionCreate/config.tsx:24
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:20
#: app/modules/route-dialogs/dialogs/CollectionDelete/config.tsx:21
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/CollectionDeleteBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:24
#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/config.tsx:25
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:21
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:22
#: app/modules/route-dialogs/dialogs/ContentIDCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/ContentIDCreate/config.tsx:24
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/config.tsx:23
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/config.tsx:24
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:48
#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:49
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/config.tsx:17
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:24
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:25
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/config.tsx:17
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:24
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:25
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:17
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:17
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/config.tsx:18
#: app/modules/route-dialogs/dialogs/FanzonePostCreate/config.tsx:19
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:18
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:19
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:18
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:19
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:17
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:18
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:19
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/config.tsx:16
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/config.tsx:17
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/config.tsx:14
#: app/modules/route-dialogs/dialogs/LabelCollaboratorInvite/config.tsx:15
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/config.tsx:14
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/config.tsx:15
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:43
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:44
#: app/modules/route-dialogs/dialogs/LabelEdit/config.tsx:24
#: app/modules/route-dialogs/dialogs/LabelEdit/config.tsx:25
#: app/modules/route-dialogs/dialogs/LicensingCreate/config.tsx:16
#: app/modules/route-dialogs/dialogs/LicensingCreate/config.tsx:17
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/MembershipAudioCreate/config.tsx:24
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/config.tsx:23
#: app/modules/route-dialogs/dialogs/MembershipCollectionCreate/config.tsx:24
#: app/modules/route-dialogs/dialogs/MembershipCreate/config.tsx:26
#: app/modules/route-dialogs/dialogs/MembershipCreate/config.tsx:27
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:26
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:27
#: app/modules/route-dialogs/dialogs/RightsCreate/config.tsx:16
#: app/modules/route-dialogs/dialogs/RightsCreate/config.tsx:17
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:24
#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:25
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:25
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:26
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:37
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:38
msgid "The label ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCreate/config.tsx:11
#: app/modules/route-dialogs/dialogs/CollaboratorCreate/config.tsx:13
#: app/routes/account+/admin+/artists+/new.tsx:47
msgid "The label ID must be a string."
msgstr ""

#: app/modules/route-dialogs/dialogs/Subscribe/config.tsx:31
msgid "The label ID should be a string."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/collaborators.tsx:37
#: app/routes/account+/admin+/collaborators+/invitation.tsx:19
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/index.tsx:37
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:81
msgid "The label is required."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/edit+/index.tsx:15
msgid "The label name is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:174
msgid "The label of this link."
msgstr ""

#: app/routes/resources+/admin.labels.$labelUid.distribution.tracks.tsx:15
msgid "The label UID is required"
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:14
#: app/routes/account+/my-account+/global-preferences+/form/use-preferences-schema.ts:9
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:13
msgid "The language is required."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:16
msgid "The last name is required."
msgstr ""

#: app/routes/_app+/licensing+/$id+/index.tsx:107
msgid "The license registration has been updated."
msgstr ""

#: app/routes/_app+/licensing+/$id+/index.tsx:99
#: app/routes/_app+/licensing+/new.tsx:68
#: app/routes/_app+/licensing+/new.tsx:109
msgid "The licensing could not be created."
msgstr ""

#: app/routes/_app+/licensing+/$id+/index.tsx:58
msgid "The licensing could not be updated."
msgstr ""

#: app/routes/_app+/licensing+/new.tsx:117
msgid "The licensing has been created."
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:53
msgid "The link could not be deleted."
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:63
msgid "The link has been deleted successfully."
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:109
msgid "The link has been updated successfully."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:97
msgid "The links page could not be saved. Try again."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/slug.validate.ts:62
msgid "The links slug could not be validated."
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCreate/index.tsx:134
#: app/modules/route-dialogs/dialogs/LabelEdit/index.tsx:224
msgid "The llama recommends not using CAPS only"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:230
#: app/components/SelectArtistPlaceholder.tsx:79
#: app/modules/route-dialogs/dialogs/ContextSwitch/index.tsx:134
msgid "The logo of {0}"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:71
msgid "The logo of the {activeEntity}"
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:18
msgid "The mechanical rights are required."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:19
msgid "The mechanical rights must be a positive number."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:22
msgid "The mechanical rights must be less than or equal to 100."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:71
msgid "The mechanical rights must sum to 100."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:45
#: app/routes/_app+/fanzone+/memberships+/create.tsx:55
msgid "The membership could not be created due to invalid data."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:66
msgid "The membership could not be deleted."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/create.tsx:92
msgid "The membership has been created successfully."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:74
msgid "The membership has been deleted with success."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:80
msgid "The membership has been updated successfully."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:39
#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:40
msgid "The membership ID is required."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:14
#: app/routes/_app+/fanzone+/memberships+/$id+/edit.tsx:15
#: app/routes/_app+/fanzone+/memberships+/create.tsx:14
#: app/routes/_app+/fanzone+/memberships+/create.tsx:15
msgid "The membership name is required."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:24
msgid "The minimum price is 1."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:30
msgid "The minimum supply is 1."
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:175
msgid "The monetization has been requested."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:22
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:17
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:28
msgid "The month is invalid."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:59
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:60
msgid "The mood is required."
msgstr ""

#: app/routes/account+/admin+/labels+/new.tsx:17
#: app/routes/onboarding+/labels+/index.tsx:52
msgid "The name is required"
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:63
#: app/routes/account+/admin+/artists+/new.tsx:64
#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:67
#: app/routes/onboarding+/artists/index.tsx:107
#: app/routes/onboarding+/artists/index.tsx:108
msgid "The name is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/config.tsx:15
msgid "The name must be a string."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioCreditsArtists.tsx:109
msgid "The name.s of the principal artist.s or band.s who participate in the release."
msgstr ""

#: app/routes/_app+/rights+/new.tsx:120
msgid "The new work has been created with success."
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:55
msgid "The number of artists is required"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:30
msgid "The order cannot be lower than 0"
msgstr ""

#: app/routes/resources+/app+/fanzone+/cover.ts:12
#: app/routes/resources+/app+/fanzone+/cover.ts:13
msgid "The original filename of the file is required."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:83
msgid "The page description is required."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:86
msgid "The page description must be at most 250 characters long."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:93
msgid "The page slug is required."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:90
msgid "The page title is required."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:9
msgid "The performance rights are required."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:10
msgid "The performance rights must be a positive number."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:13
msgid "The performance rights must be less than or equal to 100."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:60
msgid "The performance rights must sum to 100."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:41
#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:41
msgid "The permissions could not be applied."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:52
msgid "The permissions could not be assigned."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:131
#: app/routes/account+/admin+/collaborators+/$id+/labels+/roles.tsx:118
msgid "The permissions have been assigned successfully."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:67
#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:67
msgid "The permissions have been updated successfully."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:27
msgid "The phone country is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:31
msgid "The platform is required."
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:53
msgid "The platform URL is invalid."
msgstr ""

#: app/routes/account+/admin+/artists+/new.tsx:52
msgid "The platform URL is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:194
msgid "The post could not be created due to invalid data."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:39
msgid "The post could not be deleted."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:105
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:195
msgid "The post could not be updated due to invalid data."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:340
msgid "The post has been created successfully."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:75
msgid "The post has been deleted with success."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:344
msgid "The post has been updated successfully."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:20
#: app/modules/route-dialogs/dialogs/FanzonePostAnalyticsShow/config.tsx:21
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:20
#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/config.tsx:21
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:22
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/config.tsx:23
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:22
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/config.tsx:23
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:20
#: app/modules/route-dialogs/dialogs/FanzonePostShow/config.tsx:21
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:22
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:23
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:14
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/delete.tsx:15
msgid "The post ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:171
msgid "The post will also be deleted in {0}."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/create.tsx:18
msgid "The price is required."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/create.tsx:21
msgid "The price must not be greater than zero. Please use the free membership option if you want to offer free content."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:284
msgid "The prices listed above are for informational purposes only. The DSP retain the right to modify without prior notice their own sales prices at their discretion. The company will not be held responsible for any damages, whether direct or indirect, that may arise from the information provided on this page. The information is given “as is” and without any express, implicit, or legal warranties."
msgstr ""

#: app/routes/account+/producers+/new.tsx:22
msgid "The producer could not be created."
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:79
msgid "The producer has been created."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:34
msgid "The producer ID must be a string."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:59
msgid "The rate must be greater than 0%."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:60
msgid "The rate must be lower than 100%."
msgstr ""

#: app/routes/resources+/streaming-services+/tracks.ts:38
msgid "The received streamingServiceUrl must either be a spotify URL or a Deezer URL."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEdit/config.tsx:35
msgid "The redirect URL must be a string."
msgstr ""

#: app/routes/subscription.tsx:35
msgid "The redirection URL is invalid."
msgstr ""

#: app/routes/_app+/distribution+/$id+/takedown.tsx:37
msgid "The release could not be taken down."
msgstr ""

#: app/routes/_app+/distribution+/form/use-edit-release-form.tsx:39
msgid "The release date can't be sooner than in 7 days."
msgstr ""

#: app/routes/_app+/distribution+/new.tsx:128
msgid "The release has been created with success."
msgstr ""

#: app/routes/_app+/distribution+/$id+/takedown.tsx:45
msgid "The release has been taken down successfully."
msgstr ""

#: app/routes/_app+/distribution+/$id+/index.tsx:157
msgid "The release has been updated with success."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/new.tsx:103
msgid "The revenue share rule has been created successfully."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:121
msgid "The revenue share rule has been extended successfully."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:106
msgid "The revenue share rule has been updated successfully."
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/config.tsx:12
#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/config.tsx:13
msgid "The revshare rule ID is required."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:78
#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:79
msgid "The rights reservation is required"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:16
#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:33
msgid "The role ID must be a string."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:38
msgid "The role is required"
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:7
msgid "The role is required."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/roles.tsx:65
msgid "The roles could not be assigned."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/new.tsx:53
msgid "The rule could not be created."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/edit.tsx:50
msgid "The rule could not be edited."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:65
msgid "The rule could not be extended."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:82
msgid "The rule could not be found."
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:161
msgid "The rule will be extended until the selected end date or forever if you do not select an end date."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:40
msgid "The schedule date is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:41
msgid "The schedule date must be a valid date."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:44
msgid "The schedule time is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:45
msgid "The schedule time must be a valid time."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:48
msgid "The schedule UTC offset is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:52
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:56
msgid "The schedule UTC offset must be between {MIN_UTCOFFSET} and {MAX_UTCOFFSET}."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:64
msgid "The scheduled date and time must be in the future."
msgstr ""

#: app/routes/_app+/media+/collections+/append.tsx:46
msgid "The selected audio files could not be added to the collection."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioEditBulk/index.tsx:233
msgid "The selection is not editable. Please select at least one track that is not currently being used in another service."
msgstr ""

#: app/routes/services+/$id+/index.tsx:229
#: app/routes/services+/$id+/index.tsx:235
msgid "The service has been successfully activated."
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivate/config.tsx:16
#: app/modules/route-dialogs/dialogs/ServiceActivate/config.tsx:17
msgid "The service ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/config.tsx:26
#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/config.tsx:26
#: app/routes/_app+/media+/audios+/bulk.tsx:50
#: app/routes/_app+/media+/audios+/bulk.tsx:82
#: app/routes/_app+/media+/collections+/bulk.tsx:28
#: app/routes/_app+/media+/collections+/bulk.tsx:59
msgid "The service is required."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:84
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:101
msgid "The service must be a valid service."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/slug.validate.ts:17
msgid "The slug can only contain lowercase letters, numbers, dashes, and underscores."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/slug.validate.ts:12
msgid "The slug is required."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/SlugValidationInput.tsx:116
msgid "The slug is still available."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/slug.validate.ts:13
msgid "The slug must be at least 1 character long."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/slug.validate.ts:14
msgid "The slug must be at most 80 characters long."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/SlugValidationInput.tsx:84
msgid "The slug visible in the URL."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:38
#: app/routes/account+/admin+/artists+/$artistId+/edit.tsx:45
msgid "The social link must be a string."
msgstr ""

#: app/routes/account+/admin+/artists+/$artistId+/social-links.ts:64
msgid "The social links have been updated successfully."
msgstr ""

#: app/routes/resources+/app+/tools+/marketing.social-medias.unlink.ts:60
msgid "The social media could not be unlinked."
msgstr ""

#: app/routes/resources+/app+/tools+/marketing.social-medias.unlink.ts:71
msgid "The social media has been unlinked."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewSongwriter.tsx:96
msgid "The songwriter has been created."
msgstr ""

#: app/routes/_app+/rights+/new.tsx:87
msgid "The songwriters could not be synchronized with the audio."
msgstr ""

#: app/routes/resources+/streaming-services+/spotify+/artists.ts:17
msgid "The spotify artist URL is invalid. Please follow the steps above to get the correct URL."
msgstr ""

#: app/routes/resources+/streaming-services+/tracks.ts:28
msgid "The spotify URL is invalid."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/$id+/extend.tsx:18
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:13
#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:24
msgid "The start date is required."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:131
msgid "The start date must be in the future."
msgstr ""

#: app/routes/services+/$id+/index.tsx:80
msgid "The start date must be in the past."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/hooks/use-revenue-share-form.tsx:20
msgid "The start date year must be a number."
msgstr ""

#: app/routes/subscription.tsx:85
#: app/routes/subscription.tsx:137
msgid "The subscription could not be purchased."
msgstr ""

#: app/routes/_app+/collectibles+/form/use-collectible-form.tsx:41
msgid "The supply must be exactly 1 for Originals."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:173
msgid "The teammates added here will have the same roles for all the artists of your label. You will be able to update the teammates' roles per artist in your account settings later."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:66
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:67
msgid "The tempo is required."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:17
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:16
msgid "The theme is required."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:39
#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:60
#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:39
#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:61
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:39
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:60
msgid "The tier could not be updated."
msgstr ""

#: app/routes/resources+/app+/fanzone+/eligible-tracks.ts:21
msgid "The Tier ID is missing."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:16
#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/config.ts:17
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:16
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/config.ts:17
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:26
#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/config.tsx:27
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:30
#: app/modules/route-dialogs/dialogs/MembershipEdit/config.tsx:31
#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:13
#: app/routes/_app+/fanzone+/audios+/$id+/edit.ts:14
#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:13
#: app/routes/_app+/fanzone+/collections+/$id+/edit.ts:14
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:77
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:78
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:13
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:14
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:83
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:84
#: app/routes/_app+/fanzone+/feed+/route.tsx:46
#: app/routes/_app+/media+/audios+/bulk.tsx:57
#: app/routes/_app+/media+/collections+/bulk.tsx:35
msgid "The tier ID is required."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/tiers+/edit.ts:73
msgid "The tier of the post has been updated."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:16
#: app/routes/account+/my-account+/global-preferences+/form/use-preferences-schema.ts:11
#: app/routes/account+/my-account+/global-preferences+/form/use-preferences-schema.ts:12
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:15
msgid "The time zone is required."
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/update-title.ts:65
msgid "The title could not be updated. Please try again later."
msgstr ""

#: app/routes/resources+/app+/audios+/$id+/update-title.ts:79
msgid "The title has been updated."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:72
#: app/routes/_app+/media_+/audios+/$id+/form/use-edit-audio-form.ts:73
msgid "The title is required"
msgstr ""

#: app/routes/_app+/media+/components/EditableTitle.tsx:50
#: app/routes/_app+/media+/components/EditableTitle.tsx:51
msgid "The title is required."
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:133
msgid "The title is used in Creators to quickly identify your links."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:132
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:77
msgid "The title must be a string."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:841
msgid "The title of the page."
msgstr ""

#: app/components/TitleBeautifier.tsx:127
msgid "The title you entered was changed by the title beautifier to fit DSP guidelines. If you want to revert the changes, click the undo button."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:244
#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:269
msgid "The total must be 100%"
msgstr ""

#: app/routes/resources+/streaming-services+/tracks.ts:79
msgid "The track could not be found."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:109
msgid "The track could not be removed from this collection. Please try again."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:117
msgid "The track has been removed from this collection."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:97
msgid "The tracks in the collection have been updated."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:332
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:526
msgid "The update of this post will not be applied to platforms other than the Fanzone."
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:50
#: app/routes/onboarding+/artists/index.tsx:62
#: app/routes/onboarding+/artists/index.tsx:70
msgid "The URL is invalid."
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:221
msgid "The URL is not valid"
msgstr ""

#: app/routes/onboarding+/components/SpotifyArtistCombobox.tsx:220
msgid "The URL is required"
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:14
msgid "The URL is required."
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:49
#: app/routes/onboarding+/artists/index.tsx:61
#: app/routes/onboarding+/artists/index.tsx:69
msgid "The URL must be a valid string."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:192
msgid "The url of this link."
msgstr ""

#: app/routes/resources+/artists.$artistId.links.$linkId.tsx:15
msgid "The URL should be a valid URL."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/config.ts:15
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/config.ts:16
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/config.tsx:18
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/config.tsx:19
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/config.tsx:18
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/config.tsx:19
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/config.tsx:15
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/config.tsx:16
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/config.tsx:18
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/config.tsx:19
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:47
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:48
msgid "The user ID is required."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPublishDisclaimer/config.tsx:16
msgid "The value must be a string."
msgstr ""

#: app/modules/lingui/validation.ts:63
msgid "The value should be a valid email. Received {0}"
msgstr ""

#: app/modules/lingui/validation.ts:67
msgid "The value should be a valid string. Received {0}"
msgstr ""

#: app/routes/account+/kyc+/index.tsx:50
#: app/routes/account+/kyc+/index.tsx:105
#: app/routes/account+/kyc+/index.tsx:113
msgid "The verification process could not start. Please check the form."
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:198
msgid "The verification process has been canceled."
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:177
msgid "The verification process has started. If you don't see the verification dialog, please close this dialog and try again."
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:267
msgid "The verification process has started. If you don't see the verification dialog, please try again."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:26
msgid "The video ID must be a string."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/wallet.tsx:12
msgid "The wallet address is required."
msgstr ""

#: app/routes/_app+/rights+/new.tsx:54
#: app/routes/_app+/rights+/new.tsx:114
msgid "The work could not be created."
msgstr ""

#: app/routes/_app+/rights+/$id+/index.tsx:55
#: app/routes/_app+/rights+/$id+/index.tsx:93
msgid "The work could not be updated."
msgstr ""

#: app/routes/_app+/rights+/$id+/index.tsx:99
msgid "The work has been updated with success."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/index.tsx:120
msgid "Theme"
msgstr ""

#: app/routes/onboarding+/subscription+/enterprise/index.tsx:21
#: app/routes/onboarding+/subscription+/index.tsx:195
msgid "There is a plan for every creator."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:204
msgid "There is no track in this collection yet."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:245
msgid "This allows us to collect your copyright royalties on streaming platforms."
msgstr ""

#: app/routes/_app+/licensing+/components/License.tsx:100
msgid "This allows Winamp visitors to use your track for personal use, as well as to share it provided you are credited. Your music cannot be used by anyone else for commercial gain, and cannot be modified, unless you enable those options above."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:328
msgid "This artist already has music live in stores"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/index.tsx:118
msgid "This audio will be removed from it's tier in the fanzone."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:235
#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:157
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:224
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:328
msgid "this collaborator"
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/artists+/$artistId+/roles.tsx:63
msgid "This collaborator has been revoked access to the given artist."
msgstr ""

#: app/routes/account+/admin+/collaborators+/$id+/labels+/$labelId+/roles.tsx:63
msgid "This collaborator has been revoked access to the given label."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionPushToServiceBulk/index.tsx:324
msgid "This collection is already in use in this service."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:216
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:407
msgid "This collection is currently used in one of our services and therefore cannot be altered."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/components/ItemsList.tsx:213
#: app/routes/_app+/media_+/collections+/$id+/update.tsx:404
msgid "This collection is not editable."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/index.tsx:124
msgid "This collection will be removed from it's tier in the fanzone."
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:382
msgid "This description is used as the subtitle for your release."
msgstr ""

#: app/routes/account+/producers+/DialogNewProducer.tsx:146
msgid "This email will be used to notify your contact that you have added them as a producer."
msgstr ""

#: app/routes/account+/contacts+/components/DialogNewContributor.tsx:303
msgid "This email will be used to notify your contact that you have added them as an artist."
msgstr ""

#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:32
#: app/routes/_app+/licensing+/form/use-edit-licensing-form.tsx:33
msgid "This field is required."
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:171
msgid "This is your net price. You will receive approximately 90% of this amount. Your sales price will be automatically adjusted to accommodate VAT and fees, so you don't need to worry about it."
msgstr ""

#: app/routes/account+/admin+/labels+/$labelId+/index.tsx:274
msgid "This label could not be found."
msgstr ""

#: app/components/KycGdprDialog.tsx:64
msgid "This practice is in strict compliance with the General Data Protection Regulation (GDPR) principles of data minimization and purpose limitation."
msgstr ""

#: app/components/TitleBeautifier.tsx:171
msgid "This tool will help you verify that the title you entered fits DSP guidelines. If it doesn't, it will suggest a new title."
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioPushToServiceBulk/index.tsx:378
#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:220
msgid "This tracks is already in use in this service."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:348
msgid "This user does not belong to this artist's label yet. If you assign the permissions, an email invitation will be sent to {0}."
msgstr ""

#: app/components/FieldDirtyWarning.tsx:25
msgid "This value will be applied to all selected tracks."
msgstr ""

#: app/routes/account+/index.tsx:389
msgid "Thumbnail for the Getting Started video"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/subscribers.tsx:242
msgid "Tiers"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:276
msgid "Tiktok"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:41
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:42
msgid "TikTok comments must be 150 characters or less."
msgstr ""

#: app/modules/posts/validate.ts:164
msgid "Tiktok posts cannot exceed 2200 characters."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:589
msgid "Time"
msgstr ""

#: app/modules/route-dialogs/dialogs/GlobalPreferencesEdit/index.tsx:171
#: app/routes/account+/my-account+/global-preferences+/index.tsx:108
msgid "Time zone"
msgstr ""

#: app/modules/route-dialogs/dialogs/RevshareRuleExtend/index.tsx:256
#: app/routes/account+/finance+/revenue-share+/$id+/index.tsx:215
#: app/routes/account+/finance+/revenue-share+/index.tsx:273
#: app/routes/account+/finance+/revenue-share+/index.tsx:323
msgid "Timeframe"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:280
msgid "Timelapse between a subscription and unsubscription of a fan"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/TippingCard.tsx:16
msgid "Tipping"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:140
#: app/routes/_app+/collectibles+/components/Listing.tsx:258
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:80
#: app/routes/_app+/fanzone+/audios+/components/MembershipAudios.tsx:75
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:71
#: app/routes/_app+/licensing+/components/Listing.tsx:135
#: app/routes/_app+/licensing+/components/Listing.tsx:191
#: app/routes/_app+/media+/audios+/index.tsx:241
#: app/routes/_app+/media+/audios+/index.tsx:378
#: app/routes/_app+/media+/index.tsx:235
#: app/routes/_app+/media+/index.tsx:373
#: app/routes/_app+/rights+/components/Listing.tsx:129
#: app/routes/_app+/rights+/components/Listing.tsx:187
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:132
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:171
msgid "Title"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:810
msgid "Title color"
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:211
msgid "To collect all royalties and other sums derived directly or indirectly from the exercise of the Rights and arising from the aforementioned licenses;"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:184
msgid "To collect rights for this track you need to declare all contributors that have a right on the track."
msgstr ""

#: app/components/SubscriptionFeedback.tsx:39
msgid "To continue using all Winamp services, please select a subscription plan."
msgstr ""

#: app/components/SubscriptionFeedback.tsx:44
msgid "To continue using Winamp, please contact the admin of this artist’s account to proceed with the subscription."
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:153
msgid "To create a Winamp Original, you must start by connecting your Ethereum wallet. To do so you must have an Ethereum wallet installed on your browser. We recommend using <0>MetaMask</0>."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:163
msgid "To delete this artist type \"whip it\""
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:222
msgid "To determine my share of the royalties and to pay them to me in accordance with the distribution rules established by BRIDGER in the GTCS;"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:299
msgid "To pick your featured tracks, just create at least one and make it elligible for the Fanzone in the media workspace."
msgstr ""

#: app/routes/account+/index.tsx:211
msgid "To streamline the services, verify your identity here once and for all."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:242
msgid "To sub-license the Rights to any entity for the purpose of efficient royalty collection with respect to certain Rights and/or territories."
msgstr ""

#: app/routes/services+/components/BridgerMandate.tsx:233
msgid "To take any action to protect and defend my Rights;"
msgstr ""

#: app/components/CommandMenu.tsx:221
msgid "Toggle Dark Mode"
msgstr ""

#: app/routes/_app.tsx:422
msgid "Tools"
msgstr ""

#: app/components/CommandMenu.tsx:139
msgid "Tools > Grow your team"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:30
#: app/routes/_app+/tools+/marketing+/links+/index.tsx:158
#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:91
msgid "Tools to help you create a large audience"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/top-tracks.tsx:78
msgid "Top 5 streamed tracks"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:321
msgid "Top 5 Streamed Tracks"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:126
msgid "Top up"
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightForm.tsx:224
msgid "Total"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:252
msgid "Total of minutes listened through the Fanzone"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:266
msgid "Total of posts read through the Fanzone"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:238
msgid "Total of tracks played through the Fanzone"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/streams+/dsps.tsx:127
msgid "Total streams by dsp"
msgstr ""

#: app/routes/_app+/index/utils/widgets.tsx:334
msgid "Total Streams by DSP"
msgstr ""

#: app/routes/resources+/app+/widgets+/reporting+/components/TracksTable.tsx:49
msgid "Track"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:89
msgid "Track information"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:156
msgid "Track Information"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioOwnership.tsx:42
msgid "Track Ownership"
msgstr ""

#: app/components/CopyrightCheck.tsx:72
msgid "Track rejected"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:109
msgid "Track title"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:404
msgid "Track under “Some rights reserved” can be managed through our Licensing service"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:368
msgid "Troubleshooting"
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:206
#: app/routes/onboarding+/kyc/index.tsx:280
msgid "Try again"
msgstr ""

#: app/components/ErrorBoundary.tsx:120
#: app/components/ErrorBoundary.tsx:141
#: app/components/ErrorBoundary.tsx:172
msgid "Try again, or head back to a safe zone"
msgstr ""

#: app/routes/account+/index.tsx:423
msgid "Try our academy course"
msgstr ""

#: app/routes/account+/index.tsx:287
msgid "Turn your music into unique digital collectibles fans can buy and share. Monetize your work in just a few clicks, with no coding or copyright worries."
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:287
msgid "Twitter"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:634
msgid "Twitter comments may take longer to appear. Please allow up to {nextUpdateTwitter} for Twitter comments to appear."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:49
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:56
msgid "Twitter comments must be 280 characters or less."
msgstr ""

#: app/modules/posts/validate.ts:206
msgid "Twitter posts cannot exceed 280 characters."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:101
msgid "Two options: you can do it directly on the collaborator website or through your email box."
msgstr ""

#: app/components/CommandMenu.tsx:533
msgid "Type <0>#</0> for labels, <1>@</1> for artists, <2>></2> for pages and <3>?</3> for help."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:210
#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:221
msgid "Type of sharing"
msgstr ""

#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:293
msgid "Type your digital store profile URL"
msgstr ""

#: app/components/LinksField.tsx:63
msgid "Type your social media URLs"
msgstr ""

#: app/routes/_app.tsx:134
#: app/routes/_app.tsx:164
msgid "Unable to fetch the label."
msgstr ""

#: app/modules/route-dialogs/RouteDialogsContext.tsx:217
msgid "Unauthorized"
msgstr ""

#: app/components/KycGdprDialog.tsx:73
msgid "Under the GDPR, you have the right to:"
msgstr ""

#: app/components/FieldDirtyWarning.tsx:29
msgid "Undo"
msgstr ""

#: app/routes/resources+/app+/fanzone+/eligible-tracks.ts:21
#: app/routes/resources+/app+/fanzone+/eligible-tracks.ts:41
msgid "Unexpected error"
msgstr ""

#: app/routes/_app+/media+/components/MediaCallToAction.tsx:53
msgid "Unknown"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/components/SocialNetworkCard.tsx:149
msgid "Unlink"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:71
msgid "Unlock a new source of income with Winamp Original Collectibles"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:198
msgid "Unlock new services"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1084
msgid "Unpublish my page"
msgstr ""

#: app/routes/resources+/app+/widgets+/statistics+/fanzone+/subscribers.tsx:355
msgid "Unsubscribed"
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:172
msgid "UPC or EAN"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:179
msgid "UPC/EAN code"
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:299
msgid "Update \"{0}\""
msgstr ""

#: app/routes/_app+/media_+/collections+/$id+/update.tsx:434
msgid "Update collection"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/index.tsx:155
msgid "Update permissions for a user"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesEdit/index.tsx:164
msgid "Update permissions of {0}{1}"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:574
msgid "Update post"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/index.tsx:155
msgid "Update roles for a collaborator"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesEdit/index.tsx:164
msgid "Update roles of {0} for {1}"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:459
msgid "Update rule"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:241
#: app/modules/route-dialogs/dialogs/FanzoneProfileEdit/index.tsx:253
msgid "Update the fanzone profile"
msgstr ""

#: app/routes/_app+/rights+/components/Listing.tsx:284
msgid "Update this copyright"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostTierEdit/index.tsx:89
msgid "Update tier"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:454
msgid "Updating rule..."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzoneAudioTierEdit/index.tsx:87
#: app/modules/route-dialogs/dialogs/FanzoneCollectionTierEdit/index.tsx:87
msgid "Upgrade tier"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:63
#: app/routes/_app+/fanzone+/collections+/components/MembershipCollections.tsx:334
msgid "Upgrade to {0} only"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:380
msgid "Upload"
msgstr ""

#: app/routes/account+/index.tsx:242
msgid "Upload an unlimited number of tracks for free on all the major digital streaming platforms (Spotify, Apple Music, etc.) and collect 100% of your master royalties."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:643
msgid "Upload Image"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:345
msgid "Upload media"
msgstr ""

#: app/components/AvatarUpload.tsx:75
#: app/components/FileUpload.tsx:56
#: app/components/ImageUpload.tsx:104
#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:73
msgid "Upload rejected."
msgstr ""

#: app/routes/_app+/media+/components/Uploads.tsx:37
msgid "Uploading {0} media"
msgstr ""

#: app/routes/_app+/media+/components/Uploads.tsx:142
msgid "Uploading..."
msgstr ""

#: app/modules/links/LinksLibraryCreateDialog.tsx:146
#: app/modules/links/LinksLibraryEditDialog.tsx:141
#: app/modules/route-dialogs/dialogs/ArtistLinksLibrary/index.tsx:180
msgid "URL"
msgstr ""

#: app/components/CommandMenu.tsx:505
msgid "Use this tool to quickly search for artists and labels across our entire platform. You can also use the search modifiers found in the footer below to limit the results to just artists or labels."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:184
msgid "Use Winamp for Creators"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:201
msgid "Use your llamacoins to access additional services."
msgstr ""

#: app/routes/account+/index.tsx:417
msgid "Useful links"
msgstr ""

#: app/routes/_app+/licensing+/components/LicensingForm.tsx:466
msgid "Validate"
msgstr ""

#: app/components/KycBadge.tsx:68
msgid "Verified"
msgstr ""

#: app/components/KYCFeedback.tsx:83
msgid "Verify now"
msgstr ""

#: app/components/KYCFeedback.tsx:148
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:152
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:174
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:195
#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:213
#: app/routes/account+/index.tsx:208
#: app/routes/onboarding+/kyc/index.tsx:232
msgid "Verify your identity"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/route.tsx:117
msgid "Verify your identity & publish to the Fanzone"
msgstr ""

#: app/components/ServiceLinkButton.tsx:69
#: app/components/ServiceSubmitButton.tsx:127
msgid "Verify your identity & submit"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:159
msgid "Version"
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:114
msgid "Videos"
msgstr ""

#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:47
msgid "Videos from feed"
msgstr ""

#: app/modules/posts/helpers.server.ts:122
msgid "Videos uploaded to {platform} cannot be shorter than {0}."
msgstr ""

#: app/modules/posts/helpers.server.ts:81
#: app/modules/posts/helpers.server.ts:109
msgid "Videos uploaded to {platform} cannot exceed {0}."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:50
msgid "View all"
msgstr ""

#: app/routes/_app+/media+/collections+/index.tsx:280
#: app/routes/account+/admin+/artists+/components/ArtistsActions.tsx:32
msgid "View details"
msgstr ""

#: app/routes/account+/admin+/artists+/components/ArtistsActions.tsx:55
msgid "View label"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/AboutCard.tsx:50
#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:165
#: app/routes/resources+/app+/widgets+/reporting+/components/TracksTable.tsx:161
msgid "View less"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:233
msgid "View listing on Rarible"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/AboutCard.tsx:52
#: app/routes/resources+/app+/widgets+/reporting+/components/DspsTable.tsx:165
#: app/routes/resources+/app+/widgets+/reporting+/components/TracksTable.tsx:161
msgid "View more"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:337
msgid "View more comments"
msgstr ""

#: app/routes/_app+/collectibles+/components/Listing.tsx:401
msgid "View on Rarible"
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:192
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:357
#: app/routes/_app+/fanzone+/images+/components/FeedImages.tsx:93
#: app/routes/_app+/fanzone+/videos+/components/FeedVideos.tsx:149
msgid "View post"
msgstr ""

#: app/routes/account+/admin+/collaborators+/components/CollaboratorsActions.tsx:33
msgid "View Profile"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/index.tsx:342
msgid "View Rule"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:361
msgid "View stats"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:263
#: app/routes/_app+/media_+/audios+/$id+/components/AudioInformation.tsx:268
msgid "Vocal performance"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:314
#: app/routes/account.tsx:212
#: app/routes/account+/finance+/wallet+/index.tsx:85
msgid "Wallet"
msgstr ""

#: app/routes/account+/finance+/wallet+/index.tsx:33
msgid "Wallet - Winamp for Creators"
msgstr ""

#: app/modules/route-dialogs/dialogs/ProfileWallet/index.tsx:186
msgid "Wallet Address"
msgstr ""

#: app/components/WalletFeedback.tsx:41
msgid "Wallet connection and identity verification"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:180
msgid "Want to transfer your catalog to Winamp for Creators?"
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:185
msgid "Warning"
msgstr ""

#: app/routes/account+/index.tsx:379
msgid "Watch 3 minutes overview"
msgstr ""

#: app/routes/_app+/media+/components/MediaDropzonePlaceholder.tsx:48
msgid "We accept WAV, PCM, MP3 and AAC formats but recommend FLAC files for better quality."
msgstr ""

#: app/components/KycGdprDialog.tsx:55
msgid "We are dedicated to safeguarding your privacy and managing your data with the highest level of care. Please be informed that we do not store any images or biometric data, including photographs of identification documents. Only your legal name is retained, exclusively for verification purposes."
msgstr ""

#: app/routes/onboarding+/subscription+/success/index.tsx:51
msgid "We could not find any subscriptions."
msgstr ""

#: app/routes/onboarding+/subscription+/success/index.tsx:42
#: app/routes/subscription.status.ts:25
#: app/routes/subscription.tsx:198
msgid "We could not load the subscriptions. Please try again later."
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesCreate/index.tsx:378
msgid "We couldn't find any artist to assign roles to. You can create one by clicking the button below."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionAppend/index.tsx:296
#: app/routes/_app+/fanzone+/feed+/posts+/components/MediaUploads.tsx:313
msgid "We couldn't find any audios matching your search"
msgstr ""

#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesCreate/index.tsx:356
msgid "We couldn't find any label to assign permissions to. You can create one by clicking the button below."
msgstr ""

#: app/components/CommandMenu.tsx:525
msgid "We couldn’t find anything with that term. Please try again."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/AudioOwnership.tsx:68
msgid "We currently do not offer services for “Cover” or “Remix” versions of tracks by other artists."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:83
msgid "We hunt down and monetize videos that are using your music content without your permission on YouTube."
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:251
msgid "We pay you the money generated every time your track is used."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:259
msgid "We'll take it from here and will start collecting your copyright royalties."
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:113
msgid "We're currently unable to process payments for multiple artists at the same time. For this reason, you'll be redirected to the payment page for a single artist."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/components/DropdownActions.tsx:98
#: app/routes/_app+/fanzone+/audios+/components/FeedAudios.tsx:408
msgid "We're preparing your download. Please wait for a few seconds."
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:71
msgid "Website Builder"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:255
msgid "Weekly"
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingLabelComplete/index.tsx:19
msgid "Welcome to your account management area, where you can oversee your earnings, revenue shares, collaborators, artists, etc.<0/><1/>To manage a specific artist, head over to their workspace—you'll find everything you need to handle distribution, copyright, licensing, Youtune Content ID, collectibles and Fanzone."
msgstr ""

#: app/routes/_app+/index/route.tsx:309
msgid "Well done, this new overview is awesome!"
msgstr ""

#: app/routes/_app+/collectibles+/components/CollectibleForm.tsx:229
msgid "What are the perks of owning this NTF?"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:143
#: app/routes/_app+/collectibles+/components/Marketing.tsx:155
msgid "What are Winamp Original Collectibles?"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:102
msgid "What is a token?"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:167
msgid "What is an NFT?"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:138
msgid "What licenses are included?"
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:169
msgid "What media formats can I upload?"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:142
msgid "What royalties does Bridger collect?"
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:113
msgid "What's the difference between \"Llamacoin\", \"llama coins\", and \"$llama tokens\"?"
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:169
msgid "When and how often will I receive my earnings?"
msgstr ""

#: app/modules/posts/validate.ts:48
msgid "When posting to Facebook, you cannot include both images and videos."
msgstr ""

#: app/modules/posts/validate.ts:109
msgid "When posting to Instagram you must include an image or video."
msgstr ""

#: app/modules/posts/validate.ts:168
msgid "When posting to Tiktok you must include a video."
msgstr ""

#: app/modules/posts/validate.ts:251
msgid "When posting to Youtube you must include a video."
msgstr ""

#: app/routes/_app+/fanzone+/route.tsx:75
msgid "Where you share with your fans"
msgstr ""

#: app/routes/onboarding+/subscription+/components/ArtistsSelectionDialog.tsx:109
msgid "Which artists should be subscribed?"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:153
msgid "Which tracks are eligible?"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistDelete/index.tsx:166
msgid "whip it"
msgstr ""

#: app/routes/_app+/media+/components/CollectionsPlaceholder.tsx:27
msgid "Why create a collection?"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:158
msgid "Why should I use YouTube Content ID?"
msgstr ""

#: app/routes/_app+/index/route.tsx:80
msgid "Widgets updated"
msgstr ""

#: app/routes/_app.tsx:458
msgid "Winamp Academy"
msgstr ""

#: app/routes/_app+/tools+/marketing+/index.tsx:44
#: app/routes/_app+/tools+/marketing+/links+/index.tsx:197
msgid "Winamp links page"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:40
msgid "Winamp Links page - Marketing Tools - Winamp for Creators"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:146
#: app/routes/_app+/collectibles+/components/Marketing.tsx:158
msgid "Winamp Original Collectibles are unique NFTs that offer the purest representation of your music, untouched by normalization, equalization, or compression."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/index.tsx:131
msgid "Winamp terms of services and privacy policy"
msgstr ""

#: app/routes/_app+/licensing+/components/Marketing.tsx:171
msgid "With Licensing, artists can earn between 30% to 75% of their total sales revenue, depending on various factors such as the number of licenses sold. Winamp takes a commission, and processing fees are deducted, but the majority of the earnings go to the artist."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:161
msgid "With YouTube Content ID, you can monetize videos that use your music and in which ads are broadcast or displayed.<0/>You'll also be able to gain an overview of who uses your music and how. This is more interesting than simple revenue generation: the reports that you receive include all information that has been identified by YouTube Content ID, allowing you to easily understand the type of videos in which your music is used."
msgstr ""

#: app/routes/_app+/rights+/new.tsx:119
msgid "Work created!"
msgstr ""

#: app/routes/_app+/rights+/$id+/index.tsx:98
msgid "Work updated!"
msgstr ""

#: app/routes/account+/admin+/collaborators+/index.tsx:115
msgid "Working as a team?"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollaboratorCreate/index.tsx:133
msgid "Working in a team?"
msgstr ""

#: app/routes/account+/admin+/labels+/index.tsx:86
msgid "Would you like to expand and manage more than one artist?"
msgstr ""

#: app/routes/onboarding+/subscription+/components/SubscriptionPlan.tsx:78
#: app/routes/onboarding+/subscription+/success/index.tsx:78
msgid "year"
msgstr ""

#: app/routes/_app+/rights+/components/Listing.tsx:172
#: app/routes/_app+/rights+/components/Listing.tsx:189
msgid "Year"
msgstr ""

#: app/routes/account+/finance+/revenue-share+/components/Form.tsx:264
msgid "Yearly"
msgstr ""

#: app/routes/account+/finance+/plans-and-billing+/index.tsx:137
msgid "Yearly subscription"
msgstr ""

#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:308
#: app/modules/route-dialogs/dialogs/ServiceActivateRights/index.tsx:401
#: app/routes/_app+/licensing+/components/LicensingForm.tsx:264
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:194
#: app/routes/onboarding+/components/ArtistCreateFieldset.tsx:254
msgid "Yes"
msgstr ""

#: app/modules/route-dialogs/dialogs/AudioDelete/index.tsx:120
#: app/modules/route-dialogs/dialogs/CollectionDelete/index.tsx:114
#: app/modules/route-dialogs/dialogs/FanzoneAudioDelete/index.tsx:143
#: app/modules/route-dialogs/dialogs/FanzoneCollectionDelete/index.tsx:149
#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:226
#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:225
msgid "Yes, delete"
msgstr ""

#: app/modules/links/LinksLibraryDeleteDialog.tsx:126
msgid "Yes, Delete"
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectionEntryDelete/index.tsx:120
msgid "Yes, remove"
msgstr ""

#: app/modules/route-dialogs/dialogs/ArtistCollaboratorRolesRevoke/index.tsx:188
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/config.tsx:218
#: app/modules/route-dialogs/dialogs/LabelCollaboratorRolesRevoke/index.tsx:199
#: app/routes/account+/admin+/labels+/$labelId+/collaborators+/$collaboratorId+/delete.tsx:256
msgid "Yes, revoke"
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:187
msgid "Yes, the marketplace shall pay you as Creator your revenue share of 90% for primary sales and 12.5% for secondary sales (royalties). The revenue share is always paid using the same cryptocurrency as for sales."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:112
msgid "Yes, there is no limit regarding the number of positions you can create."
msgstr ""

#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:107
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:142
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:171
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:200
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:229
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:258
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:287
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:322
msgid "You accepted the terms & conditions for this service."
msgstr ""

#: app/routes/_app+/media+/components/MediaDropzonePlaceholder.tsx:65
msgid "You are not allowed to upload media files for this artist."
msgstr ""

#: app/modules/route-dialogs/RouteDialogsContext.tsx:220
msgid "You are not authorized to access this page."
msgstr ""

#: app/routes/account+/finance+/revenue-share+/index.tsx:151
msgid "You are not authorized to create revenue share rules."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:214
msgid "You can also convert your llamacoins into $llama tokens."
msgstr ""

#: app/routes/_app+/distribution+/components/Marketing.tsx:185
msgid "You can easily transfer all your music. Just re-distribute your tracks with us, wait 72 hours, and remove them from your previous distribution platform."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:37
msgid "You can only upload {0} files at a time."
msgstr ""

#: app/modules/posts/validate.ts:65
msgid "You can only upload 1 video to Facebook."
msgstr ""

#: app/modules/posts/validate.ts:172
msgid "You can only upload 1 video to Tiktok."
msgstr ""

#: app/modules/posts/validate.ts:255
msgid "You can only upload 1 video to Youtube."
msgstr ""

#: app/modules/posts/validate.ts:53
msgid "You can only upload 10 images to Facebook."
msgstr ""

#: app/modules/posts/validate.ts:210
msgid "You can only upload 4 images to Twitter."
msgstr ""

#: app/modules/posts/validate.ts:222
msgid "You can only upload 4 videos to Twitter."
msgstr ""

#: app/modules/media/get-dropzone-error-messages.ts:38
msgid "You can only upload one file at a time."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/components/StreamingServices.tsx:60
msgid "You can prefill your metadata thanks to the Spotify or Deezer track URL. <0>Where to find it?</0> <1/>Can be useful for Copyright."
msgstr ""

#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:134
msgid "You can select tracks from your media library to collect rights."
msgstr ""

#: app/routes/_app+/rights+/components/Marketing.tsx:114
msgid "You can select tracks from your media library."
msgstr ""

#: app/routes/_app+/media_+/audios+/$id+/route.tsx:177
msgid "You cannot edit this audio because your track was marked as “Copyright Check” after review, as it appears to already exist."
msgstr ""

#: app/modules/posts/validate.ts:176
msgid "You cannot upload images to Tiktok."
msgstr ""

#: app/modules/posts/validate.ts:259
msgid "You cannot upload images to Youtube."
msgstr ""

#: app/modules/permissions/helpers.server.ts:30
msgid "You do not have permission to access this page"
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/components/LinksForm.tsx:1025
msgid "You don't have any links in your page."
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:148
msgid "You don't have any links matching your search \"{search}\""
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:116
msgid "You don't have any links yet. Start by creating a new link."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:75
msgid "You don't have any Llamacoin yet"
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:133
msgid "You don't have the right permissions to activate the social media manager. Please contact the admin of this artist's account to proceed with the subscription."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:211
msgid "You don't have the right permissions to activate the Winamp links. Please contact the admin of this artist's account to proceed with the subscription."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:187
msgid "You earn Llamacoin by using the various platform services and tools."
msgstr ""

#: app/modules/route-dialogs/dialogs/RightsCreate/index.tsx:156
msgid "You gotta whip up a track in your media first to collect rights from here."
msgstr ""

#: app/modules/route-dialogs/dialogs/DistributionCreate/config.tsx:195
#: app/modules/route-dialogs/dialogs/DistributionCreate/index.tsx:178
msgid "You gotta whip up a track in your media first to distribute it from here."
msgstr ""

#: app/modules/route-dialogs/dialogs/LicensingCreate/index.tsx:157
msgid "You gotta whip up a track in your media first to license it from here."
msgstr ""

#: app/modules/route-dialogs/dialogs/CollectibleCreate/index.tsx:139
msgid "You gotta whip up a track in your media first to mint it from here."
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreate/index.tsx:165
msgid "You gotta whip up a track in your media first to monetize it from here."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:58
msgid "You have {0} Llamacoin"
msgstr ""

#: app/components/KYCFeedback.tsx:102
msgid "You have access to all services."
msgstr ""

#: app/routes/account+/finance+/llamacoin+/components/Marketing.tsx:131
msgid "You have nothing to do because all creators are already opted-in."
msgstr ""

#: app/routes/account+/messages+/index.tsx:37
msgid "You have read all of your messages! 🎉"
msgstr ""

#: app/routes/auth.invitations.$invitation.accept.tsx:52
msgid "You have successfully joined the label."
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:64
msgid "You must agree to the statements above to proceed."
msgstr ""

#: app/routes/_app+/rights+/$id+/form/work-candidate-schema.ts:48
msgid "You must confirm that you have the rights to distribute this track."
msgstr ""

#: app/routes/_app+/fanzone+/memberships+/$id+/delete.tsx:42
msgid "You must confirm the action."
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/collaborators+/index.tsx:45
msgid "You must invite at least one collaborator"
msgstr ""

#: app/routes/onboarding+/subscription+/success/index.tsx:23
msgid "You must onboard an artist before you can subscribe."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:147
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:150
msgid "You must provide a title when posting to Youtube."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:84
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:100
msgid "You must provide an audio ID."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:83
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:99
msgid "You must provide an order for the audio."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:29
msgid "You must provide an order for the file."
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:82
msgid "You must provide at least one distribution link."
msgstr ""

#: app/routes/_app+/fanzone+/audios+/create.tsx:23
msgid "You must select at least one audio."
msgstr ""

#: app/routes/_app+/fanzone+/collections+/create.tsx:23
#: app/routes/_app+/media+/collections+/append.tsx:23
msgid "You must select at least one collection."
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:43
#: app/routes/_app+/youtube-content-id+/new.tsx:55
msgid "You must select at least one track."
msgstr ""

#: app/routes/account+/admin+/artists+/index.tsx:111
msgid "You need an artist profile to access all the platform's services."
msgstr ""

#: app/components/SocialMediaCheckbox.tsx:63
msgid "You need to connect your account to post to {socialMedia}."
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:73
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/edit.tsx:74
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:79
#: app/routes/_app+/fanzone+/feed+/posts+/create.tsx:80
msgid "You need to provide some content for the post."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:189
msgid "You will need to delete the post manually in {0} because it doesn't allow posts to be deleted automatically."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostDelete/index.tsx:190
msgid "You will need to delete the post manually in {0} because they don't allow posts to be deleted automatically."
msgstr ""

#: app/routes/_app+/rights+/$id+/components/CopyrightConsents.tsx:46
msgid "You will receive an email once your track is approved. If you have declared one or more collaborators, we recommend you to let them know they will receive an email from us."
msgstr ""

#: app/routes/_app+/tools+/grow-your-team+/index.tsx:60
msgid "You'll need to create a new account. We recommend using the same email address as for your Winamp for Creators account."
msgstr ""

#: app/routes/_app+/collectibles+/components/Marketing.tsx:258
msgid "You'll receive money from the first sale and secondary sales."
msgstr ""

#: app/components/ErrorBoundary.tsx:86
msgid "You're not allowed to access this page."
msgstr ""

#: app/components/ErrorBoundary.tsx:73
msgid "You're not authorized to access this page."
msgstr ""

#: app/routes/onboarding+/index.tsx:38
msgid "Your account has been created"
msgstr ""

#: app/routes/onboarding+/labels+/$labelId+/artists/index.tsx:119
msgid "Your account has been set up successfully"
msgstr ""

#: app/routes/onboarding+/artists/index.tsx:183
msgid "Your artist has been created successfully"
msgstr ""

#: app/components/ActiveEntityDropdown.tsx:90
#: app/components/UserMenu.tsx:47
#: app/components/UserMenu.tsx:76
#: app/routes/account+/my-account+/legal-documentation+/index.tsx:120
msgid "Your avatar"
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:250
msgid "Your banner could not be updated. Please try again later."
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:260
msgid "Your banner has been updated."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:626
msgid "Your comment is being distributed across the selected networks. This will take {nextUpdate}, after which the comment will be visible here."
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCommentsEdit/index.tsx:205
msgid "Your comment will be shared on all social media platforms where this post appears. To reply directly to a specific comment, please visit the social media platform and respond there."
msgstr ""

#: app/routes/_app+/fanzone+/components/FanzoneHeader.tsx:316
msgid "Your Fanzone Banner"
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:70
msgid "Your featured tracks could not be updated. Please try again later."
msgstr ""

#: app/routes/_app+/fanzone+/components/SideCards/FeaturedTracksCard.tsx:78
msgid "Your featured tracks have been updated."
msgstr ""

#: app/components/KYCFeedback.tsx:99
msgid "Your identity has been verified"
msgstr ""

#: app/modules/route-dialogs/dialogs/KYCStart/index.tsx:155
#: app/routes/onboarding+/kyc/index.tsx:165
msgid "Your identity is being verified. The verification process can take up to 7 working days. You will receive an email once the verification is complete."
msgstr ""

#: app/routes/onboarding+/kyc/index.tsx:189
msgid "Your identity verification has been canceled."
msgstr ""

#: app/components/KYCFeedback.tsx:151
msgid "Your identity verification has been declined. Please contact the support to unlock this situation."
msgstr ""

#: app/components/KYCFeedback.tsx:118
msgid "Your identity verification is pending"
msgstr ""

#: app/routes/onboarding+/labels+/index.tsx:234
msgid "Your label"
msgstr ""

#: app/modules/route-dialogs/dialogs/OnboardingLabelComplete/index.tsx:15
msgid "Your label has been created"
msgstr ""

#: app/modules/links/LinksLibraryDialog.tsx:97
msgid "Your links library is where you manage all the links you use through Winamp for Creators. It makes it easy to reuse the same links in the Fanzone or in Winamp.link."
msgstr ""

#: app/routes/_app+/tools+/marketing+/links+/index.tsx:106
msgid "Your page has been saved."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:34
#: app/routes/account+/my-account+/global-preferences+/theme+/edit.tsx:33
msgid "Your preferences could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/account+/my-account+/global-preferences+/edit.tsx:69
msgid "Your Preferences have been updated successfully."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/edit.tsx:48
msgid "Your profile could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/_app+/fanzone+/profile+/edit.tsx:100
#: app/routes/account+/my-account+/personal-info+/edit.tsx:77
#: app/routes/account+/my-account+/personal-info+/wallet.tsx:59
msgid "Your profile has been updated successfully."
msgstr ""

#: app/routes/_app+/distribution+/components/ReleaseForm.tsx:105
msgid "Your release may not show up in stores until {0} due to stores delivery times."
msgstr ""

#: app/routes/subscription.tsx:225
msgid "Your subscription plan has been enabled. Many thanks for joining us!"
msgstr ""

#: app/components/CopyrightCheck.tsx:108
msgid "Your track was flagged as Copyright Check because it seems to already exist. Please, contact support if you'd need to challenge that decision."
msgstr ""

#: app/routes/account+/my-account+/personal-info+/wallet.tsx:30
msgid "Your wallet address could not be updated. Please check the form and try again."
msgstr ""

#: app/routes/_app+/index/route.tsx:81
msgid "Your widgets have been updated successfully."
msgstr ""

#: app/routes/_app+/tools+/marketing+/social-media-manager+/index.tsx:298
msgid "Youtube"
msgstr ""

#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/edit.ts:76
#: app/routes/_app+/fanzone+/feed+/posts+/$id+/comments+/reply.ts:83
msgid "Youtube comments must be 10000 characters or less."
msgstr ""

#: app/routes/_app+/youtube-content-id+/new.tsx:241
msgid "Youtube Content Id"
msgstr ""

#: app/components/CommandMenu.tsx:113
#: app/routes/_app+/media+/audios+/index.tsx:650
#: app/routes/_app+/media+/index.tsx:647
#: app/routes/_app+/youtube-content-id+/components/Listing.tsx:69
msgid "Youtube Content ID"
msgstr ""

#: app/routes/_app.tsx:387
#: app/routes/_app+/media_+/audios+/$id+/components/ServicesFilter.tsx:61
#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:71
#: app/routes/account+/my-account+/legal-documentation+/components/TOSByService.tsx:220
msgid "YouTube Content ID"
msgstr ""

#: app/routes/_app+/youtube-content-id+/index.tsx:12
msgid "YouTube Content ID - Winamp for Creators"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:76
msgid "Youtube Content ID Illustration"
msgstr ""

#: app/routes/_app+/youtube-content-id+/components/Marketing.tsx:179
msgid "YouTube Content ID revenues are hard to predict. Potential earnings depend on many factors, including, but not limited to, the virality of the videos."
msgstr ""

#: app/modules/route-dialogs/dialogs/ContentIDCreateBulk/index.tsx:157
#: app/routes/_app+/youtube-content-id+/new.tsx:273
msgid "Youtube Monetisation Program"
msgstr ""

#: app/modules/route-dialogs/dialogs/FanzonePostCreate/index.tsx:359
#: app/modules/route-dialogs/dialogs/FanzonePostEdit/index.tsx:411
msgid "Youtube video title"
msgstr ""
